module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("1 and 2 Thessalonians")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT",
    attrs: {
      "id": "ch001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch001"
    }
  }, [_vm._v("Commentary on 1 Thessalonians")])]), _vm._v(" "), _c('p', {
    staticClass: "h1top",
    attrs: {
      "id": "s01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s01"
    }
  }, [_vm._v("1:1"), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Letter’s Prescript")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_vm._v("Paul, Silas, and Timothy: to the church of the Thessalonians assembled by/in God the Father and the Lord Jesus Christ. Grace to you all and peace.")]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("Both 1 and 2 Thessalonians begin with a standard, albeit modified,"), _c('a', {
    attrs: {
      "id": "fn1"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" epistolary prescript including the sender(s), addressees, and a greeting. Both letters come from Paul, Silvanus, and Timothy, with no further description of who they are. Throughout the commentary, I will assume that Paul is primarily responsible for the content of both letters as their actual author and speaks for the latter two, who are best described as cosenders."), _c('a', {
    attrs: {
      "id": "fn2"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Silvanus is the Latinized form of Silas, to whom we are introduced in Acts (15:27, 40), closely followed there by the introduction of Timothy (16:1). There Paul, Silas, and Timothy are depicted as being present at the founding of the church in Thessalonica (17:1–9),"), _c('a', {
    attrs: {
      "id": "fn3"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" which takes place on a journey in which they set out to deliver the admonitions of the so-called apostolic decree to the Gentiles "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("“who are turning ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐπιστρέφουσιν")]), _vm._v(", "), _c('i', [_vm._v("epistrephousin")]), _vm._v("] to God” (Acts 15:19), that is, the churches formed in the account in Acts 13–14 (16:4). Although not explicitly narrated in Acts, the implication is that they deliver these same commands to churches they form on that journey, like the ones in Philippi and Thessalonica. While the exact content and purpose of these admonitions remain debated, the general tenor of two of the commands remains consistent throughout (Acts 15:20; cf. 15:29; 21:25)—in particular, “to abstain ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀπέχεσθαι")]), _vm._v(", "), _c('i', [_vm._v("apechesthai")]), _vm._v("] from pollutions of idols ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εἰδώλων")]), _vm._v(", "), _c('i', [_vm._v("eidōlōn")]), _vm._v("]/food sacrificed to idols ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εἰδωλόθυτον")]), _vm._v(", "), _c('i', [_vm._v("eidōlothyton")]), _vm._v("] and sexual immorality ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("πορνείας")]), _vm._v(", "), _c('i', [_vm._v("porneias")]), _vm._v("].”")]), _c('a', {
    attrs: {
      "id": "fn4"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Such language resonates with Paul’s description of the Thessalonians, who “turned ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐπεστρέψατε")]), _vm._v(", "), _c('i', [_vm._v("epestrepsate")]), _vm._v("] from idols ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εἰδώλων")]), _vm._v(", "), _c('i', [_vm._v("eidōlōn")]), _vm._v("]” in 1:9, and his command in 4:3 “to abstain ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀπέχεσθαι")]), _vm._v(", "), _c('i', [_vm._v("apechesthai")]), _vm._v("] from sexual immorality ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("πορνείας")]), _vm._v(", "), _c('i', [_vm._v("porneias")]), _vm._v("].” Hence, in both Acts and 1 Thessalonians, Paul, Silas, and Timothy are associated with Gentile churches who have turned from idols to God, are commanded to avoid being polluted with the realm of idolatry, and are commanded to avoid sexual immorality. The avoidance of idolatry and sexual immorality, which is constituent of Israel’s response to their call to be a holy people, is also assumed of the (Gentile) church in both Acts and in 1 Thessalonians. In both places the church is to engage in “public practices that demonstrate purity, thereby bearing witness to the church’s faithfulness to Israel’s God.”"), _c('a', {
    attrs: {
      "id": "fn5"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This public engagement in practices demonstrating purity is consistent with the letter’s being addressed to the "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐκκλησία")]), _vm._v(" ("), _c('i', [_vm._v("ekklēsia,")]), _vm._v(" “church”) of the Thessalonians. The word "), _c('i', [_vm._v("ekklēsia")]), _vm._v(" is often used in the LXX in reference to the called and gathered people of Israel whom Yahweh had redeemed and from whom he demanded loyalty,"), _c('a', {
    attrs: {
      "id": "fn6"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" to be expressed in actions that bore witness to his character."), _c('a', {
    attrs: {
      "id": "fn7"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Hence, together with the language of “beloved by God” (v. 4), “election” (v. 4), and “calling” (2:12; 4:7; 5:24), the term "), _c('i', [_vm._v("ekklēsia")]), _vm._v(" connects this Gentile audience to the story of God’s dealings with Israel, marking them out as a redeemed, visible people whose public practices are to make clear the character of Israel’s God. In the larger Greco-Roman world, "), _c('i', [_vm._v("ekklēsia")]), _vm._v(" commonly referred to both informal (e.g., Acts 19:32) and formal public gatherings, e.g., the regular assembly of free males in a body gathered to conduct the political affairs of a Greco-Roman city (e.g., Acts 19:39)."), _c('a', {
    attrs: {
      "id": "fn8"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" The term therefore evokes theological and political imagery "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("from the Jewish and the Greco-Roman milieu, effectively describing the audience as a public body whose ultimate loyalty was due, not to the empire and its gods, but to one particular god, namely, the God of Israel. Such exclusive loyalty distinguishes this "), _c('i', [_vm._v("ekklēsia")]), _vm._v(" from any others in Thessalonica and calls attention to the audience’s vocation as public witness.")]), _c('a', {
    attrs: {
      "id": "fn9"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This point is underscored by the way Paul modifies the standard epistolary prescript by adding a description of his audience as being "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐν")]), _vm._v(" ("), _c('i', [_vm._v("en,")]), _vm._v(" “in, by”) God the Father and the Lord Jesus Christ. There are two main possibilities for understanding the force of the "), _c('i', [_vm._v("en")]), _vm._v(" in this phrase: (1) “in” or (2) “by.” Is Paul depicting the audience as in some way "), _c('i', [_vm._v("located in")]), _vm._v(" God and the Lord, Jesus Christ, or is he thinking of it as being "), _c('i', [_vm._v("established by")]), _vm._v(" God and Christ? It may not be necessary to make an either/or choice in this case. Given his further description of the audience as loved, elected (1:4), and called by God (2:12; 4:7; 5:24), Paul certainly understands this audience both here and in 2 Thess 1:1 as existing "), _c('i', [_vm._v("by means of")]), _vm._v(" the actions of God and Christ."), _c('a', {
    attrs: {
      "id": "fn10"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Taking into account that "), _c('i', [_vm._v("ekklēsia")]), _vm._v(" might have retained its verbal connotations of “being assembled,” one might, then, translate the "), _c('i', [_vm._v("en")]), _vm._v(" as “assembled by God the Father and the Lord Jesus Christ.”"), _c('a', {
    attrs: {
      "id": "fn11"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" On this understanding of "), _c('i', [_vm._v("en")]), _vm._v(" at the very beginning of the letter, Paul would be highlighting the divine action that brought this community into existence, distinguishing this "), _c('i', [_vm._v("ekklēsia")]), _vm._v(" from any others in Thessalonica"), _c('a', {
    attrs: {
      "id": "fn12"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" and thereby making everything that follows dependent on this "), _c('i', [_vm._v("priority of divine grace.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But translating "), _c('i', [_vm._v("en")]), _vm._v(" as “in” would be no less an affirmation that everything that follows in these letters would be dependent on the priority of divine grace. While Paul often speaks of believers as being “in Christ,” other than here and in 2 Thess 1:1, he does not use the language of persons being “in God” in a parallel way. However, he does use similar terminology in Col 3:3 to refer to his audience’s life being “hidden with Christ "), _c('i', [_vm._v("in God")]), _vm._v(" ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐν τῷ θεῷ")]), _vm._v(", "), _c('i', [_vm._v("en tō theō")]), _vm._v("].” Moreover, since the one "), _c('i', [_vm._v("en")]), _vm._v(" (in) is used in reference to both God the Father and the Lord Jesus Christ in Paul’s initial characterization of his audience, the fact that he uses the language of “in Christ” to initially characterize the audience of some of his other letters (e.g., 1 Cor 1:2; Phil 1:1; Col 1:2) makes it probable that this whole phrase in 1 Thess 1:1 is a variation of “in Christ.” Michael Gorman thus rightly argues that here in 1 Thess 1:1 Paul does not sharply distinguish between being “in Christ” and being “in God.”"), _c('a', {
    attrs: {
      "id": "fn13"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" In his words, “To be in Christ is to be in God and to be the ongoing recipient of God’s Holy Spirit (4:8); this is, in Paul’s earliest "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("letter, an indication of his experience of a trinitarian participatory holiness. Paul’s concern is inhabiting God—inhabiting the cruciform God.”")]), _c('a', {
    attrs: {
      "id": "fn14"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" This is the language of theosis, and as we will argue at various points in the commentary, it is appropriate for characterizing the soteriological process into which God has incorporated this ecclesial community."), _c('a', {
    attrs: {
      "id": "fn15"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul’s phraseology, then, underscores the priority of divine grace, "), _c('i', [_vm._v("by which")]), _vm._v(" the community is brought into existence "), _c('i', [_vm._v("in order to share in")]), _vm._v(" the life of the Triune God. But it is important to note at the outset that this God is “the God/Lord of peace” (1 Thess 5:23; 2 Thess 3:16), and so Paul extends not only grace to his audience but peace as well. Here he does not explicitly designate the source of either of these qualities as he does in 2 Thess 1:2 and elsewhere (e.g., Rom 1:7 et al.) as being “from God our Father and the Lord Jesus Christ,” but there can be no real question as to their origin. If everything in the letter presumes the priority of divine grace, it also assumes the presence and availability of divine peace, or shalom. For Paul, the divinely promised messianic peace has decisively begun with the death and resurrection of Jesus, although even a cursory read through Paul’s letters will reveal that it has not yet arrived in its fullness. Such peace is not simply “inner peace of mind,” as in some popular understandings. Rather, the shalom that has been divinely provided flows from God’s provision of saving justice ("), _c('i', [_vm._v("dikaiosynē")]), _vm._v("),"), _c('a', {
    attrs: {
      "id": "fn16"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" which restores and reconciles relationships between God and humans, as well as relationships between people who had been at odds with each other. This divine shalom, then, is a concrete social reality whose arrival is good news indeed. As we will see, a community that has been granted it will also be called upon, as a Spirit-inhabited community, to act as God’s channel of granting that shalom to others in Thessalonica."), _c('a', {
    attrs: {
      "id": "fn17"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("At the outset, these comments need more clarification with regard to the relationship between God (i.e., the Father, in Paul’s terminology) and the Lord Jesus Christ. The community owes its existence to the actions of both and inhabits both. At times in these letters, their actions can be clearly distinguished (e.g., 1:10), and at other times they are quite difficult to distinguish (e.g., 3:11; 2 Thess 2:16–17). There is, then, a kind of blurring of the lines between the "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("actions on behalf of the audience of God the Father and those of the Lord Jesus Christ. On the one hand, this situation bears some analogy—albeit with significant differences—to the way that the current emperor, even if not always conceived of as divine, was called lord ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("κύριος")]), _vm._v(", "), _c('i', [_vm._v("kyrios")]), _vm._v(") and was perceived to act on behalf of the gods as their special agent because the gods had shown favor to him,")]), _c('a', {
    attrs: {
      "id": "fn18"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" and through him to Rome. Hence, there could be a blurring of the lines between the actions of the emperor and the actions of the gods, between human action and divine action. Such a theological legitimation of the political situation had deep roots in the ancient world, and the resulting conceptual framework funded the demand for loyalty to the emperor, the various gods of Rome, and the polity over which the emperor was the head.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This framework was less problematic in a polytheistic Greco-Roman context than in the context of Judaism, with its concern for the unique identity of Israel’s God Yahweh, a context that Paul never abandoned. It is therefore significant that, in the opening of both epistles, Paul makes a close connection between God the Father and the "), _c('i', [_vm._v("Lord")]), _vm._v(" ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("κύριος")]), _vm._v(", "), _c('i', [_vm._v("kyrios")]), _vm._v("), Jesus Christ, whom 1:10 identifies as “his [God’s] son.” In most cases the LXX uses "), _c('i', [_vm._v("kyrios")]), _vm._v(" as a reverential circumlocution for Yahweh, a common practice among religious Greek-speaking Jews."), _c('a', {
    attrs: {
      "id": "fn19"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" The use of "), _c('i', [_vm._v("kyrios")]), _vm._v(" to refer to Jesus permeates not only Paul’s letters but also the entirety of the New Testament. While in some contexts it carries no divine connotations (e.g., Matt 15:27), other contexts use language from OT texts that originally refer to Yahweh and apply it directly to Jesus as "), _c('i', [_vm._v("kyrios")]), _vm._v(" (e.g., Rom 10:13; 1 Cor 1:8; 2 Cor 3:15–18; Acts 2:21, 36; Mark 1:2–3)."), _c('a', {
    attrs: {
      "id": "fn20"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" Such linguistic practice is all the more significant when one recognizes that the NT continues to use "), _c('i', [_vm._v("kyrios")]), _vm._v(" to refer to God as well (e.g., Rom 11:34; Mark 13:20; Luke 1:6). Hence, both God the Father and his Son, Jesus, share the divine name, or identity. The cumulative effect is to include Jesus as Lord in the unique identity of the one God of Israel in a way that makes the relationship between the Father and the Son constitutive of that God’s identity."), _c('a', {
    attrs: {
      "id": "fn21"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" As such, there is a theological legitimation of the new sociopolitical situation in which the Thessalonians "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("find themselves, somewhat analogous to that of the imperial Roman order. As members of an alternative polity, their loyalty could be to only one God, the God of Israel, whose identity included a Jew crucified by the empire, vindicated by God (the Father’s) raising him from the dead by means of the life-giving Spirit.")]), _c('a', {
    attrs: {
      "id": "fn22"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Only by means of this Spirit’s activity (1:6; cf. 1 Cor 12:3) were they able to confess this crucified and raised Jew, the Son of the Father, as Lord of the entire cosmos."), _c('a', {
    attrs: {
      "id": "fn23"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" Hence, the identity of the God whom the Thessalonians had encountered included the Father, the Son, and the Spirit and was constituted by the reciprocal relations between them.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "s02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s02"
    }
  }, [_vm._v("1:2–3:13"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Faith Working through Love, Resulting from Paul’s Faithful Ministry")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("As was typical of ancient letters, after the prescript Paul begins the letter with a thanksgiving section. In some letters it is easy to see where a thanksgiving section starts and stops (e.g., 1 Cor 1:4–9; Phil 1:3–11). But in 1 Thessalonians Paul mentions giving thanks to God regarding the audience again in 2:13 and 3:9 and never seems to make a clear break in the text until starting the petitionary prayer at 3:11. The effect is to make it unclear where any identifiable thanksgiving section stops and the body of the letter proper begins. Hence, various interpreters see the end of this section in different places (e.g., 1:10; 2:12 or 13; 3:10 or 13). The variety of attempts to address this issue utilizing both epistolary and rhetorical categories testifies to the difficulty, if not the impossibility, of arriving at a full consensus as to the letter’s structure."), _c('a', {
    attrs: {
      "id": "fn24"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" Such difficulty may suggest that Paul himself simply was not concerned with operating within the constraints of either formal epistolary or rhetorical categories in this letter. In any case, it is not clear that the continuing debate over such issues ultimately has much theological impact.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The following brief outline of the first major section of this letter will be sufficient for our purposes. We will assume that the letter’s first major section begins with a thanksgiving in 1:2–10, the body of the letter starts in 2:1–12, and the first major section ends with Paul’s petitionary prayer for the audience "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("in 3:13.")]), _c('a', {
    attrs: {
      "id": "fn25"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" In this first major section (1:2–3:13) Paul attempts to reinforce and shape the audience’s understanding of who they are and how they ought to conduct their life together by focusing on (1) the audience’s “faith working through love” as their thankful response to the gospel, and (2) the model of Christian living manifest in his own faithful ministry and concern for the audience. The focus of 1:2–10 is on Paul’s thanksgiving for what God has accomplished "), _c('i', [_vm._v("among and by")]), _vm._v(" the addressees. In these verses Paul gives thanks for the audience primarily because of God’s election of them (1:4), which is evident because of the way his gospel came ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐγενήθη")]), _vm._v(", "), _c('i', [_vm._v("egenēthē")]), _vm._v(") to them (v. 5) and because of what the audience themselves became ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐγενήθητε")]), _vm._v(", "), _c('i', [_vm._v("egenēthēte,")]), _vm._v(" vv. 6–7) as a result of their reception of this good news (vv. 6–10). Paul begins the body of the letter in 2:1–12 by enlarging on the way his gospel came to the audience, specifically in terms of the “sort of people” (1:5) Paul and his companions proved to be. He then moves back to focus on the audience in 2:13–16 with another thanksgiving for what the audience became as a result of their reception of the gospel.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In 2:17–3:10 Paul focuses on what has transpired in his relationship with the audience since he left Thessalonica, including his concern for their bearing up under persecution and Timothy’s good report regarding their faithfulness. The latter evokes another expression of thanks for the audience in 3:9–10 before Paul finishes off this first major section with a petionary prayer (3:11–13) that touches on important themes of the second major section of the letter, namely, holiness and eschatology.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "s03"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s03"
    }
  }, [_c('i', [_vm._v("1:2–10"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Thanksgiving for What God Has Done among and by the Thessalonians")])])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('sup', [_vm._v("2")]), _vm._v("We’re always giving thanks to God for all of you by making mention [of you]"), _c('a', {
    attrs: {
      "id": "fn26"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" in our prayers time and time again"), _c('a', {
    attrs: {
      "id": "fn27"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('sup', [_vm._v("3")]), _vm._v("because we remember your work engendered by faithfulness, your labor flowing from love, and your perseverance that results from your hope for the Lord, Jesus Christ, [to come] in the presence of our God and Father. "), _c('sup', [_vm._v("4")]), _vm._v("We offer this thanks, brothers and sisters"), _c('a', {
    attrs: {
      "id": "fn28"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" whom God loves, because "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("we know God’s election of you all. "), _c('sup', [_vm._v("5")]), _vm._v("We know this because our good news did not come to you in word only, but indeed with power; that is,")]), _c('a', {
    attrs: {
      "id": "fn29"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" it came empowered by the Holy Spirit and in a fully persuasive way—just as you know what sort of people we became among you for your sake. "), _c('sup', [_vm._v("6")]), _vm._v("And [we know that God has elected you all because]"), _c('a', {
    attrs: {
      "id": "fn30"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" you began imitating us and the Lord after you received the word in much tribulation with joy that came from the Holy Spirit. "), _c('sup', [_vm._v("7")]), _vm._v("The result of this [evidenced election] is that together you became a [singular] pattern"), _c('a', {
    attrs: {
      "id": "fn31"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" for all those who are exercising believing allegiance in Macedonia and Achaia. "), _c('sup', [_vm._v("8")]), _vm._v("For from you, the word about the Lord has rung out echoing in every direction, not only in Macedonia and Achaia, but in every place your faithfulness to God has gone forth, so that we do not need to say anything [about it]. "), _c('sup', [_vm._v("9")]), _vm._v("For they themselves are talking publicly about us, about the sort of first visit we had with you. That is,"), _c('a', {
    attrs: {
      "id": "fn32"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" [they are talking publicly about] how you turned to God from idols to be enslaved to the living and true God "), _c('sup', [_vm._v("10")]), _vm._v("and to await his Son from heaven, whom he raised from the dead, Jesus, who is rescuing ("), _c('i', [_vm._v("or")]), _vm._v(" is going to rescue) us from the coming wrath.")]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("Paul begins the section by giving his audience reasons"), _c('a', {
    attrs: {
      "id": "fn33"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" why he and his cosenders are always giving thanks to God for them. They are doing so, first, because they remember the audience’s work, labor, and perseverance (v. 3), and second, because they know that God has elected the audience (v. 4). Each reason deserves further comment.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The first reason (v. 3) that Paul and his companions are giving thanks for the audience is that they remember the Thessalonians’ work engendered by faithfulness ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("πίστεως")]), _vm._v(", "), _c('i', [_vm._v("pisteōs")]), _vm._v("), their labor flowing from love ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀγάπης")]), _vm._v(", "), _c('i', [_vm._v("agapēs")]), _vm._v("), and their perseverance resulting from hope ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐλπίδος")]), _vm._v(", "), _c('i', [_vm._v("elpidos")]), _vm._v("). Although there are other possibilities,"), _c('a', {
    attrs: {
      "id": "fn34"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" it makes the most sense to take the three genitive nouns (faithfulness, love, hope) as indicating the origin of the noun that precedes them."), _c('a', {
    attrs: {
      "id": "fn35"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" In any "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("case, the point is that the nouns before each genitive noun (work, labor, perseverance) derive from, and embody a particular form of, the noun that follows it.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("In Paul’s usage, there is little, if any, difference between “work” ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἔργον")]), _vm._v(", "), _c('i', [_vm._v("ergon")]), _vm._v(") and “labor” ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("κόπος")]), _vm._v(", "), _c('i', [_vm._v("kopos")]), _vm._v(").")]), _c('a', {
    attrs: {
      "id": "fn36"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" Both terms connote low-status activity, a pattern of life that is burdensome, requiring exertion and hardship. As we will see, in 1 and 2 Thessalonians such exertion and hardship is depicted as having a cruciform character, that is, as laborious activity connected with proclaiming and embodying the gospel for the sake of others."), _c('a', {
    attrs: {
      "id": "fn37"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" Hence, Paul initially depicts the audience as engaging in “work” and “labor,” just as he and his companions had done as the very means of proclaiming and embodying the good news (2:9–10)."), _c('a', {
    attrs: {
      "id": "fn38"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" This response constitutes an “imitation” of both Paul and the Lord (1:6, enlarged on in vv. 7–8) and portrays the audience right up front as engaging in a pattern of life in which they are participants in the "), _c('i', [_vm._v("missio Dei,")]), _vm._v(" the mission of God.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The first time we encounter the word "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("πίστις")]), _vm._v(" ("), _c('i', [_vm._v("pistis,")]), _vm._v(" “faithfulness, loyalty, faith, trust”) in 1 Thessalonians (v. 3), Paul is recalling this cruciform work of the audience that was engendered by their "), _c('i', [_vm._v("pistis")]), _vm._v(" (faithfulness, faith). For some this may seem odd, given the common claim that, for Paul (particularly the Paul of Galatians and Romans), work(s) is opposed to faith ("), _c('i', [_vm._v("pistis")]), _vm._v("). Such a view is only partly true at best and positively misleading at worst!"), _c('a', {
    attrs: {
      "id": "fn39"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" Part of the problem is that many translators and interpreters fail to acknowledge the larger field of meaning of "), _c('i', [_vm._v("pistis.")]), _vm._v(" While its semantic range includes belief and trust, in 1 and 2 Thessalonians Paul most often uses "), _c('i', [_vm._v("pistis")]), _vm._v(" in the sense of faithfulness or loyalty,"), _c('a', {
    attrs: {
      "id": "fn40"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("and its verbal cognate, "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("πιστεύω")]), _vm._v(" ("), _c('i', [_vm._v("pisteuō,")]), _vm._v(" “I trust, I believe, I am faithful”), in the sense of “exercising believing allegiance.”")]), _c('a', {
    attrs: {
      "id": "fn41"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Hence, "), _c('i', [_vm._v("pistis")]), _vm._v(" in these letters has in its very essence an element of fidelity and obedience. Michael Gorman’s words appropriately describe the way Paul uses "), _c('i', [_vm._v("pistis")]), _vm._v(" in these letters: “Faith is humanity’s appropriate posture before God. It is devotion, total commitment, faithfulness.”"), _c('a', {
    attrs: {
      "id": "fn42"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" The first thing, then, in the list causing Paul and his companions to give thanks is his audience’s work engendered by, or embodying, their faithfulness. That is, he gives thanks for their work that flows from, and embodies, their believing allegiance or total commitment to God the Father and the Lord Jesus Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Second, the audience’s labor flows from their love ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀγάπη")]), _vm._v(", "), _c('i', [_vm._v("agapē")]), _vm._v("), which means that their love is embodied by activities requiring exertion and hardship. The sort of love to which Paul is referring, then, is not simply an inner emotion “but a total disposition of one’s life that involves deliberate choices and determined effort.”"), _c('a', {
    attrs: {
      "id": "fn43"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" It is embodied in the kind of self-giving practices Paul narrates in 2:6–12, practices that exhibit a cruciform structure paralleling the actions of Christ in Phil 2:6–8."), _c('a', {
    attrs: {
      "id": "fn44"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Third, the audience’s perseverance is their capacity to endure suffering under extreme pressure (like Paul himself, as in 2 Cor 6:4; 12:12),"), _c('a', {
    attrs: {
      "id": "fn45"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" a capacity that is engendered by and embodies the hope they have for the royal coming ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("παρουσία")]), _vm._v(", "), _c('i', [_vm._v("parousia")]), _vm._v(") of the Lord Jesus Christ, as in 1:10, and the salvation it brings."), _c('a', {
    attrs: {
      "id": "fn46"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" It seems likely that “hope” has this specific content, given the way Paul uses the word elsewhere in 1 Thessalonians. In 5:8 the specific content of hope is “salvation,” which clearly takes place at the parousia, and in 2:19 and 4:13 “hope” appears with the parousia in view. As the translation indicates, this hope for the Lord’s royal coming is connected with and brings with it the very “presence of God our Father.”"), _c('a', {
    attrs: {
      "id": "fn47"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" And as I will argue later, we have at least "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("an implicit theological warrant for affirming the Spirit’s presence and activity in this royal coming, so that one ought to imagine the Son’s royal coming as a pneumatological—and thus, fully Trinitarian—event.")]), _c('a', {
    attrs: {
      "id": "fn48"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As attentive readers of Paul would have already noticed, prominent in these two verses is the familiar Pauline triad of faith(fulness) ("), _c('i', [_vm._v("pistis")]), _vm._v("), love ("), _c('i', [_vm._v("agapē")]), _vm._v("), and hope ("), _c('i', [_vm._v("elpis")]), _vm._v(") (e.g., 1 Cor 13:13; Gal 5:5–6; Col 1:4–5). This triad appears again in 5:8, where Paul depicts "), _c('i', [_vm._v("pistis")]), _vm._v(" and "), _c('i', [_vm._v("agapē")]), _vm._v(" as one singular “breastplate.” Hence, while faith(fulness) and love can indeed be distinguished, they cannot be separated. In fact, it is precisely the audience’s "), _c('i', [_vm._v("pistis")]), _vm._v(" and "), _c('i', [_vm._v("agapē")]), _vm._v(" that form the content of the good news that Timothy reports back to Paul in 3:6. The other defensive piece of armor in 5:8 is a helmet, which is explicated as the “"), _c('i', [_vm._v("hope")]), _vm._v(" for salvation,” a salvation that, according to the context, is clearly eschatological. Hence, at the beginning of this letter as well as toward the end, this audience is depicted as characterized by the Pauline triad of “faith(fulness), love, and hope.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("While it would be forced to argue that this triad actually structures the rest of the letter, it does give the audience a preview of the letter’s coming attractions. The audience’s faithfulness is clearly an issue and is positively referred to at various points throughout the letter (1:8; 2:10, 13; 3:1–8; 5:8), as is their love (3:6; 5:8). And in both 1:3 and 5:8, the audience has hope for the coming salvation connected with the Lord’s royal coming (parousia), which is the catalyst for the Day of the Lord. But their faithfulness, love, and hope are not static. Their faithfulness has something that is lacking, which Paul thinks he can remedy (3:10). Their love is something that Paul prays that the Lord will enable to increase and abound (3:12). And their hope clearly needs refining, lest they grieve “like those who have no hope” (4:13). Hence, in spite of all the positive things Paul will go on to say about this audience, it is clear that their life together, like that of any flesh and blood church of any time or place, is a work—both divine and human—in progress.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In v. 4 Paul gives the second reason why he and his cosenders are giving thanks for the audience, namely, because they know their election ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐκλογή")]), _vm._v(", "), _c('i', [_vm._v("eklogē")]), _vm._v("). Here Paul draws on language that relates this Gentile audience in some way with the story of God’s dealings with Israel. The language of election (electing, elect, chosen) occurs throughout the OT to refer to God’s choosing Israel."), _c('a', {
    attrs: {
      "id": "fn49"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" Such "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("language reflects OT covenantal language about God’s love for, and choice of, Israel to be God’s holy people (e.g., Deut 7:6; 14:2). It recalls the entire complex of ideas about God’s electing Israel "), _c('i', [_vm._v("as a whole people,")]), _vm._v(" saving them, rescuing them, and setting them apart—or “sanctifying” them—both because of his love for them and so that they might become an instrument for his saving mission (Ps 105:6; Isa 41:8–10; 42:1; 44:2; 49:1–7 [LXX]).")]), _c('a', {
    attrs: {
      "id": "fn50"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" Similarly, here Paul refers to his Gentile audience as “brothers and sisters beloved by God,” those who have experienced God’s love when he elected them and continue to experience that love in the present."), _c('a', {
    attrs: {
      "id": "fn51"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("At this juncture, it is important to state explicitly a theological assumption that will undergird our understanding of the concept of election in this commentary, namely, that the concept of election in the NT has been christologically reconfigured. A number of NT texts describe Jesus as God’s elect or holy one (Luke 9:35; 23:35; Mark 1:24; John 6:68–69), and 1 Pet 1:20 affirms that he was “chosen beforehand before the foundation of the world.” While the Pauline corpus does not explicitly use the language of Jesus being God’s Elect One, a good case can be made that the writer of Ephesians (whether Paul or someone else) implies this very thing in 1:4–6, describing Jesus in Israel-like terms as “the beloved one” (v. 6) "), _c('i', [_vm._v("in whom he elected")]), _vm._v(" the audience “from before the foundation of the world.”"), _c('a', {
    attrs: {
      "id": "fn52"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" Arguably, these verses encapsulate a current that runs throughout Paul’s writings, namely that, in Jesus, Israel’s representative Messiah, the theology of election has been definitively reconfigured."), _c('a', {
    attrs: {
      "id": "fn53"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" We will therefore assume that Jesus is indeed God’s primary Elect One and that others are secondarily elect in him. Hence, individual Thessalonians are indeed elect and holy, but only insofar as they are “in Christ,” God’s Elect, Holy One; that is, only insofar as they are an ongoing part of a "), _c('i', [_vm._v("corporate")]), _vm._v(" body of the risen, cruciform Christ in Thessalonica.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Only in 1 Cor 1:26–28 does Paul use the verb “elect,” and there he implicitly "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("equates God’s election, or choosing, with God’s calling ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("κλῆσις")]), _vm._v(", "), _c('i', [_vm._v("klēsis")]), _vm._v("), as he does elsewhere (e.g., Rom 9:11–12; 11:28–29; cf. 8:30 with 8:33; cf. 2 Pet 1:10).")]), _c('a', {
    attrs: {
      "id": "fn54"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" In 2 Thess 2:13 Paul uses a synonym of “elect” ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("αἱρέομαι")]), _vm._v(", "), _c('i', [_vm._v("haireomai")]), _vm._v(") in a way that makes God’s choosing functionally equivalent to God’s calling in 2:14 (see comments). Hence, although Paul does not use the specific term for election in the remainder of 1 and 2 Thessalonians, he refers to God’s calling of the audience several times (1 Thess 2:12; 4:7; 5:24; 2 Thess 1:11), rhetorically emphasizing that God’s initiative of election underlies everything in the letter.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is worth making explicit at this point that the language of election and call in this letter or in Paul as a whole does not have to do with the predestination of only some “elect” individuals for salvation and the predestination of other individuals, the “nonelect,” for damnation (so-called double predestination). Rather, the language of election has to do with “goal and actualization.”"), _c('a', {
    attrs: {
      "id": "fn55"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" Ben Meyer’s succinct definition of election in the biblical tradition is to the point: “It is divine love sovereignly choosing its instruments for the realization of a divine plan.”"), _c('a', {
    attrs: {
      "id": "fn56"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" The purpose of their election is so that, as beneficiaries of the "), _c('i', [_vm._v("missio Dei,")]), _vm._v(" they themselves might become participants in it. Following Suzanne McDonald, we could say that this is to characterize election as “election to representation.”"), _c('a', {
    attrs: {
      "id": "fn57"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" Her full-length theological analysis of election moves along representational lines, insisting that God’s election is very particular, involving only the specific ecclesial community (contra Barth), those “in Christ” by means of the Spirit. However, this community is elect so that")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("they can represent God to others and others to God, and that in doing so . . . [hold] those who are apparently rejected within the sphere of God’s promised blessing. . . . Election to representation insists that the elect are those through whom God’s purpose of blessings unfolds, partially and proleptically, in the sphere of human history. . . . God’s purpose in electing a people for himself is that God’s loving justice and salvation might reach to the ends of the earth."), _c('a', {
    attrs: {
      "id": "fn58"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("They are elect, in other words, so that they might proclaim and embody the “good news,” or the “gospel” ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εὐαγγέλιον")]), _vm._v(", "), _c('i', [_vm._v("euangelion")]), _vm._v("), a term we first encounter "), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("in v. 5. “Gospel” in Paul’s letters and in the NT as a whole is not a “plan of salvation” for individuals, although it is certainly related to the salvation of individual persons.")]), _c('a', {
    attrs: {
      "id": "fn59"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" Even though Paul nowhere explicitly defines the word "), _c('i', [_vm._v("euangelion,")]), _vm._v(" I, as well as all other interpreters of Paul, make very important interpretive decisions based on what we assume as its content. Based on a number of summary-type passages, and taking into account the imperial background of Paul’s context sketched in the introduction to the commentary, I briefly set out here my understanding of this important word.")]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "s04"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s04"
    }
  }, [_vm._v("Excursus on the Meaning of “Gospel”")])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("In Paul’s letters, I take "), _c('i', [_vm._v("euangelion")]), _vm._v(" to be a narrative account about a particular version of good news that, whether by design or consequence, stood in contrast to Rome’s imperial version of good news and its (false) claim to have brought lasting peace to the world."), _c('a', {
    attrs: {
      "id": "fn60"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" This good news is that the Creator God, in a display of saving covenant faithfulness to Israel, has graciously invaded the cosmos in order to reclaim and reestablish sovereignty over a world enslaved by the powers of Sin and Death. This invasive act of covenant faithfulness is constituted by (1) Jesus’ whole life of covenant faithfulness (i.e., his fidelity to God and love toward others) who, in the power of the Holy Spirit, went to his death in obedience;"), _c('a', {
    attrs: {
      "id": "fn61"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" and (2) God, through that same Spirit, justifying, or vindicating, Jesus via a transformative resurrection and subsequent exaltation, declaring him to be both Israel’s Messiah and, consequently,"), _c('a', {
    attrs: {
      "id": "fn62"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" the true Lord of the whole world.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This good news is indeed a theopolitical announcement, an announcement "), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("of good news that the Savior God has begun effecting the salvation characterized by the true peace, or shalom, that he had promised (e.g., Isa 52:7–10). It is a salvation that will be consummated at the royal coming of the Lord, Jesus Messiah, when God will make the world right by bringing judgment, raising the dead, and renewing and sanctifying all of creation. In the meantime, humans can share proleptically in that final salvation through "), _c('i', [_vm._v("pistis")]), _vm._v(" and baptism into Christ, becoming part of a community that has experienced God’s peace in their forgiveness and reconciliation with God and each other. This people analogously shares Christ’s cruciform life of covenant faithfulness, thereby publicly embodying a way of living that challenges the current values of any manifestation of empire, whether in a first-century or twenty-first-century version.")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Michael Gorman describes the “gospel” similarly:")])]), _c('p', {
    staticClass: "EX"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('i', [_vm._v("The gospel of God is not a set of propositions; it is the account of the planned, executed, and soon-to-be-consummated benevolent invasion of God into the history of Israel, human history more generally, and the entire cosmos to set right a world gone awry.")]), _vm._v(" Both the invasion itself and the retelling of it (in various forms and with various emphases) effect transformation in those who receive the message for what it is—good news of God’s action in Christ and the Spirit. This is why Paul can say that the gospel is “the power of God for salvation to everyone who has faith, to the Jew first and also to the Greek” (Rom 1:16).")]), _c('a', {
    attrs: {
      "id": "fn63"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Hence, I understand the word "), _c('i', [_vm._v("euangelion")]), _vm._v(" to function as a “metaleptic prompt,” a word that is intended to evoke something like the above when heard by the audience of the letter."), _c('a', {
    attrs: {
      "id": "fn64"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" I also assume that Paul might have appealed to any number of its aspects in his initial preaching.")]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Verses 5–6 (with v. 6 further explicated in vv. 7–10) constitute the two-part reason"), _c('a', {
    attrs: {
      "id": "fn65"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" why Paul can say that he and his companions know that his audience has been elected by God: (1) because of the way their gospel came ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐγενήθη")]), _vm._v(", "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('i', [_vm._v("egenēthē")]), _vm._v(") to the audience (v. 5) and (2) because of what the audience themselves became ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐγενήθητε")]), _vm._v(", "), _c('i', [_vm._v("egenēthēte,")]), _vm._v(" vv. 6–7)")]), _c('a', {
    attrs: {
      "id": "fn66"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" as a result of their reception of this good news (vv. 6–10).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("First, the audience’s election is clear to Paul and his cosenders because their gospel not only came to the audience in word/speech ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("λόγος")]), _vm._v(", "), _c('i', [_vm._v("logos")]), _vm._v("), that is, as an oral proclamation."), _c('a', {
    attrs: {
      "id": "fn67"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" It also came in a way that Paul associates with “power,” the “Holy Spirit,” and a “fully persuasive way.” Each of these terms follows the preposition "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐν")]), _vm._v(" ("), _c('i', [_vm._v("en,")]), _vm._v(" “in, by, with”),"), _c('a', {
    attrs: {
      "id": "fn68"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" indicating that they are functioning adverbially to describe how “our gospel came,” and each of them is grammatically connected with the other two with a "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("καί")]), _vm._v(" ("), _c('i', [_vm._v("kai,")]), _vm._v(" “and, indeed, that is”). The main interpretive question is how they are connected with each other. Are they three separate elements in Paul’s description of how the gospel came to the audience, or are they more closely related?")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul associates power with the Holy Spirit in a similar context (1 Cor 2:4; cf. Rom 15:13), which makes it likely that they are connected here as well. Hence, while there are other options,"), _c('a', {
    attrs: {
      "id": "fn69"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" it makes good sense to take the second "), _c('i', [_vm._v("kai")]), _vm._v(" as explanatory (“that is”), with the next two terms functioning to clarify the phrase “with power.”"), _c('a', {
    attrs: {
      "id": "fn70"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" On this reading, the sense would be that their oral account of the gospel came to the audience with a power that (1) was generated by the Holy Spirit and (2) was connected with “full persuasion” of the truth of the proclamation, which itself corresponded to the sort of people Paul and his cosenders were among them."), _c('a', {
    attrs: {
      "id": "fn71"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" That is, not only did the Spirit empower their gospel proclamation, but the Spirit-enabled way Paul acted among them embodied the truth of the content of the proclaimed gospel, which contributed to its power to persuade the audience to confess Jesus as Lord of the cosmos. In 2:1–12 Paul "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("describes in detail this way of acting in terms that draw on what would have been familiar friendship language,")]), _c('a', {
    attrs: {
      "id": "fn72"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" as well as the language of popular moral philosophy."), _c('a', {
    attrs: {
      "id": "fn73"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" And he uses such language in ways that depict these actions in terms of an overall pattern of life, that is, one that is cruciform in nature and thereby analogous to the covenant faithfulness of Jesus himself expressed in loyalty to God and self-giving actions toward others. Hence, not only did the proclamation of this gospel take the empowering presence of the Holy Spirit acting upon its hearers to give it persuasive and liberating power; it took a concrete, Spirit-enabled reembodiment of its essence by its proclaimers."), _c('a', {
    attrs: {
      "id": "fn74"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" One part of the reason, then, that Paul and his companions know that God has elected this audience is the powerful way their gospel came to the Thessalonians.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The second part of the reason they know that God has elected the audience is "), _c('i', [_vm._v("what the audience themselves became")]), _vm._v(" as a result of their reception of this good news, initially described in v. 6 as “imitators of us and of the Lord” (cf. 2:14). The meaning of this phrase is disputed."), _c('a', {
    attrs: {
      "id": "fn75"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" Contextually, it makes little sense if Paul is trying to draw an analogy between his and (especially) the Lord’s "), _c('i', [_vm._v("reception")]), _vm._v(" of the good news and that of the Thessalonians. It would make better sense if the passage is referring to a pattern of life that the audience exhibited after they received the good news that is somehow analogous to that of Paul and his cosenders and to that of the Lord."), _c('a', {
    attrs: {
      "id": "fn76"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" In other contexts when Paul encourages his congregations to imitate him (1 Cor 4:16; 11:1; Phil 3:17; cf. Eph 5:1; 1 Tim 4:12; Titus 2:7), such imitation has to do with an overall cruciform pattern of life, that is, fidelity to God and self-giving love for others (see comments on 2 Thess 3:7, 9)."), _c('a', {
    attrs: {
      "id": "fn77"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" Hence, in light of the letter’s emphasis on the fidelity of the audience in "), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("the face of tribulation (including the immediate context of 1:8–10), as well as the pattern of Paul’s own life that emerges in 2:1–12, the meaning of v. 6 is reasonably clear. Being “imitators of us and of the Lord” would entail the audience themselves exhibiting their own “nonidentical repetition”")]), _c('a', {
    attrs: {
      "id": "fn78"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" of the covenant faithfulness of Jesus expressed in faithfulness ("), _c('i', [_vm._v("pistis")]), _vm._v(") to God and self-giving actions toward others that they had seen exemplified in the actions of Paul and his cosenders."), _c('a', {
    attrs: {
      "id": "fn79"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" In other words, they are not necessarily slavishly imitating specific actions of Paul or of the Lord."), _c('a', {
    attrs: {
      "id": "fn80"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" Rather, they have been formed by, and are now embodying, an overall life pattern in their own particular context that is analogous to the pattern of life displayed by Paul and the Lord in theirs. This is the essential meaning of "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("τύπος")]), _vm._v(" ("), _c('i', [_vm._v("typos,")]), _vm._v(" “example, pattern”) in v. 7, namely, a pattern into which something has been formed that can then be used as the pattern to form other things into an analogous pattern."), _c('a', {
    attrs: {
      "id": "fn81"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("To be clear, while such a life pattern does not exclude human effort, to place the emphasis on human effort per se would miss the nuances of what the imitation of Christ entails in the Pauline corpus. Imitating Christ is more the result of a power at work—none other than the Spirit of God and of Christ—that “enables the exalted crucified Christ to take shape in and among those who belong to him and live in him . . . [which therefore] enables the narrative of the cross to be retold and relived.”"), _c('a', {
    attrs: {
      "id": "fn82"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" This result is basically what Paul goes on to describe in the next few verses (esp. v. 8).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Their exhibition of fidelity ("), _c('i', [_vm._v("pistis")]), _vm._v(") to God and self-giving actions toward others (e.g., 3:12; 5:15) began after they received the word (i.e., the gospel) in much "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("θλῖψις")]), _vm._v(" ("), _c('i', [_vm._v("thlipsis,")]), _vm._v(" “tribulation,” v. 6; cf. Mark 4:17). This is the first time in the letter that Paul mentions the audience’s tribulation and suffering. As Acts 17 affirms, he depicts them as having undergone tribulation and suffering in the past (1 Thess 1:6; 2:14–15; 3:3–4), which we should probably imagine as continuing (see comments on 1 Thess 3:3, 8). This is not generic suffering (i.e., sickness, accidental injuries) but suffering that is part of the vocation of Christians."), _c('a', {
    attrs: {
      "id": "fn83"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" In every case, the audience is depicted as suffering at the hands of others, which is "), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("not surprising, given the way Paul describes their actions in v. 9. From a contemporary perspective, their “turning to the living and true God from idols” (1:9) may look like a change in their religious affections—granted, a rather large change in their “religious life.” But such a conclusion would fail to see that “religion” in antiquity was not a separate category from the rest of cultural life. It permeated every aspect—social, political, economic—of the culture. As Kavin Rowe puts it, “To call into question pagan religion is to critique pagan culture: tear out the threads of pagan religiousness and the cultural fabric itself comes unraveled.”")]), _c('a', {
    attrs: {
      "id": "fn84"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Thessalonians’ “turning to the living and true God from idols” would mean becoming a part of a particular community known for publicly visible actions of refusing to honor (at least) the gods of traditional Greco-Roman religion. Refusing to engage in “normal” activities like public festivals, trade association meetings in temples, or various private celebrations (e.g., birthday parties, weddings) in local temples might indeed be understood by others as threatening to destabilize the culture."), _c('a', {
    attrs: {
      "id": "fn85"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" In fact, given that the gods were seen as the city’s benefactors, such refusals might be conceived as bringing their wrath (e.g., in the form of earthquakes, floods, or agricultural failure)."), _c('a', {
    attrs: {
      "id": "fn86"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" If, as is likely, such a failure to honor the gods extended to the deified Caesars, others would have probably perceived this behavior as threatening not only the peace and security of the city but that of the empire as a whole, "), _c('i', [_vm._v("even if Christians never intended any such thing.")]), _c('a', {
    attrs: {
      "id": "fn87"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" At the very least, such actions would have been economically and socially costly for the Thessalonians. The result would no doubt have been “much tribulation or pressure” (1:6), most probably in the form of social ostracism, verbal harassment, possible political sanctions, and perhaps even sporadic physical violence."), _c('a', {
    attrs: {
      "id": "fn88"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("According to Paul, such tribulation/suffering in the Thessalonians’ sociopolitical context is simply inevitable (1 Thess 3:3–4). It would have brought with it a clear ascription of public dishonor from the audience’s neighbors and probably "), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("from those within their own households (esp. if the head of their extended household was not a member of the "), _c('i', [_vm._v("ekklēsia")]), _vm._v(").")]), _c('a', {
    attrs: {
      "id": "fn89"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" Hence, in their social context, it is a "), _c('i', [_vm._v("distinct possibility")]), _vm._v(" that their loyalty to God and their self-giving actions toward others would have resulted in physical violence directed toward them, but a "), _c('i', [_vm._v("virtual certainty")]), _vm._v(" that it would have resulted in their having dishonor publicly ascribed to them, both individually and corporately. Even so, in the midst of this tribulation and the ensuing dishonor, they received the gospel, not only with Spirit-empowered, active faith and faithfulness ("), _c('i', [_vm._v("pistis")]), _vm._v(") and love, but also with joy produced by that same Holy Spirit. As a result, they proved themselves not to be “short-time” disciples without root who fell away when tribulations or persecutions came (Mark 4:17); rather, they were those whose lives evidenced the fruit of the "), _c('i', [_vm._v("missio Dei,")]), _vm._v(" as Paul goes on to describe in the next few verses.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In imitating Paul, his companions, and the Lord, "), _c('i', [_vm._v("their corporate life together, their ecclesial body as a whole,")]), _vm._v(" in turn became a singular "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("τύπος")]), _vm._v(" ("), _c('i', [_vm._v("typos,")]), _vm._v(" “pattern, model”) to all those who were exercising believing allegiance in Macedonia and Achaia (v. 7). Hence, the faithful way this audience conducted their corporate life together in the midst of tribulation functioned as a pattern for (presumably) the churches in Philippi and Corinth in shaping their own ecclesial life together. Paul’s declaration of this faithful witness effectively ascribes a supralocal honor to this audience in an alternative court of reputation—namely, God’s."), _c('a', {
    attrs: {
      "id": "fn90"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" Verse 8 functions as a virtual warrant for Paul’s assertion."), _c('a', {
    attrs: {
      "id": "fn91"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" He can speak so positively about their ecclesial life because "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ὁ λόγος τοῦ κυρίου")]), _vm._v(" ("), _c('i', [_vm._v("ho logos tou kyriou,")]), _vm._v(" “the word [or oral proclamation] about the Lord”)"), _c('a', {
    attrs: {
      "id": "fn92"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" has rung forth from the audience and continued to reverberate,"), _c('a', {
    attrs: {
      "id": "fn93"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" not just in Macedonia and Achaia, but as the second half of the verse implies, in every place. Hence, in imitating Paul and his companions, the "), _c('i', [_vm._v("euangelion,")]), _vm._v(" the "), _c('i', [_vm._v("logos")]), _vm._v(" about the Lord’s faithfulness, has rung forth from the audience and continued to reverberate in some form of oral proclamation. Since it would have affirmed Jesus’ universal lordship, its reverberating effects would, at the very least, have included an implicit calling into question of their culture’s idolatry.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("There is a continuing debate over whether Paul expected his congregations to orally proclaim the gospel.")]), _c('a', {
    attrs: {
      "id": "fn94"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" Given the comments above that "), _c('i', [_vm._v("logos")]), _vm._v(" (word, speech, oral proclamation) and "), _c('i', [_vm._v("euangelion")]), _vm._v(" (gospel) are virtual synonyms in 1 Thessalonians, it is a false dichotomy to argue that Paul is depicting his audience here as embodying the good news "), _c('i', [_vm._v("rather than")]), _vm._v(" proclaiming it."), _c('a', {
    attrs: {
      "id": "fn95"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" They go hand in hand, and the most natural reading of the language here indicates that the audience was engaged in doing both, although such a conclusion need not mean that the audience was engaged in the same sort of public preaching as was Paul."), _c('a', {
    attrs: {
      "id": "fn96"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" Narrating the gospel orally might take other forms, such as discussing the reason for their change of public behavior with unbelievers in their household or with those visiting their household from other locales, or prophetically calling into question the idolatry of their culture in their daily routine and conversations with others. My suspicion is that, if one does not understand “gospel” in terms of a truncated propositional “sales pitch” relying solely on one atonement model (i.e., penal satisfaction), there is far less impetus to argue that Paul expects his communities only to embody rather than speak the gospel. In any case, in this context, it was God’s power at work in the Thessalonians’ words, giving those words the power to reverberate in all directions as they narrated the gospel.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The succeeding phrase in v. 8b, “but in every place,” may be taken with the preceding verb, implying that their proclamation about the Lord did indeed reverberate (hyperbolically) “in every place.” However, the phrase might also go with what follows it. That is, not only their proclamation has reverberated “in every place” but also their faithfulness to God."), _c('a', {
    attrs: {
      "id": "fn97"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" Given that Paul can say that they have no need to say anything about the latter, its going forth “in every place” seems also implied. Hence, Paul’s rhetoric moves seamlessly between the oral proclamation about the Lord reverberating outward from the Thessalonian "), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("assembly and the audience’s own faithfulness ("), _c('i', [_vm._v("pistis")]), _vm._v(") to God in moving outward (with continuing results) in every place,")]), _c('a', {
    attrs: {
      "id": "fn98"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" so that he has no need to say anything about it (cf. Rom 1:8). The effect of this seamless rhetorical move is to sew together the proclamation about the Lord’s "), _c('i', [_vm._v("pistis")]), _vm._v(" with the audience’s own "), _c('i', [_vm._v("pistis,")]), _vm._v(" that is, to combine their verbal expression of the gospel with their embodiment of it."), _c('a', {
    attrs: {
      "id": "fn99"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" They are indeed exercising "), _c('i', [_vm._v("pistis")]), _vm._v(" to God and love toward others as they persevere in tribulation, awaiting with hope their own vindication and future salvation at the royal coming of the Lord (1:3). This life pattern is congruent with the audience’s being imitators of Paul and the Lord, and now their corporate life together is a further example to be imitated by other churches like those in Philippi and Corinth.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Although Paul says he has no need to speak about their faithfulness, he does just that in what follows."), _c('a', {
    attrs: {
      "id": "fn100"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" The reason he says he does not need to mention it is that others outside their city are announcing it."), _c('a', {
    attrs: {
      "id": "fn101"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" They are apparently reporting the kind of initial visit Paul and his companions had with the Thessalonians, namely, one of impeccable integrity, in which they embodied the essence of what they proclaimed (see comments on v. 5) and the Thessalonians’ response to it (vv. 9–10). Paul goes on to describe that initial visit in more detail (2:1–12). The focus here, however, is on the report of the audience’s initial and ongoing "), _c('i', [_vm._v("pistis")]), _vm._v(" (faithfulness/fidelity), namely, “how you turned to God away from idols to be enslaved to the living and true God and to await his Son from heaven” (vv. 9b–10)."), _c('a', {
    attrs: {
      "id": "fn102"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])]), _vm._v(" The totality of this phrase defines their "), _c('i', [_vm._v("pistis")]), _vm._v(" in this context in terms of three verbs: "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐπεστρέψατε")]), _vm._v(" ("), _c('i', [_vm._v("epestrepsate,")]), _vm._v(" “you all turned”), "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δουλεύειν")]), _vm._v(" ("), _c('i', [_vm._v("douleuein,")]), _vm._v(" “to be enslaved”), and "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀναμένειν")]), _vm._v(" ("), _c('i', [_vm._v("anamenein,")]), _vm._v(" “to await”)."), _c('a', {
    attrs: {
      "id": "fn103"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As noted above, since religion permeated every aspect of city life in this culture, a “turning to God away from idols” is not simply a reference to an inner change of disposition. Rather, it would, among other things, refer to publicly visible actions of refusing to join in the variety of ways the Roman gods were honored in society, which would constitute a complete change in their pattern "), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("of life. This is clearly “conversion” language,")]), _c('a', {
    attrs: {
      "id": "fn104"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(" with Paul depicting his audience as turning to God and thus turning away from their “normal” civic activities, “to be enslaved ["), _c('i', [_vm._v("douleuein")]), _vm._v("] to the living and true God.” With the present tense verb "), _c('i', [_vm._v("douleuein,")]), _vm._v(" Paul portrays others as describing the state of the Thessalonian assembly as one of "), _c('i', [_vm._v("ongoing enslavement to God,")]), _vm._v(" that is, as exhibiting unconditional obedience and loyalty toward God. It is not that their faith ("), _c('i', [_vm._v("pistis")]), _vm._v(") “"), _c('i', [_vm._v("results")]), _vm._v(" in turning from idols, etc., but that faith ["), _c('i', [_vm._v("pistis")]), _vm._v("] "), _c('i', [_vm._v("is")]), _vm._v(" the turning from idols to serve the living God of Israel. A ‘faith in God’ that is not precisely this act of turning and serving is empty.”"), _c('a', {
    attrs: {
      "id": "fn105"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])]), _vm._v(" Hence, what those outside are announcing is the audience’s loyalty to the God of Israel, the concrete form of their “turning to the living and true God to be saved” (cf. Isa 45:22)."), _c('a', {
    attrs: {
      "id": "fn106"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It was common in Second Temple Judaism for Jews to contrast the true and living God of Israel with the dead images of the false gods of Gentiles, who had no power to save or give life (e.g., Jer 10; Wis 13–15)."), _c('a', {
    attrs: {
      "id": "fn107"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" This kind of contrast echoes emphatically monotheistic passages like Isa 44:9–20. As Joel Marcus points out, such polemic was a caricature, given that pagans did not typically worship the images per se but the invisible gods they represented. These images were characteristically thought to participate sacramentally in their power."), _c('a', {
    attrs: {
      "id": "fn108"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" Paul himself is typically Jewish at this point. He agrees with the Corinthians that an idol has no real existence (1 Cor 8:4; 10:19) but then goes on in 1 Cor 10:20 to equate these same idols with demons ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δαιμόνια")]), _vm._v(", "), _c('i', [_vm._v("daimonia")]), _vm._v("), thus showing an awareness that these images do somehow participate sacramentally in the power of the invisible realities they represent. It is just that these realities are not the gods they purport to represent (nor are they simply benign intermediate members of a divine hierarchy, as the Corinthians may have imagined)."), _c('a', {
    attrs: {
      "id": "fn109"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("Being concerned that some of the Corinthians will be dragged back into the slavery of the whole symbolic system generated by worship of false gods (i.e., into the realm of those perishing, 1 Cor 1:18), Paul admonishes that audience to “flee from idolatry” (1 Cor 10:14).")]), _c('a', {
    attrs: {
      "id": "fn110"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("No doubt Paul could have said that at one point the Corinthian audience had “turned from idols to serve the living and true God,” but clearly there were no guarantees that some of them might not turn back to these same idols. Given this constant reality in their social setting,"), _c('a', {
    attrs: {
      "id": "fn111"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])]), _vm._v(" it is important to note that God’s gracious election of these Corinthians"), _c('a', {
    attrs: {
      "id": "fn112"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])]), _vm._v(" itself was no guarantee that they would persevere in their faithfulness ("), _c('i', [_vm._v("pistis")]), _vm._v(") to this God (cf. Gal 4:8–9). The same is clearly true of the Thessalonian audience."), _c('a', {
    attrs: {
      "id": "fn113"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _vm._v(" Although they have been elected by God and are now enslaved to God, their fidelity in the face of serious pressure and tribulation is not automatic, any more than was Jesus’ own fidelity.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("That the Thessalonians’ "), _c('i', [_vm._v("pistis")]), _vm._v(" (faith/faithfulness) would take the form of enslavement ("), _c('i', [_vm._v("douleuein")]), _vm._v(") to God underscores its analogical relationship to that displayed by the Lord, who also took the form of a slave ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δοῦλος")]), _vm._v(", "), _c('i', [_vm._v("doulos")]), _vm._v(") in becoming human and then exhibited a loyalty to God that finally took him to his death on a cross (Phil 2:6–8). Hence, their assembly "), _c('i', [_vm._v("as a whole")]), _vm._v(" exhibits a similar pattern of faithfulness as that of Jesus in his rectifying display of covenant faithfulness to the God of Israel. As a nonidentical repetition of the "), _c('i', [_vm._v("pistis")]), _vm._v(" of Jesus, their "), _c('i', [_vm._v("pistis")]), _vm._v(" displays a life pattern of participation in the "), _c('i', [_vm._v("missio Dei")]), _vm._v(" and may be characterized as an “initial and ongoing cruciformity, grounded in the faithfulness of Jesus the Messiah.”"), _c('a', {
    attrs: {
      "id": "fn114"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])]), _vm._v(" As Douglas Harink maintains:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("The point to emphasize here is that for Paul the Thessalonian believer’s participation in God’s gracious work through Christ and the Spirit is not focused upon or localized in a single form of human response, that is receptive faith (or “faith in Christ,” a phrase which appears nowhere in the letter); rather it is depicted as spread over the whole range of human life, active and passive, attitudinal and bodily, inner and outer, personal, social, and political."), _c('a', {
    attrs: {
      "id": "fn115"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("Paul further characterizes their "), _c('i', [_vm._v("pistis")]), _vm._v(" as “awaiting his Son from the heavens” (cf. 4:16; 2 Thess 1:7).")]), _c('a', {
    attrs: {
      "id": "fn116"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])]), _vm._v(" In their current tribulations, they, like Israel in Isaiah and much of the persecuted church today, await justice when there appears to be none and salvation, which seems far from them (Isa 59:11). Waiting in almost any context is not primarily a heightened or intense mental or psychological state but rather “the set of observable actions or behavior to which the expectation gives rise.”"), _c('a', {
    attrs: {
      "id": "fn117"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])]), _vm._v(" In other words, the Thessalonians’ waiting—and by analogy, that of the persecuted people of God in any time or place—is not a heightened mental state but is constituted by their active public perseverance that is produced by the hope they have for the royal coming of the Lord Jesus Christ and the salvation it brings (v. 3).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul then further depicts the awaited Son with two more clauses, one of which describes what God did for Jesus and the other what Jesus is doing and will do for the audience. The first of these describes the Son as the one “whom he [God] raised from the dead.” Paul mentions Jesus’ resurrection once more (1 Thess 4:14) in the Thessalonian correspondence. In both places he simply assumes his audience’s adherence to this belief, which is the pivot point of the gospel, the point at which God vindicates, or justifies, the Son because of his saving display of covenant faithfulness in life and death. Paul mentions one aspect of that resulting salvation in the next clause, which depicts the Son, using language from Isaiah’s description of the Divine Warrior, as “Jesus, the one who is going to rescue ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("τὸν ῥυόμενον")]), _vm._v(", "), _c('i', [_vm._v("ton rhyomenon")]), _vm._v("] us from the coming wrath” (cf. Isa 59:19–20)."), _c('a', {
    attrs: {
      "id": "fn118"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])]), _vm._v(" Neither here, in 2:16, nor in 5:9 is this wrath explicitly said to come from God (as, e.g., in Rom 1:18), yet it is clearly implied. In the Bible wrath is not an attribute of God but rather a response to human actions that harm oneself and others, destroying human relationships or God’s good created order. It is a response of “ferocious love”"), _c('a', {
    attrs: {
      "id": "fn119"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])]), _vm._v(" that seeks restorative justice in and for God’s whole created order (see comments on 2 Thess 1:5–10). Baker’s and Green’s summary comments in this regard are helpful:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("Although Paul does not here identify the coming wrath as God’s, we would be mistaken to read here an impersonal force. This is none other than God’s righteous response to persistent human disobedience (see 1 Thess 2:16); thus, the coming wrath is the final judgment of those who refuse to believe. There is no sense here of divine anger but rather of God’s bringing those who rebuff him and his people to eschatological justice. The coming wrath is the coming judgment, the climactic, endtime judgment scene when those who prefer to worship idols rather than the living God receive the fruits of their own misplaced hopes and commitments.")]), _c('a', {
    attrs: {
      "id": "fn120"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Here and in the rest of 1 Thessalonians (2:16, 5:9), then, it is this eschatological wrath that is primarily in view. In this case, God will act in ferocious love to bring restorative justice for the whole of the created order, but those who are intentional and unrepentant perpetrators of violence and evil will experience God’s wrath as destructive rather than restorative. Those currently in the church are not exempt from experiencing God’s vengeance if they engage in such actions, which flagrantly violate the cruciform character of their Lord (see comments on 4:6 and 5:9).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("However, if one takes into account Rom 1:18–19 in conjunction with Paul’s use of the present tense participle "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("τὸν ῥυόμενον")]), _vm._v(" ("), _c('i', [_vm._v("ton rhyomenon,")]), _vm._v(" “the one who is rescuing us”), the wrath of God in this context may also have a current connotation."), _c('a', {
    attrs: {
      "id": "fn121"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])]), _vm._v(" In Rom 1:18–19 Paul says that the wrath of God is being revealed from heaven against all "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀσέβεια")]), _vm._v(" ("), _c('i', [_vm._v("asebeia,")]), _vm._v(" “impiety”) and "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀδικία")]), _vm._v(" ("), _c('i', [_vm._v("adikia,")]), _vm._v(" “injustice”), the manifestation of which is the actions and resulting slavery that Paul describes as "), _c('i', [_vm._v("currently")]), _vm._v(" infecting humanity in the following verses. Hence, while the focus here is primarily on the audience’s being rescued from God’s eschatological wrath, in their “turning to God to be enslaved to him in faith/faithfulness ["), _c('i', [_vm._v("pistis")]), _vm._v("],” they are also being spared from the present wrath of God, which is manifest in the slavery that results when "), _c('i', [_vm._v("asebeia")]), _vm._v(" (vertical covenant violations against God) and "), _c('i', [_vm._v("adikia")]), _vm._v(" (horizontal actions against others) spin out of control."), _c('a', {
    attrs: {
      "id": "fn122"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In vv. 5–10 Paul has given the two-part reason why he knows that this Gentile audience, like Israel in the biblical story, has been elected by God. The focus is not on specific individuals being elected for salvation and others elected for damnation by an inscrutable eternal decree of God. Rather, it is on the "), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("election of this church as a whole, an election that is clear from two observable consequences of divine action that enabled their individual and corporate human response. First, by empowering its proclaimers to reembody its essence in the midst of the Thessalonians, the Holy Spirit gave the gospel a persuasive and liberating power that it might not have had on its own in such a culture. Second, the Spirit enabled the Thessalonians themselves to publicly reembody the essence of this gospel by exhibiting their own nonidentical repetition of the covenant faithfulness of Jesus expressed in fidelity ("), _c('i', [_vm._v("pistis")]), _vm._v(") to God and the self-giving actions (i.e., love, "), _c('i', [_vm._v("agapē")]), _vm._v(") toward others that they had seen exemplified in the actions of Paul and his companions. Hence, God’s electing activity is not limited to a precreation selection process but is played out in the actual reception of Paul’s gospel in active faith/faithfulness to God and love toward others. In short, Paul knows that God has elected them because he has observed their being rescued by, in order to participate in, the "), _c('i', [_vm._v("missio Dei.")])])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "s05"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#s05"
    }
  }, [_c('i', [_vm._v("2:1–12"), _c('span', {
    staticClass: "space"
  }, [_vm._v("“The Sort of People We Became among You”: An Explanation and a Model for Participation in the")])]), _vm._v(" Missio Dei")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('sup', [_vm._v("1")]), _vm._v("For you yourselves know, sisters and brothers, that our initial visit with you has not been devoid of power. "), _c('sup', [_vm._v("2")]), _vm._v("Yet, although we suffered beforehand and were shamefully mistreated in Philippi, just as you know, in the face of much opposition we had the courage—by means of our God—to speak the good news from God openly to you all. "), _c('sup', [_vm._v("3")]), _vm._v("For our exhortation did not spring from deception or from impure motives, nor was it with deceit. "), _c('sup', [_vm._v("4")]), _vm._v("But just as we have been and remain tested and approved by God to be entrusted with the gospel, this is how we speak, not as attempting to be pleasing to people but to God, the one who continues testing and approving our hearts. "), _c('sup', [_vm._v("5")]), _vm._v("For we never came with flattering speech, just as you all know, nor with a false motive, namely, greed—God is a witness—"), _c('sup', [_vm._v("6")]), _vm._v("nor did we come demanding public honor from people, neither from you or from others, "), _c('sup', [_vm._v("7")]), _vm._v("although we could have thrown our weight around as apostles of Christ. But we became infants"), _c('a', {
    attrs: {
      "id": "fn123"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])]), _vm._v(" in your midst. Like a nurse taking care of her own children, "), _c('sup', [_vm._v("8")]), _vm._v("so we, because we cared so much for you, were pleased"), _c('a', {
    attrs: {
      "id": "fn124"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])]), _vm._v(" to share with you not only the gospel from God, but also our very selves because we had come to love you so. "), _c('sup', [_vm._v("9")]), _vm._v("For you all remember, brothers and sisters, our labor and toil. We proclaimed to you the gospel from God "), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("by working night and day in order not to burden any of you. "), _c('sup', [_vm._v("10")]), _vm._v("You yourselves are witnesses—as is God—how holily, justly, and blamelessly we behaved for the benefit of you all who are exercising believing allegiance. "), _c('sup', [_vm._v("11")]), _vm._v("Just as you know, as a father does for each one of his own children, "), _c('sup', [_vm._v("12")]), _vm._v("we exhorted, comforted, and witnessed to you all in order that you might continue walking worthily of the God who continues calling")]), _c('a', {
    attrs: {
      "id": "fn125"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])]), _vm._v(" you into his own kingdom and honor/glory.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "s06"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s06"
    }
  }, [_c('i', [_vm._v("The Rhetorical Function of 2:1–12")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("In 2:1–12 Paul begins the body of the letter by enlarging on one of the focal points of the thanksgiving section: the way the gospel came to the audience—namely, persuasively embodied in the kind of people he and his coworkers proved themselves to be. Most interpreters have recognized that, in this section, Paul contrasts his behavior among the Thessalonians to that of wandering public orators known as Sophists (often Cynic philosophers), whose vices would have been all too familiar to his audience."), _c('a', {
    attrs: {
      "id": "fn126"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])]), _vm._v(" Given this probable background, the primary interpretive question has been whether the function of 2:1–12 is primarily apologetic or primarily paraenetic."), _c('a', {
    attrs: {
      "id": "fn127"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])]), _vm._v(" That is, is Paul defending himself from actual charges made against him by opponents who accuse him of being one of these charlatan orators out for money and public honor and who abandon their pupils when the going gets tough?"), _c('a', {
    attrs: {
      "id": "fn128"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128")])]), _vm._v(" Or, rather than responding to specific charges, is he simply using the typical behavior of such orators as a negative backdrop to depict his own behavior as a model for his audience to follow?"), _c('a', {
    attrs: {
      "id": "fn129"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("Interpretive certainty is not possible on this issue.")]), _c('a', {
    attrs: {
      "id": "fn130"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130")])]), _vm._v(" But while one cannot decisively rule out an apologetic function from a historical standpoint, one need not appeal to the unnecessary hypothesis that there are opponents against whom Paul is crafting an apology."), _c('a', {
    attrs: {
      "id": "fn131"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131")])]), _vm._v(" In light of stock accusations against orators who “preach and run,” leaving their pupils in a lurch, one can understand that Paul might want to explain his continuing absence to a congregation going through persecutions."), _c('a', {
    attrs: {
      "id": "fn132"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])]), _vm._v(" But in doing so, he also attempts to shape his audience’s character and behavior by enlarging on the ethos he and his companions displayed when they were in Thessalonica."), _c('a', {
    attrs: {
      "id": "fn133"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])]), _vm._v(" Having been rescued by the "), _c('i', [_vm._v("missio Dei")]), _vm._v(" in order to participate in it, this recently converted audience needs more than just precepts. Even more, it needs concrete models"), _c('a', {
    attrs: {
      "id": "fn134"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])]), _vm._v(" to help it continue conducting its ecclesial life in ways that are worthy of God, who is calling them into a way of living at odds with societal expectations. An explanation of his continuing absence, therefore, functions at the same time as paraenesis.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Hence, in what follows I assume that in 2:1–12 Paul is contrasting his motives and behavior with contemporary wandering orators and Sophists, widely perceived to be charlatans out for their own interests rather than those of their pupils."), _c('a', {
    attrs: {
      "id": "fn135"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])]), _vm._v(" In so doing, he provides both an explanation for his continued absence "), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("as well as a pattern for the vocation of Christian leadership, a pattern that his audience is to implement in ordering their own life together.")]), _c('a', {
    attrs: {
      "id": "fn136"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The passage divides into two sections. In 2:1–4 Paul connects what he has just said in chapter 1 to this paraenetic section by reminding his audience of the power at work in his initial visit in the midst of difficult circumstances, the character of his exhortation, and God’s approval of his motives. In 2:5–12 he recounts how his public practices were consistent with God’s continued testing and approval of him to be entrusted with good news, insofar as he concretely embodied its very essence.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "s07"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s07"
    }
  }, [_c('i', [_vm._v("Paul’s Faithfulness to the Gospel in the Face of Opposition: 2:1–4")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("In 2:1 Paul begins to enlarge upon the character of his initial visit, particularly on the sort of people he and his companions showed themselves to be in it (1:5, 9). He first appeals to his audience’s own knowledge that his visit “has not been devoid ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("κενή")]), _vm._v(", "), _c('i', [_vm._v("kenē")]), _vm._v("] of power.” With this expression, he reminds the audience of the character and power of his visit evident in its continuing results, namely, their conversion and consistent faithfulness."), _c('a', {
    attrs: {
      "id": "fn137"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul’s visit to Thessalonica came after he had been treated shamefully in Philippi. Acts 16 describes the treatment Paul and Silas received there, one reserved for those of low status that would have been publicly shameful. They were stripped in public, beaten with Roman rods, and thrown into prison as uncondemned men (16:19–24, 37). Nevertheless, Paul says, God gave them courage to speak God’s own good news frankly and openly in public when they came to Thessalonica,"), _c('a', {
    attrs: {
      "id": "fn138"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")])]), _vm._v(" doing so in the face of great opposition ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀγών")]), _vm._v(", "), _c('i', [_vm._v("agōn;")]), _vm._v(" on which see Acts 17:1–9; cf. Col 1:29)."), _c('a', {
    attrs: {
      "id": "fn139"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")])]), _vm._v(" In other words, the primary reason why "), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("he, unlike the Sophists of his day, could speak so boldly in the midst of such violent opposition was God’s empowerment. Such costly actions in the service of the "), _c('i', [_vm._v("missio Dei")]), _vm._v(" are not characteristic of those whose character and intentions are less than genuine.")])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("In v. 3 Paul gives the secondary reason why he spoke so boldly in the face of opposition. He did so because his exhortation ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("παράκλησις")]), _vm._v(", "), _c('i', [_vm._v("paraklēsis")]), _vm._v("), unlike that of the popular orators, derived from a genuine concern for his audience.")]), _c('a', {
    attrs: {
      "id": "fn140"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")])]), _vm._v(" Here Paul uses the term "), _c('i', [_vm._v("paraklēsis")]), _vm._v(" to refer to the kind of frank, publicly open speaking of the gospel of God to which he has just referred in v. 2."), _c('a', {
    attrs: {
      "id": "fn141"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")])]), _vm._v(" Hence, the exhortation in question in this context is his Spirit-empowered proclamation and embodiment of the good news of God, which came to the audience as both gift and claim, enabling their "), _c('i', [_vm._v("pistis")]), _vm._v(" (faith/faithfulness) as described in 1:9–10. As such, it was a persuasive endeavor (cf. its use in 2:12) through which the Spirit worked to evoke both belief and a transformation that would be manifested in a particular pattern of life worthy of the God who called the audience, that is, "), _c('i', [_vm._v("pistis")]), _vm._v(" toward God and love toward others."), _c('a', {
    attrs: {
      "id": "fn142"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The series of antitheses in v. 3 describes Paul’s initial exhortation in negative terms, that is, it did"), _c('a', {
    attrs: {
      "id": "fn143"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")])]), _vm._v(" not “spring from "), _c('i', [_vm._v("planē")]), _vm._v(" ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("πλάνη")]), _vm._v(", ‘deception’] or from "), _c('i', [_vm._v("akatharsia")]), _vm._v(" ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀκαθαρσία")]), _vm._v(", ‘impure motives/impurity’),”"), _c('a', {
    attrs: {
      "id": "fn144"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144")])]), _vm._v(" and “neither was it with deceit.” The language of deception was used to describe the nongenuine motives of the charlatan orators whose behavior forms a negative backdrop to that of Paul."), _c('a', {
    attrs: {
      "id": "fn145"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("In v. 4 Paul turns to describe his exhortation in positive terms. In contrast to those whose public speech is characterized by the preceding antitheses, Paul reminds the audience that he speaks as one having been tested and approved by God in the past (and remaining so now)")]), _c('a', {
    attrs: {
      "id": "fn146"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146")])]), _vm._v(" to be entrusted with the gospel (cf. Gal 2:7). His behavior is the antithesis of the vices in v. 3 in that his motives have been, and continue to be, tested by God. Although Paul elsewhere uses the verb "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δοκιμάζω")]), _vm._v(" ("), _c('i', [_vm._v("dokimazō,")]), _vm._v(" “I put to the test/approve”) to refer to “the fire’s” eschatological testing of the work of Christian ministers (1 Cor 3:13; cf. 1 Pet 1:7), only here in the NT does it refer directly to God’s testing/approval of human beings. The theme of God’s testing his people, or the hearts of his people, is prominent in Jeremiah (9:7; 11:20; 12:3; 17:10; 20:12), where, in bringing a case against God, the prophet affirms his own loyalty to God by saying: “And you, yourself, Lord, know me. You have tested/approved ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δεδοκίμακας")]), _vm._v(", "), _c('i', [_vm._v("dedokimakas")]), _vm._v("] my heart in your sight” (Jer 12:3a LXX; cf. Ps 138:23 LXX)."), _c('a', {
    attrs: {
      "id": "fn147"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147")])]), _vm._v(" Paul’s allusion to Jer 1:5 in Gal 1:15 suggests that he is familiar with such claims by Jeremiah and also that he understands his vocation as prophetic.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As in the LXX, "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("καρδία")]), _vm._v(" ("), _c('i', [_vm._v("kardia,")]), _vm._v(" “heart”) in the NT generally refers to “the "), _c('i', [_vm._v("inner person,")]), _vm._v(" the seat of understanding, knowledge and will, and takes on as well the meaning "), _c('i', [_vm._v("conscience.")]), _vm._v("”"), _c('a', {
    attrs: {
      "id": "fn148"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148")])]), _vm._v(" Here "), _c('i', [_vm._v("kardia")]), _vm._v(" clearly has a volitional sense (cf. 1 Cor 4:5), but Paul can also use it with a cognitive nuance (e.g., Rom. 2:15; 16:17–18), demonstrating that he can use the term to refer to the inner aspect of one’s intentions, dispositions, and cognitive judgments. As should be obvious from the context here, he does not use “inner” anthropological terms like “heart” ("), _c('i', [_vm._v("kardia")]), _vm._v(") in precise ways to bracket these off from their embodiment in public practices. But Paul, like Jeremiah, affirms that God plumbs the very depths of human beings, testing the motives that lie behind their public practices, especially the practices of those who profess to be engaged in the "), _c('i', [_vm._v("missio Dei.")]), _vm._v(" Hence, unlike the charlatan orators, whose typical practice was to flatter their audience, Paul’s customary way of speaking is attempting to be pleasing not to human beings (cf. Gal 1:10) but rather to God. It is not that Paul does not attempt to identify with his audience (e.g., 1 Cor 9:19–23), but his typical way of speaking as he engages in God’s mission requires telling his audience the truth about their own situation in light of that mission. It is that way of speaking on which he elaborates in vv. 5–7a.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "s08"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s08"
    }
  }, [_c('i', [_vm._v("Paul’s Concrete Embodiment of the Essence of the Gospel: 2:5–12")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("Before commenting in more detail on these verses, two interpretive issues need to be addressed: (1) the textual variant in v. 7b and (2) the structure and punctuation of these verses in light of that text variant. (In the NA28 this variant reading comes in the second portion of v. 7; hence, I refer to the location of this variant as v. 7b throughout this discussion. However, in some English translations [e.g., NIV, ESV], the variant appears in the first portion of v. 7.)")])]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("The well-known text-critical issue in v. 7b is whether to read “but we became "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἤπιοι")]), _vm._v(" ["), _c('i', [_vm._v("ēpioi,")]), _vm._v(" ‘gentle’]” or “but we became "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("νήπιοι")]), _vm._v(" ["), _c('i', [_vm._v("nēpioi,")]), _vm._v(" ‘infants’].”")]), _c('a', {
    attrs: {
      "id": "fn149"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149")])]), _vm._v(" The external evidence is overwhelmingly in favor of the latter reading,"), _c('a', {
    attrs: {
      "id": "fn150"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150")])]), _vm._v(" which is clearly the more difficult. Hence, the two major Greek editions of the NT (NA28 and "), _c('i', [_vm._v("GNT")]), _c('sup', [_vm._v("4")]), _vm._v(") adopt it, but the overwhelming majority of English translations have adopted the former,"), _c('a', {
    attrs: {
      "id": "fn151"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("151")])]), _vm._v(" as well as the majority of commentators."), _c('a', {
    attrs: {
      "id": "fn152"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("152")])]), _vm._v(" The primary reason for adopting “gentle” has to do with internal consistency of context; that is, it would be awkward for Paul to say, “We became infants among you, like a nurse.”"), _c('a', {
    attrs: {
      "id": "fn153"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("153")])]), _vm._v(" There is no doubt that Paul’s use of these two metaphors together does have a jarring rhetorical impact. But that is not necessarily a reason for overriding the considerable external evidence. It may in fact be part of the rhetorical point. Hence, with a growing number of interpreters,"), _c('a', {
    attrs: {
      "id": "fn154"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("154")])]), _vm._v(" I will assume that "), _c('i', [_vm._v("nēpioi")]), _vm._v(" is the preferred reading in v. 7b.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Given this reading, we punctuate v. 7 with a full stop between 7b and 7c: “But we became infants in your midst. As a nurse taking care of her own children, so we. . . .”"), _c('a', {
    attrs: {
      "id": "fn155"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("155")])]), _vm._v(" Verse 3 contains three negative statements forming the first member of an antithesis indicating what Paul’s initial exhortation was not. "), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("It is immediately followed by a contrasting "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀλλά")]), _vm._v(" ("), _c('i', [_vm._v("alla,")]), _vm._v(" “but”) at the beginning of v. 4, which goes on to indicate what Paul’s initial exhortation and customary way of speaking are. Similarly, vv. 5–7a contain three more negative statements (each with an aside) that indicate what Paul’s visit was not like. We then have another contrasting "), _c('i', [_vm._v("alla")]), _vm._v(" at the beginning of v. 7b. Verses 7b–8 then go on to indicate what Paul’s visit was like, using two different metaphors (infants, a nurse) that are related in some way. Based on these considerations, the best structuring and punctuation of vv. 5–8 are as follows:")]), _c('a', {
    attrs: {
      "id": "fn156"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("156")])])]), _vm._v(" "), _c('p', {
    staticClass: "Hang1a"
  }, [_vm._v("For we never came with flattering speech ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐν λόγῳ κολακείας")]), _vm._v(", "), _c('i', [_vm._v("en logō kolakeias")]), _vm._v("],")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("just as you all know,")]), _vm._v(" "), _c('p', {
    staticClass: "Hang1"
  }, [_vm._v("nor with a false motive, namely, greed")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("—God is a witness—")]), _vm._v(" "), _c('p', {
    staticClass: "Hang1"
  }, [_vm._v("nor did we come demanding public honor from people, neither from you or from others,")]), _vm._v(" "), _c('p', {
    staticClass: "Hang2"
  }, [_vm._v("although we could have thrown our weight around"), _c('a', {
    attrs: {
      "id": "fn157"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("157")])]), _vm._v(" as apostles of Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang1"
  }, [_vm._v("But we became infants in your midst.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang1"
  }, [_vm._v("Like a nurse taking care of her own children,")]), _vm._v(" "), _c('p', {
    staticClass: "Hang1"
  }, [_vm._v("so we,")]), _vm._v(" "), _c('p', {
    staticClass: "Quote2"
  }, [_vm._v("because we cared so much for you,")]), _vm._v(" "), _c('p', {
    staticClass: "Quote3"
  }, [_vm._v("were pleased to share with you")]), _vm._v(" "), _c('p', {
    staticClass: "Quote4"
  }, [_vm._v("not only the good news from God,")]), _vm._v(" "), _c('p', {
    staticClass: "Quote4"
  }, [_vm._v("but also our very selves")]), _vm._v(" "), _c('p', {
    staticClass: "Quote2"
  }, [_vm._v("because we had come to love you so.")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Paul begins v. 5 with another “for,” signaling that he is about to elaborate on his typical manner of speaking. Street-corner orators and philosophers were often accused of speaking with effusive flattery ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("κολακεία")]), _vm._v(", "), _c('i', [_vm._v("kolakeia")]), _vm._v(") when trying to butter up their audience in pursuit of money and honor ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δόξα")]), _vm._v(", "), _c('i', [_vm._v("doxa")]), _vm._v(")."), _c('a', {
    attrs: {
      "id": "fn158"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("158")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("In fact, when an itinerant Sophist came into a city, the first speech he was expected to give was one praising the audience that was characterized by effusive flattery ("), _c('i', [_vm._v("kolakeia")]), _vm._v("). Hence, the following three negative statements are closely bound together, with the first describing an activity directed toward pursuing what Paul denies he was after in the next two, namely, financial gain and public honor or reputation.")])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("Rather than trying to please his audience by flattering them (see v. 4), like a true friend, he spoke to them with "), _c('i', [_vm._v("parrēsia")]), _vm._v(" (i.e., boldness, frankness), as he had already reminded them in v. 2.")]), _c('a', {
    attrs: {
      "id": "fn159"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("159")])]), _vm._v(" He openly and publicly told them the truth about their situation of enslavement to idols rather than to the living and true God of Israel, who had declared Jesus as the world’s true Lord. This is something they know very well. By contrast, speech characterized by effusive flattery would have been out of sync with the very essence of the good news and would have signaled that they had indeed come to the audience “with a false motive, namely, greed.”"), _c('a', {
    attrs: {
      "id": "fn160"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("160")])]), _vm._v(" Unlike the charlatan orators, Paul was not out for financial gain. While his public actions indicate that his inner motive for coming to the audience was not greed, in a second aside he stresses that the God who continuously tests his heart is a witness to this fact as well. Rather than signaling that Paul is defending himself against charges made against him, Paul’s invocation of God as witness may simply be a part of the overall pattern of behavior he wishes to instill in an audience called to participate in the "), _c('i', [_vm._v("missio Dei.")]), _c('a', {
    attrs: {
      "id": "fn161"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("161")])]), _vm._v(" That is, for those so called, it is imperative, not only that their public practices testify to the purity of their motives, but that they are not hesitant to call upon God publicly as a witness to that purity.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In a third negative statement, Paul asserts that he did not come demanding public honor ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δόξα")]), _vm._v(", "), _c('i', [_vm._v("doxa")]), _vm._v(") from them or from anyone. He follows up with the parenthetical comment “although we could have thrown our weight around as apostles of Christ.” This phrase could refer to (1) the right that Paul might have had to demand honor from the audience based on his apostolic authority, (2) the right that he may have had to burden them financially, or (3) both."), _c('a', {
    attrs: {
      "id": "fn162"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("162")])]), _vm._v(" On the one hand, the literary pattern of the passage (denial followed by an aside) suggests that option 1 is the primary referent of this clause."), _c('a', {
    attrs: {
      "id": "fn163"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("163")])]), _vm._v(" On the "), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("other, since effusive flattery was often directed toward achieving both honor and money from others, and since Paul had just denied in 2:5 that his motive was financial greed, it is probable that money is at least a secondary connotation of this phrase. In any case, the first and only time Paul uses the word “apostle” in this letter (and the first time in his extant writings), it is in a clause indicating that apostles of the Lord of the cosmos have a right to make weighty demands on those to whom they speak, including the demand to be treated with public honor and probably to be financially supported by others. But the concessive nature of the clause matches the concessive nature of the first line in Paul’s master story of the Lord they represent, “who, although he was in the form of God, did not . . .” (Phil 2:6). Like the Lord he represents, Paul does not exercise his authority as an apostle in demanding honor that may rightfully be due him.")]), _c('a', {
    attrs: {
      "id": "fn164"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("164")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In contrast"), _c('a', {
    attrs: {
      "id": "fn165"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("165")])]), _vm._v(" to this sort of deceptive pattern of behavior that seeks to exploit others for financial gain and public honor and reputation, Paul says, “We became infants in your midst.” As in 1 Cor 14:20, where Paul counsels the audience to “be infants ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("νηπιάζετε")]), _vm._v(", "), _c('i', [_vm._v("nēpiazete")]), _vm._v("] with respect to evil,” the immediate context here constrains the sort of conventional characteristics associated with infants that come into play. Here, Paul’s point is that, "), _c('i', [_vm._v("with respect to")]), _vm._v(" the lack of exploitative behavior and motives related to money and seeking public honor and reputation, he and his companions “became infants.” To use language from Philippians (e.g., 2:5), the metaphor underscores "), _c('i', [_vm._v("the lack")]), _vm._v(" of a particular mind-set ("), _c('i', [_vm._v("phronēsis")]), _vm._v(") in one who goes by the designation of apostle. However, it does not function well to emphasize the positive content of the apostolic mind-set. Hence, in the next sentence, he swiftly changes metaphors to do just that, comparing their conduct among the audience to the way a nurse would care for her own children.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In Paul’s social context, the nurse metaphor"), _c('a', {
    attrs: {
      "id": "fn166"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("166")])]), _vm._v(" would evoke images of a beloved, kind, and generous figure who was responsible for the daily care of infants and young children. But often, in what approximated a kinship relationship, she stayed on as an attendant for young women, and the young men she had helped raise continued to have warm affection for her."), _c('a', {
    attrs: {
      "id": "fn167"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("167")])]), _vm._v(" Whether or not “her own children” refers to the nurse’s own biological children or simply the children she is contractually responsible to care for, the effect of referring to the "), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("nurse’s own children is to intensify the metaphor.")]), _c('a', {
    attrs: {
      "id": "fn168"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("168")])]), _vm._v(" What follows in v. 8 is a natural outflow of this image in which Paul describes their care for the audience as exhibited by their sharing, not only the good news of God with them, but indeed their very lives, once again underscoring the inseparability of speaking the good news and embodying it. Paul and his companions had come to love this Gentile audience because God had taken the initiative and made them God’s own beloved (1:4), Israel-like community.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Verse 9 gives evidence for, or at least explicates, Paul’s claim in v. 8. In this connection, Paul appeals to the memory that his brothers and sisters in Thessalonica have of his and his associates’ labor ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("κόπος")]), _vm._v(", "), _c('i', [_vm._v("kopos")]), _vm._v(") and toil ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("μόχθος")]), _vm._v(", "), _c('i', [_vm._v("mochthos")]), _vm._v(") and of their working ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐργαζόμενοι")]), _vm._v(", "), _c('i', [_vm._v("ergazomenoi")]), _vm._v(") throughout the night and day (cf. 2 Thess 3:8; 2 Cor 11:27). There is little difference in the meaning of these three terms, all of which denoted manual labor (see comments on 1:3). As such, they would have carried the connotation of burdensome, low-status (at least from the standpoint of the elite) activity requiring exertion and hardship, the kind of activity carried on by slaves and artisans. While he does not explicitly describe this activity as “working with our own hands,” it is clearly to be assumed (cf. the explicit language of 1 Cor 4:12) and is the basis on which he can exhort the audience in 4:11 to “continue working with your own hands,” presumably as 1:3 depicts them as doing. Paul would have worked as a tentmaker (Acts 18:3), which would typically involve long hours. Although he could have insisted on his rights as an apostle,"), _c('a', {
    attrs: {
      "id": "fn169"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("169")])]), _vm._v(" he chose to engage in activity associated with low status (a practice that, from the standpoint of the elite, apparently reflects poorly on the status of those who are taught by such a person; note the implications of 1 Cor 9:1–18, esp. v. 6).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Giving up such rights for the sake of others and engaging in such strenuous, low-status activity was intimately connected with their proclamation of the good news of God. It showed them to be “the sort of people” whose lives displayed the very pattern of the good news they proclaimed (1:5c). “We proclaimed to you the gospel from God by means of working night and day in order not to burden any of you.”"), _c('a', {
    attrs: {
      "id": "fn170"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("170")])]), _vm._v(" The actions in which they were engaged "), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("exemplified the logic of the good news they proclaimed. Hence, the actions of Paul and his companions simultaneously exhibit both their faithfulness ("), _c('i', [_vm._v("pistis")]), _vm._v(") to the God who called them to proclaim this good news and their cruciform actions of love ("), _c('i', [_vm._v("agapē")]), _vm._v(") toward others. While "), _c('i', [_vm._v("pistis")]), _vm._v(" and "), _c('i', [_vm._v("agapē")]), _vm._v(" can be distinguished, they cannot be separated.")])]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("Paul goes on in 2:10 to call on his audience and, once again, on God (see v. 5) as witnesses that his behavior, and also that of Silas and Timothy, was not only “holy ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ὁσίως")]), _vm._v(", "), _c('i', [_vm._v("hosiōs")]), _vm._v("] and righteous/just ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δικαίως")]), _vm._v(", "), _c('i', [_vm._v("dikaiōs")]), _vm._v("]” but also “blameless ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀμέμπτως")]), _vm._v(", "), _c('i', [_vm._v("amemptōs")]), _vm._v("],” a word whose adjectival form occurs also in 3:13. This is the only time in 1 or 2 Thessalonians that a cognate of "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δικαιοσύνη")]), _vm._v(" ("), _c('i', [_vm._v("dikaiosynē,")]), _vm._v(" “righteousness/justice”) appears, leading many to observe that justification as such is not an issue in the Thessalonian correspondence.")]), _c('a', {
    attrs: {
      "id": "fn171"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("171")])]), _vm._v(" In the LXX and the NT the cognate noun of "), _c('i', [_vm._v("hosiōs,")]), _vm._v(" "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ὁσιότης")]), _vm._v(" ("), _c('i', [_vm._v("hosiotēs,")]), _vm._v(" “holiness”), often appears in the same context as "), _c('i', [_vm._v("dikaiosynē")]), _vm._v(" or one of its cognates. The terms are used once metaphorically, together with “wrath,” to describe the Divine Warrior’s armor, which God dons to engage in salvific "), _c('i', [_vm._v("activity")]), _vm._v(" (Wis 5:17–20)."), _c('a', {
    attrs: {
      "id": "fn172"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("172")])]), _vm._v(" In Deut 32:4b they are used specifically to describe the covenant God’s character: “God is faithful . . . the Lord is righteous ["), _c('i', [_vm._v("dikaios")]), _vm._v("] and holy ["), _c('i', [_vm._v("hosios")]), _vm._v("].”"), _c('a', {
    attrs: {
      "id": "fn173"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("173")])]), _vm._v(" The character and activity of God as “righteous and holy” is what humans were created to reflect in the biblical tradition (e.g., cf. Wis 9:3 with Eph 4:24).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Hence, while the terms “holily” ("), _c('i', [_vm._v("hosiōs")]), _vm._v(") and “justly” ("), _c('i', [_vm._v("dikaiōs")]), _vm._v(") may simply refer to Paul’s and his companions’ keeping divine and human law respectively,"), _c('a', {
    attrs: {
      "id": "fn174"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("174")])]), _vm._v(" given the focus on the audience’s holiness in this letter, we may have warrant for taking Paul’s use of them together as going further. Whether or not Paul intends it, this description of his behavior correlates with the way the character and activity of God are described in other texts. It is no surprise that to act this way is part and parcel of acting “blamelessly,” a term that Paul uses in 3:13 and 5:23 when he prays for his audience to be blameless "), _c('i', [_vm._v("in reference to holiness.")]), _vm._v(" Conduct analogous to that of Paul is therefore the standard for what it means to be found “blameless” in holiness at the eschaton. It sums up the expanded description in this chapter of Paul’s reference in 1:5 to the “sort of "), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("people we became among you all on your account” (1:5c). That is, Paul and his companions were the sort of people who not only proclaimed the gospel but embodied the character and image of the God who was its source, thereby reflecting God’s goal for humanity, that is, to be reshaped into God’s own image as displayed in his Son.")]), _c('a', {
    attrs: {
      "id": "fn175"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("175")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In v. 11 again Paul uses the rhetorical “just as you all know,” now narrowing it to “each one of you.” What they know is that Paul engaged in three sorts of actions, just as a father would with each of his children: exhorting/encouraging, comforting, and testifying. Paul continues using familial language for his beloved “brothers and sisters” but now switches imagery to that of the relationship of children to their father. In 1 Cor 4:14–16 his claim to be a father to the Corinthians warrants (note the “therefore” in v. 16) his explicitly exhorting that audience to become imitators of him."), _c('a', {
    attrs: {
      "id": "fn176"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("176")])]), _vm._v(" The widespread assumption that a father serves as an example to his children"), _c('a', {
    attrs: {
      "id": "fn177"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("177")])]), _vm._v(" supports the contention that this whole section functions to provide a model for the behavior Paul wants the audience to (continue to) exhibit."), _c('a', {
    attrs: {
      "id": "fn178"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("178")])]), _vm._v(" He will, in fact, go on to speak about the audience exhorting/encouraging and comforting each other (4:18; 5:11; 14), as he describes himself as doing here in v. 11.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The explicit purpose for Paul’s fatherly actions is that “you might continue walking ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("περιπατεῖν")]), _vm._v(", "), _c('i', [_vm._v("peripatein")]), _vm._v("] worthily of the God who is calling ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("καλοῦντος")]), _vm._v(", "), _c('i', [_vm._v("kalountos")]), _vm._v("] you all into his own kingdom and honor/glory.” The present tense of the participle, “calling” ("), _c('i', [_vm._v("kalountos")]), _vm._v("), indicates that there is something continuous about God’s calling. And since election and calling for Paul are functionally equivalent (see comments on 1:4), the audience’s calling/election is not a onetime event but rather an ongoing covenantal reality. In divine love, God sovereignly (and surprisingly) continues calling these Gentiles in Thessalonica into his own kingdom and honor/glory. And as the present tense of the infinitive, “walking ("), _c('i', [_vm._v("peripatein")]), _vm._v("),” indicates, Paul depicts the audience’s response to this calling as the appropriate ongoing covenantal response, that is, they are continuing to walk worthily of the God who is calling them (cf. Phil 1:27; Col "), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("1:10).")]), _c('a', {
    attrs: {
      "id": "fn179"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("179")])]), _vm._v(" While the "), _c('i', [_vm._v("ekklēsia")]), _vm._v(" is clearly dependent on the Spirit for this response, it is important to note that Paul depicts their ongoing appropriate response as also dependent on his actions. While it may be distinguishable from them, the Spirit’s enabling is not separate from the very human actions (v. 12a) through which enabling grace flows to the church.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("God is calling the church into his own kingdom/reign ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("βασιλείαν")]), _vm._v(", "), _c('i', [_vm._v("basileian")]), _vm._v(")"), _c('a', {
    attrs: {
      "id": "fn180"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("180")])]), _vm._v(" and honor/glory ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δόξαν")]), _vm._v(", "), _c('i', [_vm._v("doxan")]), _vm._v("). While the language of the kingdom ("), _c('i', [_vm._v("basileia")]), _vm._v(") of God is prevalent in the Synoptic Gospels, Paul does not use it often."), _c('a', {
    attrs: {
      "id": "fn181"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("181")])]), _vm._v(" He uses "), _c('i', [_vm._v("doxa")]), _vm._v(" (honor/glory) and its cognates more frequently."), _c('a', {
    attrs: {
      "id": "fn182"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("182")])]), _vm._v(" Often, as in ancient honor discourse, he uses it or its cognates to refer to ascribed honor based on social status in reference either to humans (e.g., 1 Thess 2:6) or to God (Rom 1:21; 4:20). When he uses it in eschatological contexts as here and 2 Thess 1:9, however, there is also an ontological aspect to the language of "), _c('i', [_vm._v("doxa")]), _vm._v(" (glory/honor). This audience is being called into God’s own glory ("), _c('i', [_vm._v("doxa")]), _vm._v("). In the LXX and other ancient Jewish writings, God’s glory ("), _c('i', [_vm._v("doxa")]), _vm._v(") refers to God’s radiant divine presence (Exod 16:7)."), _c('a', {
    attrs: {
      "id": "fn183"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("183")])]), _vm._v(" While visible radiance remains as an aspect of "), _c('i', [_vm._v("doxa")]), _vm._v(" in Paul’s letters, in eschatological contexts he constantly connects the term with incorruption and life, with the additional nuance of elevated status."), _c('a', {
    attrs: {
      "id": "fn184"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("184")])]), _vm._v(" For the audience to participate in God’s own "), _c('i', [_vm._v("doxa,")]), _vm._v(" then, would mean not only God’s granting public honor to them at the consummation of his kingdom but also fully sharing in the divine attributes of the "), _c('i', [_vm._v("living")]), _vm._v(" God to whom they had turned, that is, incorruption and life. Blackwell summarizes the point as follows: “In these ontological contexts glory denotes the honourable status of incorruption, and in its verbal form it denotes the divine action of granting incorruption with honour to believers in their physical resurrection.”"), _c('a', {
    attrs: {
      "id": "fn185"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("185")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul explicitly enlarges upon the language of 2:12 in 2 Thess 1:3–12. In that "), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("context, immediately prior to vv. 11–12, he rehearses an eschatological scenario in which he describes the audience as currently suffering so that they “might be recognized as "), _c('i', [_vm._v("worthy")]), _vm._v(" of the kingdom of God” (v. 5). Then in v. 11 Paul says that he is praying constantly that the Thessalonians “might be "), _c('i', [_vm._v("worthy")]), _vm._v(" of the calling of our God,” almost assuredly a calling into his kingdom, as v. 5 implies. He also refers to the Lord’s coming to be honored ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐνδοξασθῆναι")]), _vm._v(", "), _c('i', [_vm._v("endoxasthēnai")]), _vm._v(") by his holy ones (1:10), including his audience, who will bring honor ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐνδοξασθῇ")]), _vm._v(", "), _c('i', [_vm._v("endoxasthē")]), _vm._v(") to his name as they themselves are honored in him (v. 12) at his coming. Hence, the eschatological scenario in 2 Thess 1:3–12 vividly portays the culmination of God’s call of this audience into his own kingdom and glory/honor.")])]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("As we will see, while there are no explicit verbal connections between 2:12 and 4:13–18, Paul’s depiction of the Lord’s royal coming ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("παρουσία")]), _vm._v(", "), _c('i', [_vm._v("parousia")]), _vm._v(") in that context is also a dramatic portrayal of this culmination of God’s calling of this audience into his own kingdom and glory/honor. While neither here nor there does Paul give an explicit, lengthy description of the nature of the kingdom of God, what he does say does not lead to the impression that he understood it in terms of “celestial existence,” as a “going to heaven” (see the comments on 4:13–18). In fact, as we have seen, the political setting of Paul’s activities in Thessalonica suggests that such “kingdom” language would have at least initially been heard by the audience as politically loaded language standing in at least some tension with (if not opposition to) the Roman imperial order. Given that Paul is addressing an alternative assembly ("), _c('i', [_vm._v("ekklēsia")]), _vm._v(") as they await the "), _c('i', [_vm._v("descent")]), _vm._v(" from heaven of the true Lord ("), _c('i', [_vm._v("kyrios")]), _vm._v(") as in 4:13–17, it could hardly have been heard otherwise, particularly since he will fully and finally place all enemies under Christ’s feet (1 Cor 15:25), including any imperial enemies who refuse to recognize his lordship. But the present tense nature of God’s calling, the fact that it is ongoing, should not be forgotten. Being continuously called into this God’s kingdom points to the primary mission of the church, namely, to put God’s empire or reality on display in their daily flesh and blood life, together modeling his final salvific intent for humanity (and the entire creation)")]), _c('a', {
    attrs: {
      "id": "fn186"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("186")])]), _vm._v("—to share in divine glory (Rom 8:21).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Before leaving this context, we should also note the connection between glory/honor ("), _c('i', [_vm._v("doxa")]), _vm._v(") and holiness. This is an audience whom Paul has described as being “in God” at the beginning of the letter (1 Thess 1:1). Hence, sharing in his divine glory characterized by incorruption and life is precisely the outcome of inhabiting this cruciform, living God (see comments on 1:1), who continuously provides his life-giving "), _c('i', [_vm._v("Holy")]), _vm._v(" Spirit “into” this congregation (4:8). In the OT the glory that is the visible presence of Israel’s holy God is also, in essence, "), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_c('i', [_vm._v("holiness made visible.")])]), _c('a', {
    attrs: {
      "id": "fn187"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("187")])]), _vm._v(" Note, for example, the clear parallels between holiness and glory/honor in the following passages:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Among/by those drawing near to me [says the Lord], I will be "), _c('b', [_c('i', [_vm._v("shown holy/sanctified")])]), _vm._v(", that is, among/by the whole congregation I will be "), _c('b', [_c('i', [_vm._v("glorified/honored")])]), _vm._v(" ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δοξασθήσομαι")]), _vm._v(", "), _c('i', [_vm._v("doxasthēsomai")]), _vm._v("]. (Lev 10:3 LXX)")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_c('b', [_c('i', [_vm._v("Holy, holy, holy")])]), _vm._v(" ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἅγιος")]), _vm._v(", "), _c('i', [_vm._v("hagios,")]), _vm._v(" 3x) is the Lord Sabaoth; the whole earth is full of his "), _c('b', [_c('i', [_vm._v("glory")])]), _vm._v(" ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δόξης")]), _vm._v(", "), _c('i', [_vm._v("doxēs")]), _vm._v("]. (Isa 6:3 LXX)")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Hence, as this audience shares in the "), _c('i', [_vm._v("doxa")]), _vm._v(" of God in participating in the Lord’s royal coming (parousia), they will reflect what their Spirit-empowered life together has been in the process of becoming, that is, a visible, public display of the very character and holiness of the Lord they meet. They will be shown to be what they will have become by grace, “blameless in holiness” (3:13), and by the culminating “making-alive” actions of the Spirit,"), _c('a', {
    attrs: {
      "id": "fn188"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("188")])]), _vm._v(" their sanctification will be complete. As a redeemed people, they will, “in the eschaton, fully reflect the glory, or reality, of God.”"), _c('a', {
    attrs: {
      "id": "fn189"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("189")])])]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "s09"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s09"
    }
  }, [_c('i', [_vm._v("2:13–16"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Thanksgiving for God’s Word at Work: Imitating Faithful, Persecuted Jewish Churches in Judea")])])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('sup', [_vm._v("13")]), _vm._v("Now we ourselves are also thanking God over and over because of this:"), _c('a', {
    attrs: {
      "id": "fn190"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("190")])]), _vm._v(" when you all received the message from God by hearing it from us,"), _c('a', {
    attrs: {
      "id": "fn191"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("191")])]), _vm._v(" you welcomed it for what it truly is, God’s own word, not some mere human word. And it is continuing to work among/by means of you all who are exercising believing allegiance. "), _c('sup', [_vm._v("14")]), _vm._v("This is evident, brothers and sisters, in the way that you yourselves became imitators of "), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("the churches of God who are in Judea in Christ Jesus, because you yourselves also suffered the same things by your own compatriots, just as they themselves also [suffered] by the Judeans "), _c('sup', [_vm._v("15")]), _vm._v("who killed both the Lord Jesus and the prophets and persecuted us. They are not pleasing to God and oppose all people "), _c('sup', [_vm._v("16")]), _vm._v("by hindering us from speaking to the Gentiles in order that they might be saved. The result of this is that they are constantly filling up the cup of their sins to the brim. But [God’s] wrath has come upon them to the end.")]), _c('a', {
    attrs: {
      "id": "fn192"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("192")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("In v. 13 Paul renews his thanksgiving for the audience."), _c('a', {
    attrs: {
      "id": "fn193"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("193")])]), _vm._v(" The first thanksgiving in 1:2–10 emphasized the Spirit-empowered way the gospel came to them (v. 5) and what the audience themselves became as a result of their reception of this good news (vv. 6–10), namely, a faithful public witness elected to be a channel of the "), _c('i', [_vm._v("missio Dei.")]), _vm._v(" As we noted earlier, in 1 Thessalonians Paul uses “message/word” ("), _c('i', [_vm._v("logos")]), _vm._v(") synonymously with “gospel.” Although here in 2:13 the primary emphasis seems to be on their initial reception of that message, a pattern similar to that of the first thanksgiving is nonetheless discernable. Here Paul emphasizes that it was God’s own message that they received in the apostolic message. As noted in the comments on 1:5–8, God’s message, or gospel, was (at least partially) a message about "), _c('i', [_vm._v("pistis")]), _vm._v(" (i.e., the "), _c('i', [_vm._v("fidelity")]), _vm._v("/"), _c('i', [_vm._v("trust")]), _vm._v(" of Jesus Christ; cf. Gal 3:2, 5)."), _c('a', {
    attrs: {
      "id": "fn194"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("194")])]), _vm._v(" This message is also the instrument through which God evokes an analogous "), _c('i', [_vm._v("pistis")]), _vm._v(" (fidelity/trust/believing allegiance) in its hearers (Rom 10:16–17)."), _c('a', {
    attrs: {
      "id": "fn195"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("195")])]), _vm._v(" Hence, the audience’s reception of the divine "), _c('i', [_vm._v("logos")]), _vm._v(" (message) in the apostolic message as truly God’s own message has resulted in a divine power at work as they are exercising believing allegiance. The sentence structure in Greek makes it slightly ambiguous whether God himself or God’s message ("), _c('i', [_vm._v("logos")]), _vm._v(") is the referent of this divine power."), _c('a', {
    attrs: {
      "id": "fn196"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("196")])]), _vm._v(" In reality, the "), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_vm._v("two cannot be easily separated, but the syntax of the sentence and the context favor the latter.")]), _c('a', {
    attrs: {
      "id": "fn197"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("197")])]), _vm._v(" In the first thanksgiving section it was the Spirit shaping the audience in ways that paralleled the content of the gospel that came to them in the apostles’ message (1:5). In this renewed thanksgiving, the pattern is similar, but here it is God’s own message ("), _c('i', [_vm._v("logos")]), _vm._v(") that Paul describes as the active power at work in ways that enable those who receive it to embody its very shape, that is, the shape of the good news it announces. Not surprisingly, God’s message ("), _c('i', [_vm._v("logos")]), _vm._v("), like God’s Spirit, is a dynamic force accomplishing that for which God sends it forth (Isa 55:11).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul says that this divine message is at work in/among/by means of ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐν ὑμῖν")]), _vm._v(", "), _c('i', [_vm._v("en hymin")]), _vm._v(") those exercising believing allegiance. There can be no doubt that this divine message/power is currently operative, reshaping the identity of each person in the congregation and that of the assembly as a whole. Since persons become who they are within webs of relationships, God’s shaping power must be conceived as being at work both within persons and among them in their life together if there is to be a reshaping of their individual and corporate identity."), _c('a', {
    attrs: {
      "id": "fn198"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("198")])]), _vm._v(" However, since in the very next verse, the emphasis is on their becoming imitators of corporate assemblies in Judea (v. 14), the primary point here is that this divine power is at work in their "), _c('i', [_vm._v("corporate life together.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Given the suffering their public witness is apparently invoking (v. 14), it is quite possible that the phrase "), _c('i', [_vm._v("en hymin")]), _vm._v(" might be taken instrumentally. That is, this gospel-shaped divine power is now at work "), _c('i', [_vm._v("by means of")]), _vm._v(" their life together as they are engaged in God’s mission to their surrounding culture. At the very least, the way that Paul weaves a connection between God’s "), _c('i', [_vm._v("logos")]), _vm._v(" continuing to work among/by means of them (v. 13c) and their faithful suffering at the hands of their fellow Thessalonians (v. 14a) implies that the result of God’s "), _c('i', [_vm._v("logos")]), _vm._v(" working among them, enabling them to exercise believing allegiance, has generated opposition to such fidelity. The translation of v. 14a as “this is evident ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("γάρ")]), _vm._v(", "), _c('i', [_vm._v("gar")]), _vm._v("] . . . in the way that” is an attempt to make this rhetorical connection clear. Hence, the effects of God’s "), _c('i', [_vm._v("logos")]), _vm._v(" at work among them have spilled over into the public square, provoking opposition to their witness to the “"), _c('i', [_vm._v("logos")]), _vm._v(" about the Lord” that has rung forth from them and continued its reverberations into their surrounding locale (i.e., Macedonia and Achaia, 1:8). Although vv. 14–16 are undeniably difficult and caustic in tone, they are anchored in their context by the rhetorical connection Paul makes between them and the flow of thought in this renewed thanksgiving in v. 13.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But two broader issues complicate matters as we approach vv. 14–16. "), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_vm._v("First, the way some Christians have used these verses for anti-Jewish")]), _c('a', {
    attrs: {
      "id": "fn199"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("199")])]), _vm._v(" or anti-Semitic purposes calls for caution in their interpretation. Second, most interpreters sense that there is a tension, if not an outright conflict, between what Paul says about “the Jews” in this context and what he says about Israel later in Rom 9–11. Interpreters generally attempt to deal with these two issues in one of two ways: either by arguing that, for stylistic, historical, and mostly theological reasons, all or usually some portion of vv. 13–16 is a post-Pauline interpolation,"), _c('a', {
    attrs: {
      "id": "fn200"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("200")])]), _vm._v(" or by taking the verses as Pauline and attempting to harmonize them with Rom 9–11 (particularly 9:1–5; 11:1–2, 11, 25–32)."), _c('a', {
    attrs: {
      "id": "fn201"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("201")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("With regard to the interpolation hypothesis, along with almost all other English commentaries,"), _c('a', {
    attrs: {
      "id": "fn202"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("202")])]), _vm._v(" my position is that these verses are authentically Pauline. As noted immediately above, the rhetorical connection between vv. 13 and 14 makes it clear that these verses are not “out of place.” In addition, there is no manuscript evidence either for the absence of these verses or for their being located in any other place in the letter besides where they presently are. In other words, we know of no other version of 1 Thessalonians that ever had a shaping influence on a Christian community. But having said that, I will not attempt to harmonize these verses with Paul’s more positive statements about his fellow Jews in Rom 9–11"), _c('a', {
    attrs: {
      "id": "fn203"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn203",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("203")])]), _vm._v(" but will argue that the tension between these passages might generate fruitful theologcal reflection. I will return to this latter issue after commenting further on vv. 14–16.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As we just noted, vv. 13–14 are connected by the initial “for” in v. 14, linking the public suffering that Paul refers to in v. 14 with the audience’s participation in the "), _c('i', [_vm._v("missio Dei,")]), _vm._v(" that is, with the message ("), _c('i', [_vm._v("logos")]), _vm._v(") of God continuing to work among/by means of them. Believing allegiance lived out in a context hostile to the claim that Israel’s God was definitively revealed in and as a crucified Lord/messiah can result only in some form of suffering (3:4), whether that context is Thessalonica or Judea. Having already described the audience as being “imitators of us and of the Lord” (1:6), Paul now says that this Gentile "), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("audience became “imitators of the churches of God in Judea in Messiah Jesus.” These assemblies in Judea are clearly composed "), _c('i', [_vm._v("of Jews")]), _vm._v(" who now assemble “in the sphere of Messiah Jesus” (cf. Gal 1:22). Hence, Paul connects the corporate life of this Gentile assembly closely with the corporate life of Jewish assemblies, both of whom, out of fidelity to God, have “suffered the same things”—the Thessalonians at the hands of their own compatriots ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("συμφυλετῶν")]), _vm._v(", "), _c('i', [_vm._v("symphyletōn")]), _vm._v(")")]), _c('a', {
    attrs: {
      "id": "fn204"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn204",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("204")])]), _vm._v(" and the Jewish assemblies in Messiah at the hands of Jews/Judeans ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("Ἰουδαίων")]), _vm._v(", "), _c('i', [_vm._v("Ioudaiōn")]), _vm._v(")."), _c('a', {
    attrs: {
      "id": "fn205"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("205")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Two points should be stressed here. First, the rhetorical effect of making this connection is to strengthen the audience’s resolve toward continued fidelity in their public life together. "), _c('i', [_vm._v("This is the primary purpose for Paul’s introducing the whole topic.")]), _vm._v(" Second, whether he intends it or not, this language in Paul’s very first letter sews together Jews and Gentiles “in the sphere of Messiah Jesus” by making the point that the corporate life of these Gentiles in Christ bears analogy to the corporate life of Jews in Christ in another geographic location. While they are separated by distance and located in very different social contexts, they both are publicly faithful to the same God and thus are already moving toward Paul’s vision of Jews and Gentiles together in Christ—distinguishable, yet one people of God—giving honor “with one mouth” to “the God and Father of our Lord Jesus Christ” (Rom 15:6). In light of the caustic language that follows in vv. 15–16, it is essential to keep both these points in mind.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul’s polemical description in the verses that follow is clearly hyperbolic"), _c('a', {
    attrs: {
      "id": "fn206"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("206")])]), _vm._v(" and, as such, not out of place in intra-Jewish polemic of the first century. Verses 15–16b constitute one long descriptive dependent clause modifying the word Jews/Judeans ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("Ἰουδαίων")]), _vm._v(", "), _c('i', [_vm._v("Ioudaiōn")]), _vm._v(") at the end of v. 14. Both the "), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("NA"), _c('sup', [_vm._v("28")]), _vm._v(" and the "), _c('i', [_vm._v("GNT")]), _c('sup', [_vm._v("4")]), _vm._v(" have a comma between "), _c('i', [_vm._v("Ioudaiōn")]), _vm._v(" and the long dependent clause that follows. By grammatical convention, this encourages a nonrestrictive reading of what follows the comma, that is, making everything that follows somehow applicable to all Jews in general. Contemporary English translations are mixed in terms of whether (and how) they encourage nonrestrictive or restrictive readings of vv. 15–16b.")]), _c('a', {
    attrs: {
      "id": "fn207"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn207",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("207")])]), _vm._v(" There were, of course, no punctuation marks in early Greek manuscripts, and the choice of whether to place a punctuation mark between vv. 14 and 15 is an "), _c('i', [_vm._v("interpretive")]), _vm._v(" decision—even at times, as perhaps in this case with the insertion of a comma, one unconsciously reflecting a "), _c('i', [_vm._v("theological")]), _vm._v(" point of view. There is, however, no particular necessity to place a comma in the text at this point and some compelling reasons not to do so (on which, see below)."), _c('a', {
    attrs: {
      "id": "fn208"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn208",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("208")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The absence of a comma after "), _c('i', [_vm._v("Ioudaiōn")]), _vm._v(" encourages a restrictive reading of what comes after it. That is, what follows in vv. 15–16b is in reference to one "), _c('i', [_vm._v("specific")]), _vm._v(" group of Jews, namely, certain Judean Jews who violently opposed Jesus and his early (Jewish) followers."), _c('a', {
    attrs: {
      "id": "fn209"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("209")])]), _vm._v(" Paul describes these particular Jews with four descriptive phrases, the third and fourth of which are best taken together."), _c('a', {
    attrs: {
      "id": "fn210"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn210",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("210")])]), _vm._v(" In the first of these, Paul says that they “killed both the Lord Jesus and the prophets.”"), _c('a', {
    attrs: {
      "id": "fn211"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("211")])]), _vm._v(" While he clearly knows that the Roman political powers carried out Jesus’ crucifixion (i.e., “the rulers of this age,” 1 Cor 2:8), in line with and probably relying on early Christian tradition (Acts 2:36; 3:15; 4:10; 7:52; 13:26–28; Mark 12:1–9), Paul accuses these Judean Jews (most likely the Jerusalem leadership) of killing Jesus. While the latter did not kill Jesus themselves, the gospel accounts do suggest that they set the judicial process in motion that led to his death at the hands of the Romans (see Acts 13:26–28).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is not clear whether the second descriptive phrase ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἡμᾶς ἐκδιωξάντων")]), _vm._v(", "), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_c('i', [_vm._v("hēmas ekdiōxantōn")]), _vm._v(") ought to be translated “who persecuted us” or “who drove us out.” Either is possible, and either might well have happened to Paul at the hands of Judean Jews in the past.")]), _c('a', {
    attrs: {
      "id": "fn212"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("212")])]), _vm._v(" The nature of Paul’s language in the third and fourth phrases, combined with his switch to a present tense participle, heightens the caustic flavor of his rhetoric in that he describes these Judean Jews hyperbolically as those “who are not pleasing to God and who oppose all people” (2:15c)."), _c('a', {
    attrs: {
      "id": "fn213"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("213")])]), _vm._v(" As is often pointed out, the language of “opposing all people” sounds like anti-Jewish rhetoric from the Greco-Roman world,"), _c('a', {
    attrs: {
      "id": "fn214"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("214")])]), _vm._v(" and one can only hope that the Gentile audience of the letter did not take it that way. However, the language of displeasing God and opposing all people is immediately qualified with the first clause of v. 16. They are displeasing God and opposing all people, "), _c('i', [_vm._v("not because they are Jews,")]), _vm._v(" but “by hindering” Paul and other Jews “from speaking to the Gentiles in order that they might be saved.”"), _c('a', {
    attrs: {
      "id": "fn215"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("215")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("For Paul, everything hinged on a new age having now begun with the death and resurrection of the Messiah and with God’s commissioning him to proclaim the faithfulness of this Messiah among the Gentiles, leading to their inclusion in the people of God "), _c('i', [_vm._v("as Gentiles.")]), _vm._v(" Paul’s later thinking on the fate of that part of Israel not currently believing in Jesus connects Israel’s own final salvation with the success of his mission to the Gentiles, that is, with the full number of Gentiles coming in (Rom 11:25–32). It is not clear whether Paul already had such an understanding when he writes this letter. However, on this reasoning, any particular group of Jews currently opposing his efforts to bring Gentiles to salvation might indeed be characterized as being “opposed to all people,” "), _c('i', [_vm._v("both other Jews and Gentiles.")]), _c('a', {
    attrs: {
      "id": "fn216"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("216")])]), _vm._v(" Therefore, Paul’s language here, while clearly hyperbolic (and even unnecessarily caustic), makes sense canonically, since the salvation of both Jews and Gentiles hangs in the balance.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Whether purposed by God or not,"), _c('a', {
    attrs: {
      "id": "fn217"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("217")])]), _vm._v(" the effect of their attempts to hinder "), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("Paul’s mission to the Gentiles is their continuing to “fill up the cup of their sins to the brim.” When added to their “killing of the Lord Jesus and the prophets,” such ongoing actions constitute “the final straw,” that is, they represent the bringing of their sins to a fulfilled state.")]), _c('a', {
    attrs: {
      "id": "fn218"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("218")])]), _vm._v(" While there are biblical precedents for such language (e.g., Gen 15:16; Dan 8:23; 2 Macc 6:14, and esp. Matt 23:31–36), how one understands its implications in this context is tightly connected with the way v. 16c is to be understood. This part of the verse reads, somewhat woodenly, “But has come upon ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἔφθασεν")]), _vm._v(", "), _c('i', [_vm._v("ephthasen")]), _vm._v("] them the wrath "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εἰς τέλος")]), _vm._v(" ["), _c('i', [_vm._v("eis telos")]), _vm._v("].” The two primary difficulties here are the awkward aorist (past) tense of "), _c('i', [_vm._v("ephthasen")]), _vm._v(" and the tension it creates when read together with the final prepositional phrase, "), _c('i', [_vm._v("eis telos")]), _vm._v(" (“completely, totally” or “finally, forever, to the end”).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In general, interpreters take "), _c('i', [_vm._v("ephthasen")]), _vm._v(" as either a “prophetic aorist” (a future event so certain that it can be spoken of as having already happened)"), _c('a', {
    attrs: {
      "id": "fn219"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("219")])]), _vm._v(" or as a reference to a concrete past event or events (usually in Judea) in which God’s eschatological wrath has already begun to overtake those to whom Paul is referring."), _c('a', {
    attrs: {
      "id": "fn220"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("220")])]), _vm._v(" While neither of these interpretations can be decisively ruled out, there is another possibility for those who are consciously interpreting this letter within a canonical framework, more specifically within the Pauline corpus. There is little doubt that the primary referent of wrath in 1 Thessalonians is the eschatological wrath awaiting those whose actions are in opposition to the living and true God (1:10; 5:9). But as we noted in our comments on 1:10, Rom 1:18–32 shows that God’s eschatological wrath can be anticipated and a foretaste of it experienced in the present when God “gives up” human beings to the consequences of their own choices, namely, more and more destructive actions that enslave them and distort their humanity. Thus, for Paul, one might presently experience God’s judgment-day wrath by participating in actions manifesting impiety and injustice, actions that “suppress the truth by means of injustice ["), _c('i', [_vm._v("adikia")]), _vm._v("]” (Rom 1:18). One might debate the extent to which Rom 1:18–32 is in any way representative of Israel’s experience, but the point here is "), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("that Paul’s own language elsewhere shows that present participation in actions that “suppress the truth by means of injustice” can be said to evoke, manifest, and anticipate God’s eschatological wrath in the present (see the related comments on 2 Thess 2:10–12).")]), _c('a', {
    attrs: {
      "id": "fn221"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("221")])]), _vm._v(" One might then say that the current actions of these specific Jews in v. 16c are tantamount to “suppressing the truth by means of injustice.” As a result, these actions have evoked (in the past) and now manifest (in the present) a foretaste of God’s wrath that awaits its consummation in the future judgment because God has now given them up to the consequences of their own destructive choices."), _c('a', {
    attrs: {
      "id": "fn222"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn222",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("222")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("With this understanding in view, "), _c('i', [_vm._v("eis telos")]), _vm._v(" is best understood temporally and translated “to the end.”"), _c('a', {
    attrs: {
      "id": "fn223"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("223")])]), _vm._v(" The sharpness of Paul’s language in this context makes it likely that he expects these Judean Jews to suffer the eschatological consummation of the wrath they are currently experiencing. In this case, Paul writes as a victim of injustice, expecting God to bring about final justice on particular Jews who have opposed both himself and God. The issue in Rom 9–11 is somewhat different in that there Paul is reflecting on the fate of the portion of Israel who are not Christ-believers, which should probably be understood to include many who were not actively persecuting Christ-believing Jews. Even so, there remains a tension between this passage and what Paul writes there (particularly Rom 9:1–5; 11:1–2, 11, 25–32)."), _c('a', {
    attrs: {
      "id": "fn224"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("224")])]), _vm._v(" Reasonable harmonizations of the two passages "), _c('i', [_vm._v("at the historical level of Paul’s intended meaning")]), _vm._v(" have been offered."), _c('a', {
    attrs: {
      "id": "fn225"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn225",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("225")])]), _vm._v(" However, in view of the harshness of Paul’s language in this passage, we will move in a different direction that attempts to allow the tension between them to generate fruitful theological reflection.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("First, we reiterate three important points: (1) the whole purpose of this section is to strengthen the audience’s resolve toward continued fidelity in their public life together. (2) Paul’s inflammatory rhetoric is intra-Jewish polemic directed only at a very specific group of Judean Jews, whose actions negatively impact "), _c('i', [_vm._v("other Jews")]), _vm._v(" as well as Gentiles. To call it “anti-Jewish” would be anachronistic; "), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("to use it for anti-Jewish purposes would be reprehensible. (3) While harsh, such language continues a biblical commonplace whereby those who understand themselves to be faithfully adhering to Israel’s God in the midst of their persecution use harsh language to speak about their persecutors in what is essentially a cry for justice (or is it vengeance?) in the midst of pain and suffering (e.g., Ps 137:9).")])]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("With these points in mind, we may reflect theologically on this language by considering it in light of the larger canonical context, particularly that of the Pauline corpus. Even if Paul, reflecting on the experience of being victimized and rightly desiring God’s justice, does not hold out hope for his particular Jewish oppressors, his argument in Romans ought to give us pause for asserting without qualification that they will suffer the eschatological consummation of God’s wrath, of which they have had a foretaste. The same holds true for those currently persecuting the church in various places around the world.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As in Rom 1, a current foretaste of God’s eschatological wrath does not indicate that experiencing its eschatological consummation is inevitable. Rom 1–3 is a "), _c('i', [_vm._v("retrospective")]), _vm._v(" analysis of the human condition from the standpoint of one who is “in Christ,” written to an audience who is “in Christ.” Hence, albeit perhaps in different ways, both Paul and his Romans audience (including us!) are now able to understand themselves as having at one time also received a foretaste of God’s eschatological wrath. They were indeed “enemies” of God (5:10), but now they stand delivered from experiencing the eschatological consummation of the wrath to which they were formerly subject. Hence, even if a portion of unbelieving Israel is currently participating in oppressive actions that evoke, manifest, and anticipate God’s eschatological wrath in the present, Paul’s own logic in Romans (even apart from chapters 9–11) does not make it inevitable that they will experience its consummation. They may, like Saul the persecutor (and Phinehas his precursor, Num 25:1–15; Ps 106:28–31), be “seeking to establish their own covenant faithfulness ["), _c('i', [_vm._v("dikaiosynē")]), _vm._v("]” (Rom 10:3) by demonstrating their loyalty in opposing those they believe to be God’s enemies. While such actions may even reveal that they are currently “hardened” by God and are “enemies of [God’s] good news” (Rom 11:25, 28), the very grace of God extended to Saul the persecutor shows that one cannot preclude their being included in “all Israel” who will be saved (11:26). God has indeed “imprisoned all to disobedience so that he might show mercy to all” (Rom 11:32). Thus, even though Paul’s rhetoric shows no explicit desire for God’s mercy toward his persecutors in 1 Thess 2:16c, elsewhere Scripture coming from Paul’s own hand plays a different tune, one that allows us to hear the particular note in 1 Thess 2:16c as a part of a larger melody.")])]), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "s10"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_81"
    }
  }), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#s10"
    }
  }, [_c('i', [_vm._v("2:17–3:10"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Paul and the Thessalonians: “Bringing Things Up-to-Date”")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("To this point in the letter, Paul has focused on matters in the recent past: (1) the coming of himself and his colleagues to the Thessalonians and the audience’s ensuing conversion and faithful witness; (2) the nature of their “entry” into Thessalonica; (3) faithful suffering on behalf of the gospel by both Paul and the Thessalonians. In 2:17–3:10 he focuses on bringing matters up to date, so to speak, focusing on the circumstances that led him to write the letter. The section divides easily into three parts: (1) Paul’s explanation of why he and Silas had not been able to revisit the audience personally, although they had longed to do so (2:17–20); (2) their decision to send Timothy to learn about the audience’s fidelity ("), _c('i', [_vm._v("pistis")]), _vm._v(") under pressure and to strengthen and encourage them (3:1–5); (3) Timothy’s good report that they are “standing firm in the Lord” and Paul’s continuing desire to see them face-to-face to further shape their life together in ways that manifest informed fidelity to the living and true God (3:6–10).")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "s11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s11"
    }
  }, [_c('i', [_vm._v("2:17–20"), _c('span', {
    staticClass: "space"
  }, [_vm._v("An Explanation of Absence")])])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('sup', [_vm._v("17")]), _vm._v("Now as for us, brothers and sisters, although we were orphaned for a little while [by our separation] from you (in person but not in heart), we made a very intense effort to see you again face-to-face. "), _c('sup', [_vm._v("18")]), _vm._v("For we wanted to come to you—especially I, Paul, wanted to come time and again—but Satan stopped us. "), _c('sup', [_vm._v("19")]), _vm._v("For who will be our hope or joy or crowning boast in the presence of our Lord Jesus at his royal coming? Surely it is you all, right? "), _c('sup', [_vm._v("20")]), _vm._v("For you yourselves are our honor and joy!")]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("In vv. 17–20 Paul explains why he and Silas had not revisited the audience prior to sending Timothy, even though they had longed to do so. Presumably, Timothy would have already given this information to the Thessalonians, and so what follows in these verses is more formational than informational. With emotionally charged language expressing Paul’s extreme affection for them, these verses continue to form their audience by depicting the relationship between Paul and his recipients as characterized by a mutual mediation of grace.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In 3:1–10 it is clear that Paul and Silas had sent Timothy because they were concerned about the Thessalonians’ vulnerability in the face of suffering and testing. But in 2:17–20 Paul begins by stressing his own vulnerability. As if likening himself and his companions to infants (2:7) was not striking enough, here he takes the remarkable step of likening himself and his companions to "), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("children in their most vulnerable state.")]), _c('a', {
    attrs: {
      "id": "fn226"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("226")])]), _vm._v(" In their temporary separation from the Thessalonians, they are like bereaved children deprived of their parents."), _c('a', {
    attrs: {
      "id": "fn227"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("227")])]), _vm._v(" The orphan metaphor resonates well with an audience who, in turning from the idols of their pagan past, may have experienced a similar separation from their households with its subsequent confusion and sadness."), _c('a', {
    attrs: {
      "id": "fn228"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn228",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("228")])]), _vm._v(" Together with the rest of the language in v. 17, the metaphor underscores not only Paul’s intense longing, his “truly fervent love,”"), _c('a', {
    attrs: {
      "id": "fn229"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("229")])]), _vm._v(" for the audience, but also the mutual interdependence that exists between himself and his converts."), _c('a', {
    attrs: {
      "id": "fn230"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("230")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("While the audience is clearly dependent on Paul for their Christian formation (3:10), in vv. 19–20 Paul portrays the eschatological standing of himself and his colleagues as dependent on this community’s sustained fidelity to God (note 3:8, where Paul’s “continuing to live” is dependent on this). More specifically, Paul connects his eschatological hope, joy, crowning boast (cf. 1 Cor 9:24–27), and glory/honor to the integrity and shape of the Thessalonian church at the royal coming of the Lord (vv. 19–20)."), _c('a', {
    attrs: {
      "id": "fn231"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn231",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("231")])]), _vm._v(" He uses similar ideas (1 Cor 3:10–15) and language (Phil 2:16; 4:1) elsewhere.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Since Paul proclaims a gospel that has God’s formation of a faithful, holy people in Christ as a central component, it is not surprising that his own eschatological vindication depends, at least to some extent,"), _c('a', {
    attrs: {
      "id": "fn232"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn232",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("232")])]), _vm._v(" on whether there turn out to be flesh and blood communities whose cruciform life together testifies to the truth of what he proclaimed, namely, that a Jewish messiah, stamped forever with the legacy of crucifixion (see 1 Cor 1:23; 2:2), is Lord of the cosmos. His part in the formation of such communities who reflect that Lord’s character at his royal coming will indeed be a “crowning boast” for Paul, albeit ultimately an eschatological opportunity to “boast in the (cruciform) Lord” (1 Cor 1:31 citing Jer 9:23–24 LXX) or to boast in the grace of God at work in "), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_vm._v("him (1 Cor 15:10).")]), _c('a', {
    attrs: {
      "id": "fn233"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn233",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("233")])]), _vm._v(" Hence, the outcome of Paul’s prayer in 3:13 (that their hearts will be “blameless in holiness in the presence of our God and Father at the royal coming of our Lord Jesus”) not only has a bearing on his audience’s eschatological vindication, but his own as well.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The vulnerability implied in the orphan metaphor, along with the language of vv. 19–20, stresses the reciprocal nature of the relationship between Paul and his converts. That is, these Gentiles being formed as a faithful community after the pattern of Jesus are dependent on Paul’s formative actions, whereas Paul’s own eschatological standing is dependent on this community’s sustained fidelity to God. But the reciprocal nature of the relationship is evident also in that the community’s continuing faithfulness has encouraged Paul and his companions in their own distress and tribulation to remain faithful to God’s redemptive project in the present (3:7–8). So the audience’s continued fidelity to God provides formative encouragement in the present that solidifies Paul’s own fidelity. In other words, seeing the pattern of Jesus formed and faithfully lived out in a Gentile community testifies to the truth of the gospel, which in turn, sustains and solidifies the continued fidelity of its proclaimers.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul and his colleagues are therefore in a relationship with the Thessalonians that is mutually formative. While it is important for Paul as a “true friend” to assure the audience that he is not absent from them in heart (v. 17),"), _c('a', {
    attrs: {
      "id": "fn234"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("234")])]), _vm._v(" he underscores the importance of being physically present with them, of “seeing their face” in v. 17 and again in 3:10. In such mutually formative relationships, there is no substitute for face-to-face, physical interaction for effective modeling, encouragement, and exhortation. As contemporary research in psychology and neuroscience shows, we are reciprocally formed in the prolonged presence of others because we unconsciously mimic their mannerisms, facial expressions, behavior, and even ways of thinking and dispositions."), _c('a', {
    attrs: {
      "id": "fn235"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn235",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("235")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("So it is no wonder that Paul has so much at stake in seeing his audience again face-to-face. And with so much at stake, it is no wonder that Paul can attribute his and his companions’ inability to return to the audience to Satan’s preventing it on more than one occasion (v. 18). Little is to be gained by speculating on what Paul understands as the concrete referent(s) of Satan’s actions. Whatever they are, claiming Satan as the cause was Paul’s retrospective interpretation of whatever happened."), _c('a', {
    attrs: {
      "id": "fn236"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("236")])]), _vm._v(" However, this is not to imply that Paul’s interpretation was wrong. He is not hesitant to speak about the presence of "), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("evil in the world, which actively opposes the "), _c('i', [_vm._v("missio Dei")]), _vm._v(" (see further on 3:5 and 2 Thess 2:9; 3:3; cf. 2 Cor 4:4), a presence he refers to as “Satan.”")])]), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("Verse 19 contains the first usage of the term "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("παρουσία")]), _vm._v(" ("), _c('i', [_vm._v("parousia,")]), _vm._v(" “royal coming”) in 1 Thessalonians, and here it is clearly a reference to the eschatological coming of “our Lord, Jesus.” His coming from heaven has already been mentioned in 1:10, and it is important to note that neither there nor here does Paul attempt to persuade his audience "), _c('i', [_vm._v("that")]), _vm._v(" the Lord Jesus will come. Nor does he attempt to persuade them here that this coming is appropriately described by the word “parousia,” which in its technical sense could refer to the coming of a (hidden) divinity or to official visits of high-ranking persons, especially provincial visits of kings and emperors.")]), _c('a', {
    attrs: {
      "id": "fn237"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn237",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("237")])]), _vm._v(" As we will see in the comments on 4:13–18, Paul draws on this technical sense of the word later in addressing some of the audience’s eschatological concerns. Hence, there is no reason to hear the word “parousia” in this context any differently than as a reference to the Lord’s royal coming. In the letter as a whole, then, Paul simply assumes that the audience will take for granted that (1) the true Lord of the cosmos will come, (2) the direction is from heaven to earth (1:10; cf. Phil 3:20), and (3) his coming will have the character of a royal/imperial entrance, with both Paul and the audience present in the King’s presence. What Paul says to this point in his letter about the Lord’s coming begins to prepare the way for him to address the eschatological concerns in 4:13–5:11.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "s12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s12"
    }
  }, [_c('i', [_vm._v("3:1–5"), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Sending of Timothy")])])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('sup', [_vm._v("1")]), _vm._v("So, because we could no longer stand it, we gladly chose to be left alone in Athens "), _c('sup', [_vm._v("2")]), _vm._v("and sent Timothy, our brother and God’s coworker"), _c('a', {
    attrs: {
      "id": "fn238"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn238",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("238")])]), _vm._v(" in the gospel about Christ, in order to strengthen you all and encourage you for the sake of your faithfulness "), _c('sup', [_vm._v("3")]), _vm._v("so that no one would be shaken by these persecutions."), _c('a', {
    attrs: {
      "id": "fn239"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("239")])]), _vm._v(" "), _c('sup', [_vm._v("4")]), _vm._v("For you yourselves know that we are destined for this because, indeed, when we were with you, we kept telling you beforehand that we were going to be persecuted—just as it has happened, "), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("as you well know. "), _c('sup', [_vm._v("5")]), _vm._v("Because of this, I myself, because I could no longer stand it, sent to find out about your faithfulness in case the Tester had tested you all and our labor had been for nothing.")])]), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }), _c('p', {
    staticClass: "BodyFlush1"
  }, [_c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("The chapter division here is arbitrary. Paul continues the thought from 2:20 with a “so” ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("διό")]), _vm._v(", "), _c('i', [_vm._v("dio")]), _vm._v("), indicating that 2:17–20 is the basis for what he is about to say here. Because of his intense feelings for his audience and his desire that they be properly formed in Christ, and because his own honor at the eschatological Day of the Lord is wrapped up with their personal and corporate life—and because he could no longer stand not knowing about them—Paul says, “We chose to be left alone in Athens and sent Timothy.”")]), _c('a', {
    attrs: {
      "id": "fn240"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn240",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("240")])]), _vm._v(" The language of being “left alone” conveys a feeling of loneliness and recalls the earlier language of “being orphaned” from his audience (2:17).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul goes on to describe Timothy as “our brother and "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("συνεργὸν τοῦ θεοῦ")]), _vm._v(" ["), _c('i', [_vm._v("synergon tou theou,")]), _vm._v(" ‘coworker of God’] in the good news about Christ.” The phrase "), _c('i', [_vm._v("synergon tou theou")]), _vm._v(" can be translated “[our] coworker for God” (NRSV, similarly the NIV “[our] coworker in God’s service”). In that case, Timothy would be understood as belonging to God as "), _c('i', [_vm._v("Paul’s")]), _vm._v(" coworker, but not as a coworker with God."), _c('a', {
    attrs: {
      "id": "fn241"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("241")])]), _vm._v(" However, the discomfort in the textual tradition indicates that the phrase is most naturally understood as characterizing Timothy as a coworker "), _c('i', [_vm._v("with")]), _vm._v(" God (see note on translation above). In addition, Paul’s language elsewhere indicates that, while God remains the primary actor, God works together with and through Paul and his colleagues. For example, the phrase "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("θεοῦ")]), _vm._v(" . . . "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("συνεργοί")]), _vm._v(" ("), _c('i', [_vm._v("theou synergoi")]), _vm._v(") in 1 Cor 3:9 may be taken as characterizing Paul and Apollos as coworkers with God,"), _c('a', {
    attrs: {
      "id": "fn242"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn242",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("242")])]), _vm._v(" but even if that passage remains ambiguous, the language of 2 Cor 5:20–6:2 certainly moves in this direction. The phrase “God’s coworker” in this context implies at least a couple of things. First, God is actively at work in the speaking and exhibiting of the good news about Jesus the Messiah. In other words, the good news "), _c('i', [_vm._v("does")]), _vm._v(" something because God is at work when it is spoken and embodied (see comments on 1 Thess 2:13). Second, it implies that Timothy, who is actively working in speaking and embodying the good news, is working together with God."), _c('a', {
    attrs: {
      "id": "fn243"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("243")])]), _vm._v(" God, in other words, chooses to be active together with and through those who announce and embody the good news about Jesus the Messiah (1:5, 8; 2:13).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_vm._v("Paul’s cruciform action in sending Timothy was for the purpose of strengthening and encouraging the audience to persevere in their faithfulness ("), _c('i', [_vm._v("pistis")]), _vm._v("), essentially continuing Paul’s own work among the audience (as described, e.g., in 2:12).")]), _c('a', {
    attrs: {
      "id": "fn244"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn244",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("244")])]), _vm._v(" As has been the case throughout the letter, "), _c('i', [_vm._v("pistis")]), _vm._v(" in this section (vv. 2, 5, 6, 7, 10) is not limited to the Thessalonians’ inner belief/trust but is better understood as faithfulness or fidelity,"), _c('a', {
    attrs: {
      "id": "fn245"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("245")])]), _vm._v(" particularly since the following phrase expresses the ultimate purpose of sending Timothy, that is, “so that no one would be shaken by these pressures/persecutions.” Paul says “these”"), _c('a', {
    attrs: {
      "id": "fn246"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("246")])]), _vm._v(" rather than “those” and uses a present tense verb to insist that “we are destined for this,” which implies that the “pressures/persecutions” afflicting the audience are continuing, as they are for him."), _c('a', {
    attrs: {
      "id": "fn247"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("247")])]), _vm._v(" His present tense assertion in 3:8, “We’re now truly alive, since you all "), _c('i', [_vm._v("are standing firm")]), _vm._v(" in the Lord,” also implies that the tribulations are continuing as he writes, as they clearly are at the time he writes 2 Thessalonians (see 2 Thess 1:4). For the nature of these “pressures/persecutions,” see the comments on 1:6.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul continues in v. 3b with “For you yourselves know that we are destined for this.” Paul and his cosenders kept nothing from the audience, being familiar themselves with what devotion to a crucified Lord might entail. Hence, they told them repeatedly"), _c('a', {
    attrs: {
      "id": "fn248"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn248",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("248")])]), _vm._v(" that all of them (i.e., the Thessalonians, Paul, Silas, and Timothy) were going to be pressured/persecuted, and thus, Paul says, it has happened. It is widely attested in the NT (e.g., 2 Thess 1:4–5; Phil 1:28–30; Mark 4:17; 13:9–13; Acts 14:22; Rev 1:9) that Christians were expected to suffer persecution as a result of their participation in God’s mission. Indeed, for Paul the opportunity to “suffer on behalf of Christ” was actually a gift, an expression of grace (Phil 1:29), because cosuffering was to lead to coglorification/cohonor at Christ’s royal appearance (4:13–18; 2 Thess 1:11–12) in the resurrection of the dead (Rom 8:17; Phil 3:10–11)."), _c('a', {
    attrs: {
      "id": "fn249"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("249")])]), _vm._v(" Suffering is not to be sought out but is an inevitable by-product of participating in the "), _c('i', [_vm._v("missio Dei,")]), _vm._v(" a consequence of being “God’s coworker,” wherein one’s body becomes a weapon of God’s own justice "), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_vm._v("and saving covenant faithfulness in a world bent toward injustice ("), _c('i', [_vm._v("adikia;")]), _vm._v(" see the comments on 5:8; cf. Rom 6:13; 2 Cor 5:21).")]), _c('a', {
    attrs: {
      "id": "fn250"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("250")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("So because Paul himself knew that the Thessalonians had encountered such pressures, he sent Timothy in order to find out about their faithfulness/fidelity ("), _c('i', [_vm._v("pistis")]), _vm._v(") in the midst of it. Paul’s fear is that their “labor had been for nothing” (cf. Phil 2:16; Gal 2:2) as a result of the Thessalonians being tested by “the Tester,” that is, Satan (named in 2:18). Such language rhetorically casts the "), _c('i', [_vm._v("thlipsis")]), _vm._v(" (pressures/persecutions) they are experiencing as more than simply local social pressures but as part of a larger cosmic battle. In an apocalyptic view of the world, the actions of unseen powers lie back of, and are embodied in, human actions, such as the audience’s suffering at the hands of their fellow countrymen (2:14). Hence, Paul scripts their experience of "), _c('i', [_vm._v("thlipsis")]), _vm._v(" into a larger cosmic drama, in which the "), _c('i', [_vm._v("missio Dei")]), _vm._v(" is being enacted and in which they are currently participating, but from which they would bow out if they succumbed to the temptation to return to what their society would have understood as normalcy. Paul’s expressed concern about whether they had done so indicates that he had no doubts that such a thing "), _c('i', [_vm._v("could")]), _vm._v(" happen. It had certainly happened previously to Israel itself when, rather than confronting the idolatry of the surrounding nations in faithfulness to God’s mission, they had been absorbed into it. Paul’s expressed confidence in God (e.g., 5:24), however, indicates that it "), _c('i', [_vm._v("would")]), _vm._v(" happen only if the Thessalonians eschewed God’s faithfulness to them in the midst of the pressure to be absorbed back into the “common sense” of their culture’s idolatrous practices.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This is the only place where Paul explicitly refers to “the Tester/Tempter” ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ὁ πειράζων")]), _vm._v(", "), _c('i', [_vm._v("ho peirazōn")]), _vm._v("); there is no question that he is referring to Satan. The theme of testing/temptation is not that common in Paul’s letters, and Satan’s role in it is explicitly stated only in 1 Cor 7:5, but he is the implied agent or ultimate cause of testing/temptation elsewhere in the Pauline corpus (1 Cor 10:13; Gal 6:1; 1 Tim 6:9). Hence, it is clear that Paul conceives Satan as actively opposing God’s mission, one manifestation of which is his involvement in testing the fidelity of those participating in it. In the canonical context of Matthew’s portrayal of the testing of Jesus (Matt 4:1–11 // Luke 4:1–13), we have the same language as Paul uses here ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ὁ πειράζων")]), _vm._v(", "), _c('i', [_vm._v("ho peirazōn,")]), _vm._v(" Matt 4:3), with Matthew naming that one “the devil” (4:5; cf. Mark 1:13; Luke 4:2). In Matthew’s and Luke’s depictions of this testing, what is tested is not Jesus’ belief but rather his fidelity/faithfulness to God’s way of his living out his sonship in carrying out God’s redemptive project."), _c('a', {
    attrs: {
      "id": "fn251"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn251",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("251")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_vm._v("What is tested, one might say, is his fidelity or loyalty to the "), _c('i', [_vm._v("missio Dei.")]), _vm._v(" Given that the audience has already been portrayed as imitators of the Lord, this comparison with the Synoptic portrayal of the Son suggests that what is at stake here is the audience’s faithfulness/fidelity to God’s ongoing redemptive project, that is, to the "), _c('i', [_vm._v("missio Dei.")])])]), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "s13"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_89"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#s13"
    }
  }, [_c('i', [_vm._v("3:6–10"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Timothy’s Good Report and Paul’s Desire to See the Thessalonians")])])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('sup', [_vm._v("6")]), _vm._v("But Timothy has just come back to us from you and brought good news (“gospel”) regarding your faithfulness and love and [telling us] that you always have a good memory of us, longing to see us, just as we also long to see you. "), _c('sup', [_vm._v("7")]), _vm._v("On account of this, sisters and brothers, we were encouraged because of you in all our distress and persecution through your faithfulness, "), _c('sup', [_vm._v("8")]), _vm._v("so that"), _c('a', {
    attrs: {
      "id": "fn252"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("252")])]), _vm._v(" we’re now truly alive, since you all are standing firm in the Lord. "), _c('sup', [_vm._v("9")]), _vm._v("For what thanksgiving are we able to repay to God for you all for the joy with which we are rejoicing because of you in the presence of our God "), _c('sup', [_vm._v("10")]), _vm._v("as we, night and day, more than you can imagine, beg to see your face and make complete the things lacking in your faithfulness?")]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("In vv. 6–10 Paul describes the results of Timothy’s return, in view of which he has written the entire letter. Because Paul said earlier that his separation from the audience had been for only a short time (2:17), it seems likely that he wrote the letter shortly after Timothy’s return."), _c('a', {
    attrs: {
      "id": "fn253"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("253")])]), _vm._v(" Timothy’s report bringing good news had two parts, the first having to do with the audience’s Christian identity, the second, with their relationship with Paul. First, the news is good with regard to the audience’s fidelity ("), _c('i', [_vm._v("pistis")]), _vm._v(") to God and their love ("), _c('i', [_vm._v("agapē")]), _vm._v(") for each other, for Paul and Timothy, and perhaps for others outside the community as well."), _c('a', {
    attrs: {
      "id": "fn254"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn254",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("254")])]), _vm._v(" For Paul, fidelity toward God and love for others go hand in hand; they are distinguishable "), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("but inseparable and together constitute the quintessential marker of Christian identity (see comments on 1:3; 5:8; cf. Gal 5:6; Col 1:4).")]), _c('a', {
    attrs: {
      "id": "fn255"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn255",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("255")])]), _vm._v(" Timothy’s report is the basis for what Paul writes not only here, but also in 1:6, namely, that the audience is continuing to embody an overall life pattern that is analogous to that of the cruciform Lord, whose life of suffering and death was characterized by fidelity to God’s redemptive mission expressed in self-giving love for others. This Spirit-enabled life pattern of fidelity and love constitutes a participation in Christ’s quintessential act of covenant fulfillment, that is, his unified act of fidelity and love that culminated on the cross. As such, they bear the mark of a justified people and, in the present, anticipate sharing in Christ’s vindicating, future resurrection, resulting in the culmination of their transformation and in public honor (see further comments on 4:14 and 2 Thess 1:12)."), _c('a', {
    attrs: {
      "id": "fn256"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("256")])]), _vm._v(" In this context, such is the concrete meaning of (the participatory language of) “standing firm "), _c('i', [_vm._v("in")]), _vm._v(" the [cruciform] Lord” and is the basis for Paul’s confidence that they did not succumb to the “Tester/Tempter.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("While the audience could have had reason for harboring bad memories of Paul,"), _c('a', {
    attrs: {
      "id": "fn257"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn257",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("257")])]), _vm._v(" the second part of Timothy’s good news is that they instead have a good memory of him. The “good memory” Timothy reports may indeed imply fond and pleasant memories of Paul, but its primary referent is probably the absence of doubts and suspicions and the presence of a clear recollection of the sort of person Paul proved to be when he was with them (1:5),"), _c('a', {
    attrs: {
      "id": "fn258"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn258",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("258")])]), _vm._v(" a memory that might continue to help form their own character along similar lines. In any case, that “good memory” results in their longing to see Paul, just as he longs to see them (cf. Rom 1:11; Phil 2:26), as indeed “true friends” do in their physical (but not emotional) separation from each other.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This good report of their fidelity and love and their continued good memory and strong feelings for Paul encouraged him in his own distress and persecution to remain faithful to God’s mission. While such mutuality and reciprocity were at the core of the concept of friendship in the Greco-Roman world and no doubt influenced Paul’s language here,"), _c('a', {
    attrs: {
      "id": "fn259"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn259",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("259")])]), _vm._v(" this is not just an example of mutual dependence on one another. It is a mutual mediation of God’s grace, "), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_vm._v("a reciprocity of grace that comes initially through Paul to the audience and then returns through the audience as sustaining grace to Paul (see comments on 2:19–20). This sustaining grace impacts Paul to such an extent that he can describe his state as being “truly alive, since ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐάν")]), _vm._v(", "), _c('i', [_vm._v("ean")]), _vm._v("] you all are standing firm ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("στήκετε")]), _vm._v(", "), _c('i', [_vm._v("stēkete")]), _vm._v("] in the Lord.”")]), _c('a', {
    attrs: {
      "id": "fn260"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn260",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("260")])]), _vm._v(" As Gaventa puts it, “Now that the crisis has passed, [Paul] breathes again.”"), _c('a', {
    attrs: {
      "id": "fn261"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("261")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In vv. 9–10 Paul returns to the theme of thanksgiving, only now in the form of a long rhetorical question that is filled with vivid emotion and underscores the fact that Paul’s joy is ultimately because God has been at work among the Thessalonians, enabling them to stand firm in the Lord by exhibiting fidelity to God and cruciform acts of love for others. When Paul asks what thanksgiving is adequate to repay God for all the joy they have brought to him, his language echoes conventional language of reciprocity when one receives a great gift from a benefactor."), _c('a', {
    attrs: {
      "id": "fn262"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn262",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("262")])]), _vm._v(" The implied answer to his question is: There is simply no thanksgiving that is adequate to the task, which makes it all the more important to publicly announce that he can find no adequate way to thank God for what God has done for the Thessalonians!")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In v. 10 we learn—not surprisingly, given our comments on 2:17—that Paul makes “seeing their face” a matter of fervent, intense, repeated prayer. As we noted earlier, there is simply no substitute for face-to-face, physical interaction for effective modeling, encouragement, and exhortation whose ultimate goal is transformation. And it is precisely the need for this transformation that Paul connects with seeing their face in 3:10b. He has so unequivocally affirmed this audience’s fidelity to God until this point that it is a bit surprising to hear him express his desire to “make complete ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("καταρτίσαι")]), _vm._v(", "), _c('i', [_vm._v("katartisai")]), _vm._v("] the things lacking in your faithfulness ["), _c('i', [_vm._v("pistis")]), _vm._v("].” The key to understanding what is at stake here lies in recognizing that the verb "), _c('i', [_vm._v("katartizō")]), _vm._v(" occurs often in educational contexts to refer to the teacher completing the student’s instruction so that he or she could live fully as an adult (cf. Luke 6:40)."), _c('a', {
    attrs: {
      "id": "fn263"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn263",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("263")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_vm._v("This language, in conjunction with the completely positive portrayal of the audience’s fidelity ("), _c('i', [_vm._v("pistis")]), _vm._v(") throughout the epistle until this verse, points away from any "), _c('i', [_vm._v("intentional")]), _vm._v(" disloyalty to God. Rather, given their relatively recent conversion and its accompanying new value system, it points toward "), _c('i', [_vm._v("a lack in their ability to discern")]), _vm._v(" how their fidelity ("), _c('i', [_vm._v("pistis")]), _vm._v(") should be embodied in each circumstance that might confront them in their ancient Mediterranean society, especially how to face the continuing social pressure and persecution.")])]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_vm._v("It is difficult to overemphasize the radical change that had recently taken place in their lives. As Wayne Meeks observes, “Being or becoming religious in the Greco-Roman world did not entail either moral transformation or sectarian resocialization.”")]), _c('a', {
    attrs: {
      "id": "fn264"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("264")])]), _vm._v(" For Gentiles in the Roman Empire to worship a crucified and risen Jewish peasant as the one Lord would have been surprising enough, but to undergo a radical resocialization in which they became a part of a community whose moral life was to be characterized by a cruciform pattern would have required no less than a “conversion of the imagination.”"), _c('a', {
    attrs: {
      "id": "fn265"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("265")])]), _vm._v(" One’s “imagination” (or “life world”) often operates invisibly at an unacknowledged level, giving shape to one’s intentions and dispositions, as well as to the practices that flow out of them."), _c('a', {
    attrs: {
      "id": "fn266"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn266",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("266")])]), _vm._v(" Hence, this audience’s whole epistemological and volitional apparatus (i.e., their imaginations), through which they made cognitive/volitional judgments and construals about their world, had to be reshaped by the Holy Spirit."), _c('a', {
    attrs: {
      "id": "fn267"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("267")])]), _vm._v(" By the power of the Spirit working in and among them, one “life world” had to be unlearned and another learned."), _c('a', {
    attrs: {
      "id": "fn268"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn268",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("268")])]), _vm._v(" Otherwise they could not begin discerning what faithfulness and loyalty to the one God of Israel actually entailed, much less decide to enact such faithfulness. In short, their whole embodied life (inner and outer) had to be initially and continuously transformed. In NT terms, this transformation roughly corresponds to saying that one’s heart ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("καρδία")]), _vm._v(", "), _c('i', [_vm._v("kardia")]), _vm._v(") must be changed and continuously “strengthened” in the ability to live faithfully (see comments on 3:13).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Hence, after Paul left, and even after Timothy had brought back a totally positive report about their fidelity ("), _c('i', [_vm._v("pistis")]), _vm._v("), Paul could anticipate (1) that numerous "), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_vm._v("issues might arise in their social context about which he had not given them specific instruction")]), _c('a', {
    attrs: {
      "id": "fn269"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("269")])]), _vm._v(" and (2) that certain “life world” assumptions had been so engrained in their consciousness that acting on the basis of them might continue to seem natural, nothing but common sense. In other words, it would not be surprising that such an audience might not readily recognize possible threats to their loyalty to God, particularly in certain commonsense assumptions about sexual activity and in the way public life was organized, namely, in terms of patron-client relationships dependent on a system of social stratification. Paul goes on to address issues related to both these concerns in the very next section of the letter (4:1–12). In more basic terms, it is worth repeating that their imaginations were constantly bombarded with conceptions of “normal divinity” at odds with the cruciform pattern etched in the face of Jesus (see comments on 2:17). It would be easy for such conceptions to creep back into the community’s understanding of God, unintentionally underwriting a pattern of life running counter to the character of this cruciform God.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Therefore, when Paul says he wants to “make complete the things lacking in your faithfulness/fidelity,” such lacks are "), _c('i', [_vm._v("not")]), _vm._v(" likely activities (or even lack of trust) in which the audience is currently engaged that manifest intentional disloyalty to God."), _c('a', {
    attrs: {
      "id": "fn270"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn270",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("270")])]), _vm._v(" Rather, they most probably have to do with an imperfectly developed ability to discern which practices might lead to, or actually constitute, disloyalty toward the particular God revealed in Jesus. Rom 12:2 expresses the gist of what Paul is concerned with here, namely, that this audience’s mind and imagination will be in the process of continual transformation into a progressively more cruciform shape so that they will be increasingly adept at being able to discern what God’s will for them might be in a variety of situations in their particular social setting. Hence, what remains incomplete and ongoing in their "), _c('i', [_vm._v("pistis")]), _vm._v(" is what I have called elsewhere “the sanctification of their imagination,”"), _c('a', {
    attrs: {
      "id": "fn271"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("271")])]), _vm._v(" which only God can do (as 5:23 affirms). However, Paul’s language here implies that one of the means by which God brings it about is a face-to-face encounter with other graced persons, whether Paul himself or, in the meantime, the graced person who reads this epistle to its audience. Paul therefore says that he prays constantly that God will allow him to see them again, presumably for a more extended time of face-to-face instruction to continue their Christian formation. "), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_vm._v("In the meantime, he uses the rest of the epistle to initiate that completion, suggesting that at least some of what follows in 4:1–5:22 constitutes some of the areas where Paul is attempting to complete his audience’s ability to discern how their "), _c('i', [_vm._v("pistis")]), _vm._v(" should be embodied in their particular context.")])]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "s14"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_94"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#s14"
    }
  }, [_c('i', [_vm._v("3:11–13"), _c('span', {
    staticClass: "space"
  }, [_vm._v("First Petitionary Prayer for the Holiness of the Thessalonians")])])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('sup', [_vm._v("11")]), _vm._v("Now may our God and Father himself and our Lord Jesus clear our way to you. "), _c('sup', [_vm._v("12")]), _vm._v("And may the Lord enable you to increase and flourish in love for one another and for all, just as we [were enabled by the Lord to increase and flourish in love] for you all "), _c('sup', [_vm._v("13")]), _vm._v("in order that he might strengthen"), _c('a', {
    attrs: {
      "id": "fn272"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn272",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("272")])]), _vm._v(" your hearts to be blameless in holiness in the presence of our God and Father in the royal coming of our Lord Jesus with all his holy ones."), _c('a', {
    attrs: {
      "id": "fn273"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn273",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("273")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("With the issue of “making complete” what is lacking in their fidelity ("), _c('i', [_vm._v("pistis")]), _vm._v(") ringing in the ears of his audience, Paul moves directly into a petitionary prayer in 3:11–13. This prayer functions as a rhetorical hinge to connect the first major section of the letter (1:2–3:13) with the second major section (4:1–5:24), which itself concludes with another petitionary prayer with similar concerns as this one."), _c('a', {
    attrs: {
      "id": "fn274"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn274",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("274")])]), _vm._v(" Hence, all the material in between, in which Paul exhorts his audience with regard to their practices, is framed both rhetorically and theologically with prayers invoking God’s enabling grace on their behalf. The material sandwiched between these prayers does, however, clearly indicate that this divine enabling grace does not operate apart from the volition and action of those in Christ, by whom it must be appropriated for it to become effective in their lives.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Not surprisingly, this prayer reflects some issues in 1:2–3:10 and also anticipates some concerns of 4:1–5:22. Sounding a similar note as 3:10, it implores God the Father and the Lord Jesus to make it possible for Paul’s ministry to continue among them by clearing his way to his audience (3:11), thereby overcoming Satan’s attempts to block Paul’s visit to them (2:18). Paul also prays that the audience will be enabled to increase and abound in the love that already "), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_vm._v("characterizes them (1:3; 3:6; 4:9), the faithful embodiment of which is explicitly an issue in 4:9–12 and implicitly an issue in 4:1–8 and 5:12–13, 15. The ultimate purpose of this first petitionary prayer is that the hearts of the Thessalonians will be established “blameless in holiness” before God at the royal coming of the Lord Jesus. Paul’s own cruciform example has exemplified a way of life that is holy and blameless (2:6–12), and holiness will immediately be an explicit issue in 4:1–8 and implicitly so in 4:9–12 and 5:12–22. The eschatological setting in which the audience is to become blameless in holiness has already been alluded to (1:10; 2:19–20; probably 1:3) and is the subject of 4:13–5:11.")])]), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("This first prayer thus looks both backward and forward and is connected with the prayer in 5:23–24, which ends the next major section of the letter. These prayers frame what comes between them with the orienting concern of Paul’s desire for the audience’s holiness/sanctification. The same concerns appear in both, that is, the audience’s holiness/sanctification and their being kept blameless at the parousia. The Lord’s establishment of their hearts blameless ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀμέμπτους")]), _vm._v(", "), _c('i', [_vm._v("amemptous")]), _vm._v(") in holiness ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἁγιωσύνη")]), _vm._v(", "), _c('i', [_vm._v("hagiōsynē")]), _vm._v(") in the parousia (3:13) is hardly different from God’s entire sanctification ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἁγιάσαι")]), _vm._v(", "), _c('i', [_vm._v("hagiasai")]), _vm._v(") of them, in which their whole spirit, soul, and body will be kept blameless ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀμέμπτως")]), _vm._v(", "), _c('i', [_vm._v("amemptōs")]), _vm._v(") in this same parousia (5:23). Paul thus does more than simply connect the completion of the things lacking in the faithfulness ("), _c('i', [_vm._v("pistis")]), _vm._v(") of his audience (3:10) to his prayer for a face-to-face interaction with the audience. He also connects it with the petition that the Lord (Jesus) would establish their “hearts blameless in holiness” at the parousia, which he further explicates in 5:23 as God (the Father) himself completely sanctifying the community as a whole, and the whole of every person in it.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_vm._v("Paul has both God the Father and the Lord Jesus engaging in the sanctification of God’s people in these prayers, which implicitly raises again the question as to the relationship between the two. The way Paul opens the prayer in v. 11 presses the question. His petition is that “our God and Father "), _c('i', [_vm._v("himself")]), _vm._v(" and our Lord Jesus” would clear his way to visit the Thessalonians, using a singular verb with this plural subject. Compound subjects in the NT in fact sometimes take singular verbs (e.g., Matt 5:18; Mark 4:41), and the emphasis in 3:11 is certainly on the Father.")]), _c('a', {
    attrs: {
      "id": "fn275"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn275",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("275")])]), _vm._v(" By itself, then, one might argue that the verb does not necessarily have theological significance. But our earlier comments on 1:1 suggest otherwise, as do the following factors in 1 and 2 Thessalonians: (1) "), _c('i', [_vm._v("As a monotheistic Jew,")]), _vm._v(" Paul is addressing a public prayer to "), _c('i', [_vm._v("both")]), _vm._v(" God the Father and Jesus as “Lord” (cf. Acts 1:24);"), _c('a', {
    attrs: {
      "id": "fn276"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn276",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("276")])]), _vm._v(" (2) he does the same thing "), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("in 2 Thess 2:16–17, only there reversing the order, mentioning the Lord Jesus "), _c('i', [_vm._v("himself")]), _vm._v(" (emphatically) first and then God the Father; (3) he can address either in prayers separately (the Father in 1 Thess 1:2–3; 5:23; the Lord Jesus in 2 Thess 3:5, 16) and single one out for a particular petition when addressing them both (1 Thess 3:12);")]), _c('a', {
    attrs: {
      "id": "fn277"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("277")])]), _vm._v(" and (4) in this very context (3:13) Paul appears to be alluding to Zech 14:5 LXX, thereby identifying an OT reference to the future coming of “the Lord my God” with the future coming of “our Lord Jesus.”"), _c('a', {
    attrs: {
      "id": "fn278"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn278",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("278")])]), _vm._v(" Paul offers no explanation or warrant for these prayer practices or this sort of interpretation of an OT reference, indicating that he could already assume his audience’s familiarity with both his prayer practice and his practice of using OT allusions with christological referents."), _c('a', {
    attrs: {
      "id": "fn279"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn279",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("279")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is obvious that Paul is not explicating the relationship between the Father and the Son in the explicit language of the Nicene tradition, either here or elsewhere, but the singular verb has more significance than just indicating that they are somehow closely related. The implicit assumption in this and other prayers in 1 and 2 Thessalonians is that the Father and the Son share divine power and prerogative but remain distinguishable as addressable persons. Referring to this usage as simply a functional Christology that attributes divine activity to Jesus misses the point both historically and theologically. Historically, there is little parallel for a first-century Jew actually engaging in the practice of addressing in prayer any figure other than the unique God of Israel."), _c('a', {
    attrs: {
      "id": "fn280"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn280",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("280")])]), _vm._v(" Theologically, the pattern of judgments present in the texture of scriptural discourse concerning the God of Israel ought to provide us with an ontology."), _c('a', {
    attrs: {
      "id": "fn281"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("281")])]), _vm._v(" That is, we should not assume some understanding of God outside the text and then bring that to the table to see what functions of this God Jesus takes over. Rather, as interpreters of Christian Scripture, we should consider the pattern of judgments that emerge in Paul’s epistles as part of Scripture’s witness as a whole that forges an identity for Israel’s God, YHWH."), _c('a', {
    attrs: {
      "id": "fn282"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn282",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("282")])]), _vm._v(" Such an endeavor has the potential of overcoming the dualism between ontological and functional categories. Like "), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_vm._v("much of the NT, then, 1 and 2 Thessalonians include Jesus as Lord ("), _c('i', [_vm._v("kyrios")]), _vm._v(") in the unique identity of the one God of Israel in a way that makes the relationship between the Father and the Son constitutive of that God’s identity (see comments on 1:1). By including Jesus within the unique divine identity of Yahweh, the NT affirms that Jesus reveals the character of Israel’s God and is thus the ultimate exemplar of what it means to be holy.")])]), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_vm._v("With the remainder of his public prayer in 3:12–13, Paul explicitly makes this holiness/sanctification a matter of public concern for the church. The prayer connects the language of holiness both with the heart ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("καρδία")]), _vm._v(", "), _c('i', [_vm._v("kardia")]), _vm._v(") and with public, communal practices. Using the language of “sanctification of the imagination” with reference to Paul’s concerns here corresponds roughly to the language of one’s heart being initially and continuously changed. The correspondence is rough partially because Paul’s usage of anthropological terms in reference to inner aspects of persons is often imprecise. As in the LXX, “heart” ("), _c('i', [_vm._v("kardia")]), _vm._v(") in the NT generally refers to “the "), _c('i', [_vm._v("inner person,")]), _vm._v(" the seat of understanding, knowledge and will, and takes on as well the meaning "), _c('i', [_vm._v("conscience.")]), _vm._v("”")]), _c('a', {
    attrs: {
      "id": "fn283"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("283")])]), _vm._v(" Paul uses "), _c('i', [_vm._v("kardia")]), _vm._v(" with both volitional (e.g., 1 Thess 2:4; 1 Cor 4:5) and cognitive (e.g., Rom 10:8–9) nuances, demonstrating that he can use the term to refer to the inner aspect of one’s intentions, dispositions, and cognitive judgments. However, he does not use “inner” anthropological terms (e.g., heart, soul, spirit, mind) in precise ways, nor does he bracket off the inner activities associated with these from their embodiment in public practices.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Given Paul’s concern about it in 3:1–10, being found blameless in holiness would certainly entail the audience’s divinely enabled (cf. 5:24) continued faithfulness to God in the midst of their tribulation. But here Paul specifically focuses on the Lord’s enabling the audience’s love ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀγάπη")]), _vm._v(", "), _c('i', [_vm._v("agapē,")]), _vm._v(" i.e., concrete self-giving actions) to increase as the context within, or the means by which,"), _c('a', {
    attrs: {
      "id": "fn284"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn284",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("284")])]), _vm._v(" their hearts will be strengthened to be blameless in holiness. Fittingly, Paul’s petition that the Thessalonians will be enabled to increase and abound in self-giving practices is addressed specifically to the Lord (Jesus), whose cruciform life pattern defines love toward others (Gal 2:20; 2 Thess 2:13)."), _c('a', {
    attrs: {
      "id": "fn285"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("285")])]), _vm._v(" The audience has already seen this pattern modeled in Paul’s actions for their sake (2:6–12),"), _c('a', {
    attrs: {
      "id": "fn286"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn286",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("286")])]), _vm._v(" a pattern of life that Paul describes in 2:10 as "), _c('i', [_vm._v("holy")]), _vm._v(" ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ὁσίως")]), _vm._v(", "), _c('i', [_vm._v("hosiōs")]), _vm._v("), righteous ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δικαίως")]), _vm._v(", "), _c('i', [_vm._v("dikaiōs")]), _vm._v("), and blameless ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀμέμπτως")]), _vm._v(", "), _c('i', [_vm._v("amemptōs")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Here, then, Paul is imploring the "), _c('i', [_vm._v("crucified")]), _vm._v(" and risen Lord to enable the "), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_vm._v("church to increase in "), _c('i', [_vm._v("cruciform")]), _vm._v(" practices (cf. Phil 1:9), practices in which Paul depicts them as "), _c('i', [_vm._v("already engaged")]), _vm._v(" (1:3; 3:6; 4:9–10). These are self-giving actions done by persons within the church for the sake of others within it and for the sake of “all,” including those outside the community (cf. 5:15; Gal 6:10).")]), _c('a', {
    attrs: {
      "id": "fn287"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn287",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("287")])]), _vm._v(" Since some of the latter may even be persecuting them, such expressions of love may indeed be costly. But as such, they reflect the words of this same Lord Jesus, who commands his disciples to love their enemies and to pray for those who persecute them, with the result that they show themselves as true sons and daughters of the Father, reflecting his own perfect (holy) character (Matt 5:43–48). Such loving actions in the midst of their own testing would, like the actions of Jesus in his wilderness testing, exhibit their fidelity/faithfulness to God’s way of living out their own sonship as they carry out God’s redemptive project in their particular social context. After all, in Pauline terms, this God reconciles his enemies with a very costly, loving act indeed—the death of his Son (Rom 5:8–10), the same Son who prays that the Father would forgive those (enemies) crucifying him (Luke 23:34)."), _c('a', {
    attrs: {
      "id": "fn288"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn288",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("288")])]), _vm._v(" Such practices are part and parcel of participating in the "), _c('i', [_vm._v("missio Dei")]), _vm._v(" and thus constitutive of their role as a "), _c('i', [_vm._v("holy")]), _vm._v(" people. Not surprisingly, then, the purpose for the Lord’s enabling them to increase in love is to establish their hearts “blameless in "), _c('i', [_vm._v("holiness")]), _vm._v("” at the Lord’s royal coming.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In this prayer, there is an initiating divine action (enabling the increase in love), followed by a responsive human action (engaging in cruciform practices)."), _c('a', {
    attrs: {
      "id": "fn289"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("289")])]), _vm._v(" In 4:10 Paul exhorts the audience to engage in the very action (i.e., to “continue abounding” in the loving practices of 4:9) that he implores the Lord to enable in 3:12. Hence, Paul depicts God as working among and in the Thessalonians, “not apart from, but in and through their own volition and action.”"), _c('a', {
    attrs: {
      "id": "fn290"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn290",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("290")])]), _vm._v(" This pattern is further evident from the prayer’s reciprocal movement "), _c('i', [_vm._v("from")]), _vm._v(" their being engaged in grace-enabled, self-giving practices "), _c('i', [_vm._v("to")]), _vm._v(" (or for the goal of)"), _c('a', {
    attrs: {
      "id": "fn291"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn291",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("291")])]), _vm._v(" their hearts/"), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("imaginations being strengthened to be blameless in holiness at the parousia. That is, Paul is depicting the Lord as sanctifying the hearts/imaginations of those in the church, not only in the encounter with graced persons like himself, but also "), _c('i', [_vm._v("in the context of,")]), _vm._v(" or even "), _c('i', [_vm._v("by means of,")]), _vm._v(" their own grace-enabled practices in a way that continues their initial transformation. The Lord’s enabling them to increase in love would therefore continue God’s transformation of them into a holy community whose conduct, like that of Paul’s among them (2:10), would be characterized by complete integrity (i.e., by being “blameless”) in the royal coming of the Lord. Prior to that time, Paul hopes for their communal life to exemplify increasing faithfulness toward God and to overflow with self-giving actions toward others—a “blameless” pattern of life analogous to that which Paul lived out among them (2:1–10).")]), _c('a', {
    attrs: {
      "id": "fn292"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn292",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("292")])]), _vm._v(" As such, they would be an instrument of the "), _c('i', [_vm._v("missio Dei,")]), _vm._v(" permeated with God’s own character/holiness as definitively revealed in the faithfulness and love of Jesus."), _c('a', {
    attrs: {
      "id": "fn293"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn293",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("293")])]), _vm._v(" It would be a “colony of cruciformity,”"), _c('a', {
    attrs: {
      "id": "fn294"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn294",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("294")])]), _vm._v(" an instantiation of the holiness of God in Thessalonica. Paul’s thanksgiving for this audience in 2 Thessalonians affirms that his prayer for them here is being at least partially answered before the Lord’s royal coming: “Brothers and sisters, as is only right, we’re bound to be thanking God always for you because your faithfulness is growing by leaps and bounds, and the love of every one of you for each other is increasing” (2 Thess 1:3).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Since Paul clearly depicts the parousia as a theophany (see comments on 4:13–18), it is not surprising that the parousia of the Lord also brings this community into the “presence of our God and Father” (a phrase that is very similar to the “presence of our Lord Jesus in his royal coming” in 2:19). The term “blameless” also implies judgment connected with the parousia, most probably of the sort that is referred to in 1:10 (“the coming wrath”), 5:2–3, and 2 Thess 1:5–9. The phrase “with his holy ones” is repeated in the context of the latter (2 Thess 1:10); in both places it could refer to angels,"), _c('a', {
    attrs: {
      "id": "fn295"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("295")])]), _vm._v(" Christians,"), _c('a', {
    attrs: {
      "id": "fn296"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn296",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("296")])]), _vm._v(" or both."), _c('a', {
    attrs: {
      "id": "fn297"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn297",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("297")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_vm._v("Although Paul never explicitly uses the adjective “holy” to describe angels, it does seem possible that “holy ones” should be understood as including angels in this context for the following reasons. First, in 2 Thess 1:7, when Jesus is revealed from heaven, he is accompanied by his “powerful angels.” Although Paul does not explicitly mention angels in 1 Thess 4:13–18, the archangel’s voice in 4:16 probably implies their presence. Second, in both the OT and NT there is a tradition of angels (sometimes called “holy”) being present at the final judgment (e.g., Dan 7:18; Mark 8:38; Matt 16:27; 25:31; Jude 14 [citing Zech 14:5]). Third, Paul appears to be alluding here to Zech 14:5 LXX, where Yahweh comes with his heavenly court/angels (“And the Lord, my God, will come and all his holy ones with him”).")])]), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("However, to limit the referent of “holy ones” to angels, either here or in 2 Thess 1:10, is unwarranted for several reasons.")])]), _c('ol', [_c('a', {
    attrs: {
      "id": "page_100"
    }
  }), _c('li', [_c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_vm._v("Elsewhere, Paul almost always uses the language of “holy ones/saints” as a general designation for members of early Christian communities who stand in some continuity with Israel as God’s holy/missional people (e.g., Rom 1:7, 15:25; 1 Cor 1:2; Col 1:26).")]), _c('a', {
    attrs: {
      "id": "fn298"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn298",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("298")])])]), _vm._v(" "), _c('li', [_vm._v("The whole context of 3:13 and the following section ending in 5:24 is that of the expected current and eschatological holiness of the Thessalonians.")]), _vm._v(" "), _c('li', [_vm._v("Given that Paul, in alluding to Zech 14:5, simply identifies the referent of “the Lord my God” as “our Lord Jesus,” it would not be unlikely if the referent of “all his holy ones” was also not exactly identical with its referent in Zechariah’s original context.")]), _vm._v(" "), _c('li', [_vm._v("In 2 Thess 1:10 the “holy ones” who honor the Lord at his revelation need not be a different group from those who have come to faith and “marvel at him”—that is, Christians. But even if those who honor him in 1:10 include angels, Paul’s prayer in 1:12 is that "), _c('i', [_vm._v("his audience")]), _vm._v(" will be among those who honor him."), _c('a', {
    attrs: {
      "id": "fn299"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn299",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("299")])])]), _vm._v(" "), _c('li', [_vm._v("It is worth noting that, early on, “all his holy ones” was interpreted as referring to those raised from the dead who will come with the Lord ("), _c('i', [_vm._v("Did.")]), _vm._v(" 16:6–7), not to members of a heavenly court.")])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Based on these observations, it seems best to understand “all his holy ones” in 3:13 (and possibly in 2 Thess 1:10) as including members of Christian communities whose hearts are “blameless in holiness” in the parousia, as well as God’s heavenly court/angels. As we will see, this understanding "), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_vm._v("is confirmed by the way Paul depicts the parousia in 4:13–18.")]), _c('a', {
    attrs: {
      "id": "fn300"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn300",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("300")])]), _vm._v(" There he does not explicitly say that Christ comes from heaven with his (powerful) angels as he does in 2 Thess 1:7, although the archangel’s voice in 4:16 probably implies it. But he does explicitly depict the parousia as something "), _c('i', [_vm._v("into which Christ-followers may go")]), _vm._v(" by meeting the Lord in the clouds/air (not in heaven!) and "), _c('i', [_vm._v("only then coming with the Lord")]), _vm._v(" to take up his reign. None of these Christians, however, is depicted as accompanying Jesus "), _c('i', [_vm._v("all the way from heaven,")]), _vm._v(" but they do meet him in the clouds/air to join in his parousia. Such a scenario gives no support to the idea of secretly raptured saints returning from heaven with Christ or, for that matter, to the idea that Christians who have died and are currently “with the Lord” return with him from heaven to earth (see comments on 4:13–16)."), _c('a', {
    attrs: {
      "id": "fn301"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn301",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("301")])]), _vm._v(" In any case, “becoming [entirely] holy as God is holy” (Lev 11:44–45; 19:2; 1 Pet 1:16) is a necessary prerequisite of being in the direct presence of the Triune God, whether in heaven (in the case of angels) or on earth (in the case of those in Christian communities).")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "s15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s15"
    }
  }, [_vm._v("4:1–5:24"), _c('span', {
    staticClass: "space"
  }, [_vm._v("God’s Sanctifying Work in the Life of the Community in Anticipation of the Parousia on the Day of the Lord")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("In the second major section of the letter Paul encourages his audience to avoid certain practices and engage in others (4:1–12; 5:12–22) and clarifies issues relating to the parousia (4:13–5:11). His primary purpose in doing so is to encourage and bolster his audience’s perseverance in faithfulness in connection with God’s sanctifying work and their blamelessness at the parousia (5:23–24). Much in this section is simply reinforcing reminders of what the audience already knows or is already apparently doing (4:1–2, 6, 9–10; 5:1–2, 11). In 4:13–18, however, Paul is communicating new information regarding the participation in the parousia of those who have died, and in 5:12–22 he offers general admonitions regarding the audience’s communal life, with no indication as to whether the audience is already engaged in the practices that he encourages or those he prohibits.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul has already used the language of holiness/sanctification immediately before this new section (3:13), and it becomes particularly important for this section as a whole, explicitly so in 4:3–8 and 5:23–24 and implicitly so in the rest of the section. Hence, before offering detailed comments on this section "), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_vm._v("of 1 Thessalonians, some more general comments on holiness/sanctification are in order.")])]), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_c('p', {
    staticClass: "line1"
  })]), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "s16"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_102"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#s16"
    }
  }, [_vm._v("Excursus on Holiness/Sanctification")])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("The primary terminology to refer to holiness in the Second Temple period (including the NT) is from "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἅγιος")]), _vm._v(" ("), _c('i', [_vm._v("hagios")]), _vm._v(") and its cognates, although other terms such as "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ὅσιος")]), _vm._v(" ("), _c('i', [_vm._v("hosios")]), _vm._v(") might also be used."), _c('a', {
    attrs: {
      "id": "fn302"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("302")])]), _vm._v(" "), _c('i', [_vm._v("Hagios")]), _vm._v(" and its verbal forms were seldom used in the Greco-Roman world, where the concept of holiness itself had little importance. The "), _c('i', [_vm._v("hosios")]), _vm._v(" word group was most often used to describe things and people associated with cultic activities, but gods and goddesses were rarely described as holy. In contrast, the concept of holiness was so important to Second Temple Judaism and the NT that it provides the implicit background of numerous texts, even where explicit holiness language does not appear.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Although not strictly opposites, holiness and impurity were both understood as dynamic forces, with holiness associated with (sources of) life, and impurity ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀκαθαρσία")]), _vm._v(", "), _c('i', [_vm._v("akatharsia")]), _vm._v(") with (sources of) death. As in the OT, in Second Temple Judaism there were dangerous consequences for contaminating God’s holy presence by bringing the holy into contact with the dynamic, contagious force of impurity. Hence, Second Temple conceptions of holiness had primarily to do with separation from the impure. This idea remained a concern for early Christians but was not configured along exactly the same lines as other forms of Second Temple Judaism. For example, although Paul continues to affirm the importance of purity or difference from pagan Gentiles—that is, avoiding sexual immorality (e.g., 1 Thess 4:5) and idolatry (e.g., 1 Thess 1:9; 1 Cor 10:1–22)—he rejects other traditional Jewish marks of holiness (e.g., circumcision, separate table fellowship) for his Gentile converts.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("For Paul, although the messianic age had indeed been inaugurated, it had happened in a most unexpected way, namely, via a Spirit-inhabited, crucified messiah. When Paul and the earliest church claimed that God was in Jesus, "), _c('i', [_vm._v("a crucified messiah")]), _vm._v(" (2 Cor 5:19), it was scandalous and foolish (1 Cor 1:23). But this cruciform messiah was vindicated by the Spirit"), _c('a', {
    attrs: {
      "id": "fn303"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("303")])]), _vm._v(" and is the exalted Lord, "), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_vm._v("who, then and now, remains marked by a cruciform character; he is “messiah having been "), _c('i', [_vm._v("and remaining")]), _vm._v(" [marked as] crucified” (1 Cor 1:23).")]), _c('a', {
    attrs: {
      "id": "fn304"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn304",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("304")])]), _vm._v(" Paul says that he “has become for us,” among other things, “holiness/sanctification ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἁγιασμός")]), _vm._v(", "), _c('i', [_vm._v("hagiasmos")]), _vm._v("] from God” (1 Cor 1:30). He reveals the very character of the God of Israel, and thereby the nature of God’s holiness. This Jew from Nazareth hanging on the cross therefore does so as a public display of God’s holiness, revealing the very character of YHWH to be cruciform."), _c('a', {
    attrs: {
      "id": "fn305"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn305",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("305")])]), _vm._v(" In Stephen Barton’s terms, holiness has been dislocated and relocated in the "), _c('i', [_vm._v("crucified Lord.")]), _c('a', {
    attrs: {
      "id": "fn306"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn306",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("306")])]), _vm._v(" Hence, the character of the sanctity/holiness that derives from this God—none other than the Triune God—may best be described as “cruciformity.”"), _c('a', {
    attrs: {
      "id": "fn307"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn307",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("307")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In this regard, as in other OT and Second Temple conceptions, holiness remains a dynamic force generating life—a dynamic salvific force that is (paradoxically) channeled through a death-dealing, shameful Roman cross. In this way, the Christ-event reconfigures OT and Second Temple conceptions of holiness primarily along the lines of a "), _c('i', [_vm._v("cruciform pattern of redemptive activity")]), _vm._v(" that reclaims persons for God’s reign and restores their relationship with the holy God, with others, and finally with creation itself. Hence, holiness retains its character as a dynamic force associated with life for Paul (e.g., holiness in Rom 6:22, whose goal ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("τέλος")]), _vm._v(", "), _c('i', [_vm._v("telos")]), _vm._v("] is the life of the age to come), albeit life that comes ironically through death in all its impurity, particularly death on a shameful and bloody cross (Phil 2:8c).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("When Paul uses language associated with holiness/sanctification (as in all of Second Temple Judaism), it is always derivative, that is, people, places, or things are holy only insofar as they are in relation to the Holy One, whose character defines holiness. There is a dynamic quality to this holiness in that it implies divine activity (which one might characterize as the "), _c('i', [_vm._v("missio Dei")]), _vm._v(") most focused in the Spirit-empowered faithfulness of the crucified and risen Christ, which itself calls forth and enables human participation in Christ’s faithfulness (i.e., active participation in the "), _c('i', [_vm._v("missio Dei")]), _vm._v("). This process whereby God calls forth and enables human participation in Christ’s faithfulness/mission constitutes God’s sanctifying activity for Paul, that is, God’s electing and setting apart a people to undergo Christoformity and thereby theoformity as God continues “giving his [life-giving] Spirit into them.”"), _c('a', {
    attrs: {
      "id": "fn308"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn308",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("308")])]), _vm._v(" If this phenomenon is a state, it is "), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_vm._v("not a static, passive state; it is a state "), _c('i', [_vm._v("of activity,")])]), _c('a', {
    attrs: {
      "id": "fn309"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("309")])]), _vm._v(" a process whereby the Holy Spirit shapes a people to become Christlike, individually and corporately, in the midst of, and at least at times by means of, the actions in which they engage, not least actions through which the Spirit continues God’s mission.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Such a process is certainly morally transformative for those involved, but it is more than that. When Paul has the end goal of this process in view in 1 Thessalonians, he uses the language of the audience participating eschatologically in divine glory ("), _c('i', [_vm._v("doxa")]), _vm._v("), God’s holiness made visible. As we have seen, such "), _c('i', [_vm._v("doxa")]), _vm._v(" granted to humans has both sociological and ontological aspects (see comments on 2:12), that is, public honor and fully sharing in the divine attributes of the "), _c('i', [_vm._v("living")]), _vm._v(" God, namely, incorruption and life. This culminating act of sanctification is God’s vindicating, transforming resurrection (or vindicating transformation of the living). It constitutes their glorification, their full and final justification, and their complete sanctification, in that they now fully share in God’s own glory, his self-vindication as true Lord of the cosmos, and his holiness. This whole process—from initial election to God’s bringing redeemed humanity to its intended destiny—can properly be called sanctification ("), _c('i', [_vm._v("hagiasmos")]), _vm._v("), theosis, or for that matter, salvation itself."), _c('a', {
    attrs: {
      "id": "fn310"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn310",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("310")])]), _vm._v(" From beginning to end it is a gift from the God who continues to give his Spirit into his elect people and will be faithful to complete it.")]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "s17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s17"
    }
  }, [_c('i', [_vm._v("4:1–8"), _c('span', {
    staticClass: "space"
  }, [_vm._v("God’s Will: The Sanctification of the Community")])])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('sup', [_vm._v("1")]), _vm._v("Therefore, brothers and sisters, to move on to what remains to be said, we’re asking and encouraging you all in the sphere of the Lord Jesus that, just as you received from us [instructions on] how you should live and be pleasing to God—just as, in fact, you are living"), _c('a', {
    attrs: {
      "id": "fn311"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("311")])]), _vm._v("—you continue flourishing in living this way even more. "), _c('sup', [_vm._v("2")]), _vm._v("For you all know what instructions we gave to you through the Lord Jesus. "), _c('sup', [_vm._v("3")]), _vm._v("For this is the will of God, the sanctification of you all [which requires] that you all avoid sexual "), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_vm._v("immorality. "), _c('sup', [_vm._v("4")]), _vm._v("More specifically, each of you [men] should learn to exercise control over your own male organ")]), _c('a', {
    attrs: {
      "id": "fn312"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn312",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("312")])]), _vm._v(" in holiness and with honor, "), _c('sup', [_vm._v("5")]), _vm._v("not “exercising control” with lustful passion like the Gentiles who do not acknowledge God. "), _c('sup', [_vm._v("6")]), _vm._v("In this matter, you are not to wrong or exploit your brother or sister, because the Lord is an avenger regarding these things, just as we also told you beforehand and solemnly testified. "), _c('sup', [_vm._v("7")]), _vm._v("For God did not call us to impurity but [to live] in the sphere of sanctification. "), _c('sup', [_vm._v("8")]), _vm._v("Therefore, the one who rejects [these instructions] is not rejecting a human but the God who is giving his Holy Spirit into you all.")]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("With the word “therefore,” Paul connects his prayer for the sanctification of the audience’s imagination in 3:12–13 with “what remains to be said,”"), _c('a', {
    attrs: {
      "id": "fn313"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn313",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("313")])]), _vm._v(" that is, the exhortation he is about to give in 4:1–8, as well as the broader paraenetic context through 5:22. Using a complimentary paraenetic style appropriate for exhorting friends, Paul portrays his audience in this section as "), _c('i', [_vm._v("currently")]), _vm._v(" conducting themselves in a way that is “pleasing to God” (vv. 1–2)."), _c('a', {
    attrs: {
      "id": "fn314"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn314",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("314")])]), _vm._v(" This characterization reinforces the point that they are indeed “imitators” of Paul and his cosenders (1:6), whose cruciform pattern of life in 2:1–12 has the characteristic of “not attempting to please humans but God” (2:4).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As we saw in the comments on 3:12–13, Paul has just prayed that "), _c('i', [_vm._v("the Lord will enable")]), _vm._v(" the Thessalonians to increase and flourish ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("περισσεύσαι")]), _vm._v(", "), _c('i', [_vm._v("perisseusai")]), _vm._v(") in the very self-giving actions in which he depicts them as already being engaged (1:3; 3:6; 4:9–10). Now, "), _c('i', [_vm._v("on the basis of")]), _vm._v(" that prayer just voiced publicly for them, in 4:1 Paul encourages them as one who lives in the same sphere of the reigning Lord Jesus as they do to “continue flourishing ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("περισσεύητε")]), _vm._v(", "), _c('i', [_vm._v("perisseuēte")]), _vm._v("] in living this way even more.” This exhortation is therefore cast in the same language as that of the enabling action he attributes to the Lord in the immediately preceding prayer in 3:12. The theo-logic of this wording is that, while the Lord’s enabling action is clearly prior, such enabling action generates and requires an "), _c('i', [_vm._v("ecclesial")]), _vm._v(" response, which consists of a continued pattern of life in which cruciform and therefore theo-form actions are on the increase. The "), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_vm._v("Lord Jesus embodied this cruciform pattern of activity in a way that effected the saving, reconciling purposes of the Triune God. God’s own activity in their grace-enabled response will result in their being “blameless in holiness at the Lord’s royal coming,” since it is this cruciform pattern of activity, the dynamic force of holiness, that is being embodied in their community. Throughout the Bible divine activity expresses divine essence/character, and the same is true of human communities and communal persons. Ecclesial activity expresses ecclesial essence/character.")])]), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_vm._v("While Paul and his companions modeled positive exemplary practices of self-giving love, their modeling also included abstaining from certain other practices and calling attention to their doing so with the language of prohibitions. Hence, it is likely that the instructions mentioned in v. 2 at least included (but were probably not exhausted by)")]), _c('a', {
    attrs: {
      "id": "fn315"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("315")])]), _vm._v(" the kinds of prohibitions that follow in vv. 3b–6a.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("With the “for” in v. 3, Paul connects these instructions with the will of God and places the audience’s sanctification in apposition to the latter. “For this is the will of God,” he says, “the sanctification ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἁγιασμός")]), _vm._v(", "), _c('i', [_vm._v("hagiasmos")]), _vm._v("] of you all.” English translations treat the noun "), _c('i', [_vm._v("hagiasmos")]), _vm._v(" in various ways."), _c('a', {
    attrs: {
      "id": "fn316"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn316",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("316")])]), _vm._v(" Given that the strengthening of the audience’s hearts to be blameless in holiness ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἁγιωσύνῃ")]), _vm._v(", "), _c('i', [_vm._v("hagiōsynē")]), _vm._v(") is to be accomplished by the Lord’s enabling them to increase and flourish in practices of self-giving love, it is hard to imagine that “your sanctification ["), _c('i', [_vm._v("hagiasmos")]), _vm._v("]” in this verse refers simply to a passive state granted by God, that is, a static condition to be expressed. Holiness/sanctification is indeed a state characteristic of those “in Christ,” but like salvation itself (see comments on 1 Thess 5:9), not a completely static or passive state. As the Lord enables the church to increase and flourish in cruciform (holy) practices and in and through them sanctifies their imaginations, the active state of those “in Christ” might best be described in the language of 2 Cor 7:1 as an ongoing state of “perfecting holiness ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἁγιωσύνην")]), _vm._v(", "), _c('i', [_vm._v("hagiōsynēn")]), _vm._v("].” Flourishing in such Spirit-enabled practices, in addition to continuing to abstain from certain other practices, would result in their hearts (imagination) being “blameless” in holiness at the parousia.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Hence, the term "), _c('i', [_vm._v("hagiasmos")]), _vm._v(" (sanctification) here is best understood as a process,"), _c('a', {
    attrs: {
      "id": "fn317"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn317",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("317")])]), _vm._v(" one initiated and completed by God, but not apart from the volition "), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_vm._v("and participative activity of the church. The Thessalonians’ sanctification began when God elected and set them apart for participation in the "), _c('i', [_vm._v("missio Dei")]), _vm._v(" and continued by God’s shaping their imagination and bodies by means of their participation in this mission as they flourished in practices of self-giving love. For the process to continue, however, they must also avoid some practices that might compromise their capacity to reflect God’s own character. Adhering to the prohibitions that follow is depicted as a "), _c('i', [_vm._v("necessary condition")])]), _c('a', {
    attrs: {
      "id": "fn318"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn318",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("318")])]), _vm._v(" for God to continue and complete his sanctifying work and for the audience to reflect his holy character.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The syntactic structure and exact meaning of the clauses (particularly that of v. 4) containing these prohibitions are much debated. Verses 3b–6a have three clauses, all of which are closely related and have to do with sexual matters."), _c('a', {
    attrs: {
      "id": "fn319"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("319")])]), _vm._v(" The first admonition (i.e., to abstain from sexual immorality in 3b) is made more specific by the second admonition in vv. 4–5 (on the meaning of which, see below). The last clause (not to wrong or exploit your brother or sister in this matter in 6b) explicates the effect of failing to follow Paul’s admonition in vv. 4–5."), _c('a', {
    attrs: {
      "id": "fn320"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn320",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("320")])]), _vm._v(" If this summary is correct, the fact that Paul equates engaging in the specific sexual activity prohibited in vv. 4–5 as wronging or exploiting one’s “brother/sister” ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀδελφόν")]), _vm._v(", "), _c('i', [_vm._v("adelphon")]), _vm._v(") makes it likely that these particular admonitions are directed primarily toward intracommunal sexual practices. Even so, the typically (although not universally) tolerant attitude toward male sexual activity outside of marriage in non-Jewish society at large would be reason enough for Paul to remind this Gentile audience that any such activity would compromise their identity as God’s holy people. Apart from some moral philosophers (e.g., Musonius Rufus), the idea that free males should not have sexual relations outside of marriage would have been countercultural indeed. On the contrary, it was “common sense”—even their right—and not categorized as immoral.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Hence, Paul’s first admonition in v. 3 to abstain ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἀπέχεσθαι")]), _vm._v(", "), _c('i', [_vm._v("apechesthai")]), _vm._v(") from sexual immorality ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("πορνεία")]), _vm._v(", "), _c('i', [_vm._v("porneia")]), _vm._v(") would have a decidedly Jewish ring and content, namely, to avoid any form of sexual relations outside marriage."), _c('a', {
    attrs: {
      "id": "fn321"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn321",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("321")])]), _vm._v(" This is the same verb used to admonish the “Gentiles who are turning to God” in "), _c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_vm._v("Acts 15:19 in the so-called apostolic decree to abstain ("), _c('i', [_vm._v("apechesthai")]), _vm._v(") from things polluted by idols and from sexual immorality ("), _c('i', [_vm._v("porneia")]), _vm._v(").")]), _c('a', {
    attrs: {
      "id": "fn322"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn322",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("322")])]), _vm._v(" Paul is reminding this Gentile audience, who turned to God from idols (1:9–10), that their continuing sanctification is contingent upon their abstaining from sexual immorality. Like other Jews of the time influenced by their Scripture (e.g., Wis 14:12), Paul readily made a connection between idolatry and sexual immorality."), _c('a', {
    attrs: {
      "id": "fn323"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn323",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("323")])]), _vm._v(" Not only was Israel’s idolatry/covenant unfaithfulness rhetorically cast in terms of sexual immorality/adultery (e.g., Ezek 23; Hos 1:2), it was typical for Jews to see idolatry and sexual immorality as connected and as the paradigmatic sins of the Gentile world (note the progression of thought in Rom 1:23–27). In a sense, "), _c('i', [_vm._v("porneia")]), _vm._v(" was a form or expression of idolatry. In a city like Thessalonica, the two were also concretely connected at the social level in a variety of ways (e.g., public festivals and banquets in the temples or private homes involving gluttony, drunkenness, and sex with prostitutes)."), _c('a', {
    attrs: {
      "id": "fn324"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn324",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("324")])]), _vm._v(" Engaging in "), _c('i', [_vm._v("porneia,")]), _vm._v(" even (or especially!) at the intracommunal level, would make the Thessalonians’ life together indistinguishable from much of the society around them, threatening their character as a community set apart from its culture as an instrument in the "), _c('i', [_vm._v("missio Dei.")]), _vm._v(" Such activity might even reflect the character and activities of the gods in the Greco-Roman pantheon, but certainly not the faithful character of Israel’s God, to whom the audience had turned. It would therefore ultimately be a move toward idolatry and thus could simply not coexist with God’s sanctifying activity.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is not entirely clear what Paul means in v. 4, in particular how to translate "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("σκεῦος κτᾶσθαι")]), _vm._v(" ("), _c('i', [_vm._v("skeuos ktasthai")]), _vm._v("). The referent of the noun "), _c('i', [_vm._v("skeuos")]), _vm._v(" and the meaning of the infinitive "), _c('i', [_vm._v("ktasthai")]), _vm._v(" have been the source of disagreement among translators and interpreters of these letters from antiquity to the present."), _c('a', {
    attrs: {
      "id": "fn325"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn325",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("325")])]), _vm._v(" The main options include the following:"), _c('a', {
    attrs: {
      "id": "fn326"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn326",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("326")])])]), _vm._v(" "), _c('ol', [_c('li', [_c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_vm._v("Paul is counseling "), _c('i', [_vm._v("the unmarried men")]), _vm._v(" in his audience “to understand/learn how to acquire ["), _c('i', [_vm._v("ktasthai")]), _vm._v("] a wife ["), _c('i', [_vm._v("skeuos")]), _vm._v("]” for themselves as a guard against sexual immorality (cf. 1 Cor 7:9, 36).")]), _c('a', {
    attrs: {
      "id": "fn327"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn327",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("327")])])]), _vm._v(" "), _c('li', [_vm._v("Paul is exhorting "), _c('i', [_vm._v("any married man")]), _vm._v(" in the audience “to understand/learn how to live with ["), _c('i', [_vm._v("ktasthai")]), _vm._v("] his wife ["), _c('i', [_vm._v("skeuos")]), _vm._v("] in holiness and honor,”"), _c('a', {
    attrs: {
      "id": "fn328"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn328",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("328")])]), _vm._v(" especially with regard to avoiding any “lustful passion” as they are having sex."), _c('a', {
    attrs: {
      "id": "fn329"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn329",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("329")])])]), _vm._v(" "), _c('li', [_vm._v("Paul is counseling "), _c('i', [_vm._v("the men")]), _vm._v(" in the audience “to understand/learn how to exercise control over ["), _c('i', [_vm._v("ktasthai")]), _vm._v("] their own penis ["), _c('i', [_vm._v("skeuos")]), _vm._v("].”"), _c('a', {
    attrs: {
      "id": "fn330"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn330",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("330")])])]), _vm._v(" "), _c('li', [_vm._v("Paul is encouraging the whole audience, "), _c('i', [_vm._v("both males and females,")]), _vm._v(" “to understand/learn how to exercise control over ["), _c('i', [_vm._v("ktasthai")]), _vm._v("] their own body ["), _c('i', [_vm._v("skeuos")]), _vm._v("].”"), _c('a', {
    attrs: {
      "id": "fn331"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn331",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("331")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("None of these options is free of difficulties. Option 1 does not adequately explain why Paul would use such ambiguous language to counsel acquiring a wife."), _c('a', {
    attrs: {
      "id": "fn332"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn332",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("332")])]), _vm._v(" He is perfectly capable of using typical words for husband and wife in 1 Cor 7:1–7, where he speaks of them providing each other with sexual satisfaction as a guard against "), _c('i', [_vm._v("porneia.")]), _vm._v(" This option also seems to make the verb “understand/learn how” ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εἰδέναι")]), _vm._v(", "), _c('i', [_vm._v("eidenai")]), _vm._v(") unnecessary. It also leaves no good explanation for why Paul would warn (Gentile) males in the audience "), _c('i', [_vm._v("not")]), _vm._v(" to “acquire a wife in lustful passion like the Gentiles who do not acknowledge God,” as though he was unaware that those unbelieving Gentiles would not have considered the purpose of marital sex to be satisfying a man’s sexual desires. While some ancient Greek romantic novels may have viewed sexual relations within marriage as a way of controlling sexual passions,"), _c('a', {
    attrs: {
      "id": "fn333"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn333",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("333")])]), _vm._v(" it was more typical to portray marital sex as being for the purpose of having children, not for satisfying one’s sexual desires."), _c('a', {
    attrs: {
      "id": "fn334"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn334",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("334")])]), _vm._v(" Mistresses and prostitutes were more typical outlets for satisfying a man’s “lustful passions.” With regard to option 2,"), _c('a', {
    attrs: {
      "id": "fn335"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn335",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("335")])]), _vm._v(" to say that "), _c('a', {
    attrs: {
      "id": "page_110"
    }
  }, [_vm._v("Paul is counseling “passionless sex” within marriage is in some tension with what he says in 1 Cor 7:1–7 about the role of marriage partners satisfying each other sexually as a prophylactic against "), _c('i', [_vm._v("porneia.")])]), _c('a', {
    attrs: {
      "id": "fn336"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("336")])]), _vm._v(" Also, unless v. 6 is dealing with something else altogether, it is difficult to see what failure to have stoic-like “passionless sex” within marriage could have to do with “wronging or exploiting one’s brother/sister ["), _c('i', [_vm._v("adelphos")]), _vm._v("].” As regards option 4, while Paul certainly can use "), _c('i', [_vm._v("skeuos")]), _vm._v(" to refer to the human body in general (2 Cor 4:7), it is difficult to understand why he would do so in a context where a simple reference to the word “body” ("), _c('i', [_vm._v("sōma")]), _vm._v(") would have sufficed.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("With these difficulties in mind, I see option 3 as the simplest and most likely alternative."), _c('a', {
    attrs: {
      "id": "fn337"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn337",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("337")])]), _vm._v(" It best explains why Paul would use such indirect language here, that is, he wants to refer to the penis euphemistically in a public setting, for this letter is being read aloud “to all the brothers and sisters” (5:27). In a culture in which phallic symbols were widespread and the sexual practices of many male Gentiles were roundly criticized by many Jews, it is not surprising that Paul might counsel the Gentile males in this audience to gain mastery over ("), _c('i', [_vm._v("ktasthai")]), _vm._v(") their penises, unlike those Gentiles in their culture who do not acknowledge God and who use them “in passionate lust.” What follows in v. 6 would also make good sense in that failure to respond to Paul’s counsel “in this particular matter” would indeed have the potential"), _c('a', {
    attrs: {
      "id": "fn338"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn338",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("338")])]), _vm._v(" of wronging or exploiting a brother or sister (see below). The primary objection to this view is that "), _c('i', [_vm._v("ktasthai")]), _vm._v(" (gain mastery over) does not normally have a durative sense (i.e., possess/control) in the present tense. However, although this sense may have been confined to the perfect and pluperfect tenses in classical Greek, there is evidence in the papyri and other texts of this meaning appearing in other tenses, including the present."), _c('a', {
    attrs: {
      "id": "fn339"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("339")])]), _vm._v(" Hence, it does not seem unreasonable to think that Paul may be using it in a durative sense here to mean something like “exercise control over.”"), _c('a', {
    attrs: {
      "id": "fn340"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn340",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("340")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("While certainty thus remains impossible, it is probable that vv. 4–5 describe more explicitly what abstaining from "), _c('i', [_vm._v("porneia")]), _vm._v(" entails in the particular "), _c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_vm._v("situation Paul addresses here; namely, males in the audience are to learn to exercise control over their own penis in holiness and with honor, not “exercising control” with lustful passion “like the Gentiles who do not acknowledge God” might claim they are doing by engaging in various sexual encounters. Although terminological connections are absent here, this was basically what some male elites in society claimed about their bodies and their senses (by twisting Plato), that is, that unbridled pleasurable sexual actions demonstrated their ownership/control over their own bodies to use them as “nature” intended.")]), _c('a', {
    attrs: {
      "id": "fn341"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn341",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("341")])]), _vm._v(" Hence, a commonsense way of demonstrating that a free male was exercising proper ownership/control of his own penis would have been to engage in what Jews would have called "), _c('i', [_vm._v("porneia.")]), _vm._v(" In this countercultural community, however, Paul says that the reverse is true. Males in the holy sphere of the lordship of Christ demonstrate that they exercise control over their own penis in holiness and with the honor consistent with that sphere of lordship. That is, they engage in sexual relations only with their wife in a way that displays sexual fidelity and love to her, thereby analogically reflecting the faithful character of the one in whose sphere of lordship they now reside.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A possible objection to this interpretation is that the audience would have to recognize that “each of you all” in v. 4 specifically addresses the males in the audience, whereas the language of “you all” ("), _c('i', [_vm._v("hymeis")]), _vm._v(") in the surrounding verses (4:1–3, 6, 8) seems to apply to the whole audience, both male and female. Although, on the basis of the verbal and conceptual parallels between this passage and Rom 1:24–28, it is tempting to address this possible objection by taking "), _c('i', [_vm._v("skeuos")]), _vm._v(" as a euphemism for both male and female sex organs, there is little precedent for its being used as a euphemism for the female sex organ."), _c('a', {
    attrs: {
      "id": "fn342"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("342")])]), _vm._v(" Hence, it seems better to assume that Paul is tailoring his general example of the "), _c('i', [_vm._v("porneia")]), _vm._v(" to be avoided in vv. 4–6 to what he imagines is more likely in the circumstances of this newly converted audience, namely, a possible illicit sexual relationship initiated by a free male in the audience who, in general, would have more power and opportunity to do so than would females. The euphemistic metaphor itself would have been the signal to the whole audience that Paul was momentarily addressing these free males. But it would not necessarily have signaled that the rest of Paul’s rhetoric in the context did not apply to the women also, who were part of a corporate body whose holiness would be threatened if a male member of that body failed to exercise sexual control."), _c('a', {
    attrs: {
      "id": "fn343"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn343",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("343")])]), _vm._v(" Hence, whereas in this specific "), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_vm._v("context Paul momentarily singles out the free males in his audience with his euphemistic metaphor, it remains God’s will that "), _c('i', [_vm._v("all")]), _vm._v(" in the audience be holy, abstain from "), _c('i', [_vm._v("porneia,")]), _vm._v(" and thus not hinder the work of the Holy Spirit, whom God was continuing to “give into [them] all.”")])]), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_vm._v("In this context, failing to exercise such control and instead acting with the sort of lustful passion characteristic of Gentiles who do not acknowledge God would result in wronging or exploiting an "), _c('i', [_vm._v("adelphos")]), _vm._v(" (brother or sister) in God’s household. There is no reason that the word "), _c('i', [_vm._v("adelphos")]), _vm._v(" should not be heard in a gender-inclusive sense in this context. Paul would probably consider that a male church member had been wronged or exploited if another male member of the church engaged in sex with the former’s wife, daughter, or possibly their female slave. He would probably also consider that a female member of the church, whether married or unmarried, had been wronged or exploited if a male member who was not her husband had sex with her, treating her as simply an object for his “lustful passion.” If there were members of this church who owned slaves who were also a part of the church, Paul’s language here would also function as a warning against the commonsense view that a free male had the right to use that slave (whether male or female) as a means of satisfying his sexual urges.")]), _c('a', {
    attrs: {
      "id": "fn344"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("344")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In any case, all such intracommunal sexual practices would reflect the opposite of cruciform behavior and therefore would fail to reflect the character of God. Instead, they would reflect the (Gentile) pattern of life outside the church, life among “the Gentiles who do not acknowledge God” (4:5), life among those who have not “turned to God from idols to be enslaved to the living and true God” (1:9). In this case, “sexual immorality . . . and cruciform love cannot coexist, for "), _c('i', [_vm._v("porneia")]), _vm._v(" is a form of self-love, of self-indulgence that harms others and diminishes the holiness of both the individual and the community.”"), _c('a', {
    attrs: {
      "id": "fn345"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn345",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("345")])]), _vm._v(" Here, then, it is precisely sexual behavior that expresses the opposite of cruciformity (and therefore, holiness) that is being prohibited."), _c('a', {
    attrs: {
      "id": "fn346"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn346",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("346")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Before moving on to comment on the reasons Paul gives for avoiding these sexually immoral practices in vv. 6b–8, we should note a number of verbal and conceptual connections between this section of Paul’s letter and Ezek 36:16–37:14. Acknowledging the failure of Israel as a whole to reflect God’s holiness, which brings down his wrath upon them (Ezek 36:16–21), Ezekiel announces to the exiled nation that God would restore them by (1) cleansing them from their impurities (e.g., Ezek 36:25b, 29a; cf. 1 Thess 4:7), namely, the polluting effects of "), _c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_vm._v("idolatry; (2) taking them “out of the nations/Gentiles” (36:24),")]), _c('a', {
    attrs: {
      "id": "fn347"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn347",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("347")])]), _vm._v(" giving them “a new heart” (36:26; cf. 1 Thess 3:13); and (3) giving his “Spirit/breath in/among you all” (36:26–27; cf. Jer 31:34; Joel 2:28–29; cf. 1 Thess 4:8). This restoration and renewal of exiled Israel is then depicted in Ezek 37 with the well-known imagery of the Spirit’s actions in the valley of (Israel’s) dry bones. No fewer than four times, Ezekiel emphasizes that the Spirit enters "), _c('i', [_vm._v("into")]), _vm._v(" ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εἰς")]), _vm._v(", "), _c('i', [_vm._v("eis")]), _vm._v(") these dry bones (37:5, 6, 10, 14). Two of these times he uses the language of God’s "), _c('i', [_vm._v("giving")]), _vm._v(" his Spirit “into ["), _c('i', [_vm._v("eis")]), _vm._v("] you all” (37:6, 14), language almost identical to that used in 1 Thess 4:8. But Israel is not renewed simply for its own sake (Ezek 36:21–23). Rather, it is for the sake of Yahweh’s holy name or reputation. As Yahweh says in 36:23b, it is so that “the nations will know that I, myself, am the Lord "), _c('i', [_vm._v("when I manifest my holiness by means of you all")]), _vm._v(" before their eyes.” Hence, there is a missional impetus, namely, to put Yahweh’s character/holiness on public display before the eyes of the nations by means of Israel’s life together. Israel is, in essence, depicted as a new creation brought into existence by the life-giving breath/Spirit in order to reflect the image of the holy God to the nations, who do not currently acknowledge him. This language and imagery from Ezekiel provide a scriptural matrix within which to hear the reasons Paul gives for avoiding the sexually immoral practices in vv. 6b–8."), _c('a', {
    attrs: {
      "id": "fn348"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn348",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("348")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("First, utilizing a familiar biblical pattern when the (lack of) holiness of God’s people is in view (cf. Ezek 36:16–21),"), _c('a', {
    attrs: {
      "id": "fn349"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn349",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("349")])]), _vm._v(" Paul reminds his audience of what he had told them before, namely, that “the Lord is an avenger ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἔκδικος")]), _vm._v(", "), _c('i', [_vm._v("ekdikos")]), _vm._v("] in all these things” (v. 6b). That is to say, the "), _c('i', [_vm._v("cruciform")]), _vm._v(" Lord, to whom this audience owes its very existence as a people, will avenge activity "), _c('i', [_vm._v("within the corporate life of this people")]), _vm._v(" that violates his own character. He does so because, as Yahweh’s name was publicly linked with Israel in Ezekiel, so the Lord’s name is publicly linked with the life of this Thessalonian assembly. This is an ominous note, a warning that even those who were called to live “in the sphere of sanctification” (v. 7), as Israel had been, might choose to live in a way that betrays their identity as the holy ones of God (as Israel had, Ezek 36:16–21). If they do so, according to 2 Thess 1:7–9, the Lord Jesus at his revelation from heaven will give just punishment ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐκδίκησις")]), _vm._v(", "), _c('i', [_vm._v("ekdikēsis")]), _vm._v("), not only to those who do not acknowledge God (like the Gentiles of 1 Thess 4:5), but also to those whose pattern of life indicates that they are “not "), _c('i', [_vm._v("obeying")]), _vm._v(" the gospel about our Lord Jesus Christ.” The related terminology here in 1 Thessalonians (cf. "), _c('i', [_vm._v("ekdikos")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_vm._v("and "), _c('i', [_vm._v("ekdikēsis")]), _vm._v("), especially given its rarity in Paul as an eschatological referent,")]), _c('a', {
    attrs: {
      "id": "fn350"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn350",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("350")])]), _vm._v(" suggests that these passages are mutually interpreting. Hence, the pattern of life that Paul warns the audience about here in vv. 3b–6a is one form of behavior that illustrates what he means in 2 Thess 1:8 by “not obeying the gospel of our Lord Jesus Christ.” Conversely, since the avoidance of this sort of activity is constitutive of “your sanctification ["), _c('i', [_vm._v("hagiasmos")]), _vm._v("],” actually obeying the good news by displaying self-controlled, cruciform behavior is constitutive of sanctification ("), _c('i', [_vm._v("hagiasmos")]), _vm._v(") itself.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The second reason for avoiding these practices comes in v. 7, where Paul reminds his audience that God did not call us to impurity ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐπὶ ἀκαθαρσίᾳ")]), _vm._v(", "), _c('i', [_vm._v("epi akatharsia")]), _vm._v(") but to live in the sphere of sanctification ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἐν ἁγιασμῷ")]), _vm._v(", "), _c('i', [_vm._v("en hagiasmō")]), _vm._v("). While Paul can use "), _c('i', [_vm._v("akatharsia")]), _vm._v(" (impurity) with nonsexual nuances (e.g., 1 Thess 2:3), he most often uses it, as he does here, in contexts where sexual immorality is in view."), _c('a', {
    attrs: {
      "id": "fn351"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn351",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("351")])]), _vm._v(" Holiness and impurity were not strictly opposites in Second Temple Judaism."), _c('a', {
    attrs: {
      "id": "fn352"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn352",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("352")])]), _vm._v(" As we noted in the excursus above, however, both were understood as dynamic forces: holiness a force associated with (sources of) life, and impurity a polluting force associated with (sources of) death.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Already in the OT, the meaning of "), _c('i', [_vm._v("akatharsia")]), _vm._v(" (impurity) moved beyond simply ritual impurity and included the polluting effects of idolatry (e.g., Ezek 36:25b, 29a) and other objectionable behaviors, including sexual immorality (e.g., Ezek 22:10–16). In this context, it is clear that the “impurity” with which Paul was concerned is not ritual in nature. Paul’s later use of the word in Rom 1:24 informs its usage here. In the context of Rom 1, Paul connects "), _c('i', [_vm._v("akatharsia")]), _vm._v(" (Rom 1:24) with sexual immorality "), _c('i', [_vm._v("resulting from idolatry.")]), _vm._v(" There, God “gives up” those whose choices amount to a vote for idolatry to the powerful, “polluting” effects of "), _c('i', [_vm._v("akatharsia,")]), _vm._v(" with the result that they dishonor their own bodies with inappropriate sexual actions. Hence, for Paul, "), _c('i', [_vm._v("akatharsia")]), _vm._v(" seems to retain some of its OT character as a dynamic, contagious—even enslaving—force, one that for him may be expressed by, and result from, sinful sexual activity. It is obvious from 1 Cor 5 and 6:12–20 that Paul thinks that sinful sexual activity can infiltrate, pollute, and damage entire relational networks. Anyone who has seen the rippling effects of the damage done to relationships when improper sexual behavior is discovered in a tight-knit, local church will share a sense of Paul’s concern.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_vm._v("Given these observations, it is clear why Paul would say that one reason to avoid the practices in 3b–5a is that God did not call us to impurity ("), _c('i', [_vm._v("akatharsia")]), _vm._v("). It is one way that their entire network of relations would become polluted with a powerful, contagious force whose end result would be death. The result would be that neither the corporate body as a whole nor the persons within it could continue to experience in beneficial ways the dynamic, life-giving (now personal) force of holiness, namely, God’s Holy Spirit.")])]), _c('a', {
    attrs: {
      "id": "page_115"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_vm._v("This reason to avoid such sexual practices is directly connected with the final and most important reason for avoiding them, namely, that rejecting these prohibitions amounts to a rejection of the God who, in Ezekiel-like language, “is giving his Holy Spirit into you all” (4:8; cf. Ezek 37:6, 14). Paul’s language in reference to the Spirit here is unusual in two ways. First, he speaks of God’s gifting of the Spirit with a present tense verb, signaling an ongoing supplying of the Spirit (cf. Gal 3:5), not simply a onetime gift, whose presence is continuing to give life to this community. Second, apparently under the influence of Ezek 37, he speaks of God’s giving this Spirit who brings dry bones to life "), _c('i', [_vm._v("into")]), _vm._v(" ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εἰς")]), _vm._v(", "), _c('i', [_vm._v("eis")]), _vm._v(") you all.")]), _c('a', {
    attrs: {
      "id": "fn353"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn353",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("353")])]), _vm._v(" In Ezekiel, this life-giving Spirit moves among the whole community of exiled Israel, as well as "), _c('i', [_vm._v("into")]), _vm._v(" each set of bones, bringing them all to life together. Here, then, Paul’s language refers to the continual empowering activity of this life-giving, now cruciform, Holy Spirit being breathed "), _c('i', [_vm._v("into")]), _vm._v(" both the community as a whole body and into the individual bodies of its members. With God’s "), _c('i', [_vm._v("Holy")]), _vm._v(" Spirit now continuously energizing every part of their bodies (even their "), _c('i', [_vm._v("skeuos")]), _vm._v("!),"), _c('a', {
    attrs: {
      "id": "fn354"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn354",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("354")])]), _vm._v(" they need not be enslaved to the cultural patterns of "), _c('i', [_vm._v("porneia,")]), _vm._v(" with their bodies vehicles for the contagious effects of impurity ("), _c('i', [_vm._v("akatharsia")]), _vm._v("). Hence, to engage in such patterns of behavior would be tantamount to rejecting the gift of the Holy Spirit, whose purpose was to sanctify them, that is, to enable their life together in the sphere ruled by the cruciform Lord to publicly display "), _c('i', [_vm._v("this Lord’s")]), _vm._v(" character/holiness before the eyes of the Gentiles who did not acknowledge their God "), _c('i', [_vm._v("so that they would come to acknowledge him as Lord.")]), _vm._v(" Like Ezek 36–37, then, this text also has a missional direction. The "), _c('a', {
    attrs: {
      "id": "page_116"
    }
  }, [_vm._v("ultimate purpose for the Thessalonians to avoid sexual immorality is so that others will see the image of the holy God instantiated in a communal body of flesh-and-blood human bodies animated by the Spirit of the new age and thereby be drawn to acknowledge the Cruciform One they see reflected there as Lord indeed (cf. Phil 2:6–11).")]), _c('a', {
    attrs: {
      "id": "fn355"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn355",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("355")])])]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "s18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s18"
    }
  }, [_c('i', [_vm._v("4:9–12"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Flourishing in Love and Working to Avoid Dependence on Patrons")])])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('sup', [_vm._v("9")]), _vm._v("Now about loving your sisters and brothers, you all have no need [for us]"), _c('a', {
    attrs: {
      "id": "fn356"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn356",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("356")])]), _vm._v(" to write to you. For you yourselves are taught by God so that you all love one another. "), _c('sup', [_vm._v("10")]), _vm._v("For you’re also doing (loving deeds) for all the brothers and sisters in the whole of Macedonia. Now we encourage you, brothers and sisters, to continue flourishing even more [in your loving deeds] "), _c('sup', [_vm._v("11")]), _vm._v("and to aspire to live quietly, tend to your own affairs, and work with your [own] hands, just as we instructed you all "), _c('sup', [_vm._v("12")]), _vm._v("so that you may live properly with regard to those outside, that is, that you all will not be dependent on anyone.")]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("Most commentators contend that 4:9–12 is related to Paul’s admonition in 5:14. There he counsels his audience to warn “those who are disorderly idlers,” which seems connected to the intracommunal situation he confronts in 2 Thess 3:6–13, with some who are refusing to work “living in disorderly idleness” (2 Thess 3:6, 11). Through what lens are we to view that intracommunal situation? Given the ubiquity of the patronage system in the audience’s social milieu, explicitly interpreting these three passages in light of it (1 Thess 4:9–12, esp. vv. 11–12; 5:12–14; 2 Thess 3:6–13) seems reasonable"), _c('a', {
    attrs: {
      "id": "fn357"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn357",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("357")])]), _vm._v(" and is less speculative than some of the alternatives."), _c('a', {
    attrs: {
      "id": "fn358"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn358",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("358")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_117"
    }
  }, [_vm._v("In the honor/shame–based Greco-Roman society, public life (as opposed to family life) was structured with a network of patron/client relationships. Economic and social life was characterized by the dependency of clients upon their patrons for financial assistance (at times including necessities like food and clothing) or influence the patron might exercise on their behalf because of his higher social status. In return, the client might come to the patron’s house in the morning to publicly honor him, would publicly speak out in support of his economic and social interests, and might be used by the patron on errands that would further those interests in the city’s public square. The more clients a patron had, the more honor and power accrued to him. Patrons themselves were clients of higher-status patrons in a kind of pyramid scheme of relationships that topped out at the emperor. It was engrained in the imagination of most in Greco-Roman culture that public life should be structured in this way. Acting on the basis of the assumptions it engendered would have seemed natural, nothing but common sense.")]), _c('a', {
    attrs: {
      "id": "fn359"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn359",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("359")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It would not have been surprising, then, that at least some in the Thessalonian congregation might not have discerned that attempting to pattern their life both within and outside the church on the basis of “business as usual” patronage assumptions might threaten their loyalty to God. This threat could show up in two related ways. First, for members of this community to indebt themselves to a patron outside the church could result in extreme pressure to display loyalty to that patron in ways that might compromise their loyalty to the God to whom they had turned. What might they do, for example, if their patron invited them to his daughter’s birthday party in a local temple where sacrificial meat would be served? They would have an obligation to their patron to attend; to refuse to do so would be an offense to him. However, to go and participate might, from Paul’s perspective, not only be an offense to God, but also be perilously close to turning back to their former life of idolatry and its demonic enslavement (1 Cor 10:14–22).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Second, for an able-bodied church member to attempt to cultivate a client relationship with another member of the church as their patron in lieu of engaging in some form of labor would lessen the ability of the church to take care of its genuinely “weak” members (5:14). It would also impede its ability to continue being a channel of grace (esp. in the form of economic aid) to other "), _c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_vm._v("Christians outside Thessalonica “in the whole of Macedonia” (v. 10). Such a life pattern would stand in tension with that of the cruciform Lord. For those involved, attempting to cultivate relationships with patrons inside or outside of the church may have seemed very natural and certainly not like intentional disloyalty to God. As such, it could indeed be one of the things lacking in the "), _c('i', [_vm._v("pistis")]), _vm._v(" (faithfulness/loyalty) of some in the audience, one of the things Paul continues using this section of his letter to address.")])]), _c('a', {
    attrs: {
      "id": "page_118"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_vm._v("With this in mind, we are not surprised to encounter a topic in v. 9 related to Paul’s cautions in 4:6a, that is, “love for brothers and sisters ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("φιλαδελφίας")]), _vm._v(", "), _c('i', [_vm._v("philadelphias")]), _vm._v("].” The word "), _c('i', [_vm._v("philadelphia")]), _vm._v(" was used for love between members of the same family/household, where life was not (at least overtly) structured in terms of the patronage system. Throughout the letter Paul has depicted the audience in familial terms as a community characterized by love (1:3; 3:6, 12). Here he tells them he has no need to write to them about it, effectively complimenting them by pretending to pass over the topic while nevertheless reinforcing what they already know about it and clarifying what it entails in their life together.")]), _c('a', {
    attrs: {
      "id": "fn360"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn360",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("360")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As we saw in the last section, Paul has already described the Thessalonians in terms reminiscent of Ezekiel’s description of Israel restored from exile, that is, as animated by Ezekiel’s life-giving Spirit. Apparently drawing from another prophetic context referring to God’s restoration of Israel from exile (Isa 54), Paul now describes them with what appears to be a neologism, that is, “God taught” ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("θεοδίδακτοι")]), _vm._v(", "), _c('i', [_vm._v("theodidaktoi;")]), _vm._v(" cf. John 6:45)"), _c('a', {
    attrs: {
      "id": "fn361"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn361",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("361")])]), _vm._v(" to love one another. They are indeed a community restored from (figurative) exile by Ezekiel’s life-giving Spirit, “whose sons and daughters are taught by God ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("διδακτοὺς θεοῦ")]), _vm._v(", "), _c('i', [_vm._v("didaktous theou,")]), _vm._v(" Isa 54:13 LXX],” experiencing God’s own “covenant of peace” (v. 10 LXX), essentially bearing the marks of Jeremiah’s “new covenant” community, where God “gives his laws into their mind and writes them upon their hearts” (Jer 31:33 LXX; 38:33). Given Paul’s emphasis so far on the way his own example (explicitly in 1:6, implicitly in 2:1–12) and teachings (4:1–2) have provided the content of the audience’s instruction, “God taught” probably does not mean unmediated instruction from God. It may, however, include the audience’s knowledge of Scripture related to loving your neighbor (e.g., Lev 19:18) in a way that reflects the holy character of God."), _c('a', {
    attrs: {
      "id": "fn362"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn362",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("362")])]), _vm._v(" In any case, their “doing” "), _c('a', {
    attrs: {
      "id": "page_119"
    }
  }, [_vm._v("of loving deeds")]), _c('a', {
    attrs: {
      "id": "fn363"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn363",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("363")])]), _vm._v(" is on display, extending to brothers and sisters throughout the whole of Macedonia.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul then encourages the community as a whole to continue flourishing in these practices toward sisters and brothers both within and without the immediate "), _c('i', [_vm._v("ekklēsia,")]), _vm._v(" thereby partially"), _c('a', {
    attrs: {
      "id": "fn364"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn364",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("364")])]), _vm._v(" fulfilling Paul’s prayer in 3:12, that is, that the Lord would enable them “to increase and to flourish in love for one another and for all.” Verse 11 describes the sort of life pattern that will enable this growth to happen. They are to aspire to live quietly and tend to their own affairs. Such advice, if followed, would at least have the effect of not intentionally provoking more persecution."), _c('a', {
    attrs: {
      "id": "fn365"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn365",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("365")])]), _vm._v(" In addition, whether or not the two phrases together had a more technical sense of withdrawing altogether from public political life,"), _c('a', {
    attrs: {
      "id": "fn366"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn366",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("366")])]), _vm._v(" following this advice would make it very difficult for any audience member to cultivate a client relationship with a patron outside the church, given that in doing so, they would have to be tending to their patron’s affairs, not their own—and doing so in the public arena."), _c('a', {
    attrs: {
      "id": "fn367"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("367")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("From Paul’s point of view, his counsel to “work with your [own] hands” would have been a clear alternative to seeking to cultivate relationships with a patron, whether outside or inside the church (cf. 1 Cor 9:12–18). Paul had already exemplified this pattern of life when he brought the gospel to them (2:9). His very life pattern embodied that gospel in that, even though he could have thrown his weight around, he refused to do so, working long and hard hours "), _c('i', [_vm._v("in order to avoid burdening them")]), _vm._v(" (see comments on 2:7–9). He did so with only their benefit in mind, demanding no reciprocal response from them, as the logic of the patronage system might have dictated. Hence, while cultivating relationships with patrons might have seemed entirely natural to some, Paul has already embodied, and now encourages, a different pattern of life for a community whose purpose is to embody the character of the cruciform Christ. But as we noted above, engaging in manual labor in this social context is not simply a way to avoid becoming a burden to others in the local church. It would also be a way to become a means of grace to others (cf. Eph "), _c('a', {
    attrs: {
      "id": "page_120"
    }
  }, [_vm._v("4:28),")]), _c('a', {
    attrs: {
      "id": "fn368"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn368",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("368")])]), _vm._v(" an activity through which God continues to work to sanctify the imagination of those participating in it.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This whole pattern of life (aspiring to live quietly, tending to one’s own affairs, engaging in manual labor) will enable the community to continue to flourish in doing loving deeds for each other and for Christians outside of their local fellowship. The result"), _c('a', {
    attrs: {
      "id": "fn369"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn369",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("369")])]), _vm._v(" of this way of living will be that they will be living with propriety or properly ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εὐσχημόνως")]), _vm._v(", "), _c('i', [_vm._v("euschēmonōs")]), _vm._v(") with regard to those outside the community. Paul’s language here is ambiguous and could mean that either (1) from the perspective of those outside the community, the community is living “properly” if its embodies the pattern of life Paul is recommending, or (2) from the perspective of those inside the church, this pattern of life is the “proper” way to live toward those outside the community. Paul’s use of the word elsewhere is not determinative in this case,"), _c('a', {
    attrs: {
      "id": "fn370"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn370",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("370")])]), _vm._v(" but other factors favor the latter."), _c('a', {
    attrs: {
      "id": "fn371"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn371",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("371")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Verse 12b is best understood as further explaining what “living properly with regard to those outside” means."), _c('a', {
    attrs: {
      "id": "fn372"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn372",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("372")])]), _vm._v(" In this case, then, this clause entails that those in the community are not dependent on anyone, the very antithesis to structuring life in terms of normal patron/client relationships. It seems unlikely that those outside the community—especially possible former patrons, for whom the patronage system was simply a matter of common sense—would think it was proper behavior for those in this community to seek not to be engaged in any client relationships with those outside it."), _c('a', {
    attrs: {
      "id": "fn373"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn373",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("373")])]), _vm._v(" It is more likely that the calculus for determining what constitutes proper behavior is one that is internal to the community. They are acting properly with regard to those outside the church when they are not dependent on any one of them. Mutual interdependence is indeed proper for those in the body of Christ, as Paul’s body imagery in 1 Cor 12 affirms, but not the sort of interdependence characteristic of patron/client relationships.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In this section, then, Paul is counseling a pattern of behavior whose purpose is to enable the whole church to flourish in loving deeds toward each other and toward Christians outside the local assembly. If all able-bodied church "), _c('a', {
    attrs: {
      "id": "page_121"
    }
  }, [_vm._v("members work with their hands rather than seeking to cultivate business-as-usual patron/client relationships, the first result would be an enhanced ability of the whole community to be an effective economic means of grace to those in need within it, as well as to Christians in need outside it. The second result would be that church members would also avoid becoming clients of those outside, avoiding the possible pressure of displaying loyalty to their patron in ways that might compromise, albeit unintentionally, their loyalty to the God to whom they had turned.")])]), _c('a', {
    attrs: {
      "id": "page_121"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_121"
    }
  }, [_vm._v("Some would characterize the language in 4:9–12 as Paul’s counsel to the Thessalonians who are refusing to work to stay out of public/political life.")]), _c('a', {
    attrs: {
      "id": "fn374"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn374",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("374")])]), _vm._v(" While this description is true to the extent that engaging in public/political life in this social context would have meant engaging it on its own terms (i.e., as structured by the patronage system), such a characterization can be misleading. Paul’s counsel, if followed in this social context, would have resulted in a community who publicly embodied the "), _c('i', [_vm._v("logos")]), _vm._v(" of the cross, that is, the way of thinking produced by the cross (1 Cor 1:18) rather than the common-sense assumptions of the patronage system. "), _c('i', [_vm._v("It would have been a reconfiguration of public life in cruciform, and therefore, holy, terms, not a withdrawal into the sphere of the private.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is certainly possible that some in such a community (even if all “work with their hands”) will continue to have relatively higher status and wealth at their disposal than others and, as such, will be better able than some to “care for” others in the congregation by rendering them aid in some form (see comments on 5:12–13). Such people might typically be categorized as patrons and emerge as de facto leaders of the community. But even if this is the case in this church, Paul’s language does not depict such relationships in business-as-usual patron/client terms. As we will note in the comments on 5:13, those who could be categorized as patrons of this congregation deserve the acknowledgment and love of other community members because of their cruciform work within the congregation, not because of their inherent social status in Greco-Roman society.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "s19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s19"
    }
  }, [_c('i', [_vm._v("4:13–18"), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Resurrection of Those “Sleeping” at the Royal Coming of the Lord")])])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('sup', [_vm._v("13")]), _vm._v("Now we do not want you all to be uninformed, brothers and sisters, about those who are sleeping, so that you will not grieve like the rest, who have no hope."), _c('a', {
    attrs: {
      "id": "fn375"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn375",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("375")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_122"
    }
  }, [_c('sup', [_vm._v("14")]), _vm._v("For since we believe that Jesus died and rose, so also God, through Jesus, will bring those who have fallen asleep so that they might be with him. "), _c('sup', [_vm._v("15")]), _vm._v("For we are saying this to you all in accordance with this message about the Lord, that we who are living and remaining will surely not precede the ones who have fallen asleep into the royal coming of the Lord. "), _c('sup', [_vm._v("16")]), _vm._v("[This is] because the Lord himself will descend from heaven with a commanding shout, accompanied by a sound the archangel makes—that is, accompanied by the trumpet of God—and the dead will rise first through Christ’s actions. "), _c('sup', [_vm._v("17")]), _vm._v("Then we ourselves who are living and remaining will be caught up together with")]), _c('a', {
    attrs: {
      "id": "fn376"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn376",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("376")])]), _vm._v(" them by the clouds into a meeting with the Lord in the air. And thus we will always be with the Lord. 18So then, comfort each other with these words.")]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "s20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s20"
    }
  }, [_c('i', [_vm._v("The Main Issue in the Community")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("The community situation Paul is addressing in 4:13–18 has been reconstructed in a variety of ways."), _c('a', {
    attrs: {
      "id": "fn377"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("377")])]), _vm._v(" The issue involves some sort of knowledge about “the ones who are sleeping,” with the lack of such knowledge causing grief in the community (4:13). But what sort of knowledge? General historical and rhetorical considerations make it unlikely that the audience lacked knowledge of a future resurrection of the dead,"), _c('a', {
    attrs: {
      "id": "fn378"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn378",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("378")])]), _vm._v(" and Paul’s rhetoric clearly assumes his audience’s belief in the Lord’s royal coming, or parousia (2:19; 3:13). The primary issue, then, is not total lack of knowledge about the future resurrection or lack of belief in the parousia but how the two are connected. Given the clear emphasis on issues of timing (the language of “first,” “then”), the focus of the section seems to be the "), _c('i', [_vm._v("timing")]), _vm._v(" of the resurrection of the dead in relationship to the parousia. To be more specific, the source of grief in the audience seems to be uncertainty over whether those in the church who die before the parousia "), _c('a', {
    attrs: {
      "id": "page_123"
    }
  }, [_vm._v("will be raised and united with the living church members in time to meet the Lord in his parousia.")]), _c('a', {
    attrs: {
      "id": "fn379"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn379",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("379")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Portraying the issue in this way is solidly anchored in textual indicators. An explanation as to "), _c('i', [_vm._v("why")]), _vm._v(" such timing is important for the church depends on what sort of historical information one brings to bear on the text. While there are other historically plausible alternatives for explaining the audience’s concern with timing,"), _c('a', {
    attrs: {
      "id": "fn380"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn380",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("380")])]), _vm._v(" the following explanation seems the most historically probable and seems to open the door to a fruitful theological engagement with the text (both in the comments that immediately follow and in the Theological Horizons portion of the commentary).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul refers to the coming of the/our Lord as a parousia six times in 1 and 2 Thessalonians (1 Thess 2:19; 3:13; 4:15; 5:23; 2 Thess 2:1, 8) and only once outside these letters—and that in a context in which political overtones are unmistakable, as the Lord comes to publicly consummate his reign over the cosmos (1 Cor 15:23). When used in connection with the imperial honorific language of Lord ("), _c('i', [_vm._v("kyrios")]), _vm._v("), as well as other language with political connotations,"), _c('a', {
    attrs: {
      "id": "fn381"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn381",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("381")])]), _vm._v(" “parousia” carries with it a loose pattern of cultural expectations associated with the arrival of a king, an important official, or even the emperor himself."), _c('a', {
    attrs: {
      "id": "fn382"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn382",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("382")])]), _vm._v(" Hence, the description of Christ’s coming as a parousia carries with it the cultural images of a royal parade, a victorious king coming in great honor into a city.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In v. 15 Paul assures the audience that those who are living will not precede those who have died into the Lord’s parousia, depicting it as something "), _c('i', [_vm._v("into")]), _vm._v(" which people can go, that is, something in which one might participate."), _c('a', {
    attrs: {
      "id": "fn383"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn383",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("383")])]), _vm._v(" To participate in the royal parade welcoming and honoring one crucified by the empire whom you had acclaimed as Lord would bring not only honor to that Lord but vindication and honor to you as well (see the comments on 2:12 and 2 Thess 1:12). Paul had already admonished the Thessalonians to continue walking worthy of the God who even now is calling them “into his own kingdom "), _c('a', {
    attrs: {
      "id": "page_124"
    }
  }, [_vm._v("and honor/glory” (2:12). In such a social context, even though Paul does not say it explicitly, the import of the resurrection of the dead would have been not only about the assurance of individual salvation but also about issues of "), _c('i', [_vm._v("public honor—")]), _vm._v("albeit an honor whose basis has been recalibrated in God’s alternative court of reputation as sharing in the cruciform character of the coming Lord.")]), _c('a', {
    attrs: {
      "id": "fn384"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn384",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("384")])]), _vm._v(" If the dead whose lives had a cruciform shape because of their suffering faithfulness are not raised "), _c('i', [_vm._v("in time")]), _vm._v(" to share in the public vindication of their cruciform Lord, might they miss out on their own "), _c('i', [_vm._v("public")]), _vm._v(" vindication and sharing in the very honor/glory ("), _c('i', [_vm._v("doxa")]), _vm._v(") to which God had called them? Without this hope for public vindication, there might indeed be reason for grief on behalf of those who would be left out of it.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("With some confidence, then, we may say that this section of the letter clarifies the timing of the resurrection of the dead in relationship to the parousia. The social context of first-century Thessalonica and other clues in 1 and 2 Thessalonians make it historically probable that Paul says what he does to assure his audience that the dead who had experienced public dishonor because of their suffering faithfulness would share in the public vindication/honor of their "), _c('i', [_vm._v("kyrios")]), _vm._v(" (Lord) as they participated in his victorious royal parade. And if Paul’s habit elsewhere of describing resurrection life with "), _c('i', [_vm._v("doxa")]), _vm._v(" (glory/honor) and its cognates (see comments on 2:12) is allowed to influence the interpretation of this section, we may say that his mention of the resurrection of the members of this community also carries with it connotations of incorruption and life, that is, of transformation."), _c('a', {
    attrs: {
      "id": "fn385"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn385",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("385")])])]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "s21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s21"
    }
  }, [_c('i', [_vm._v("Death, Resurrection, and the Coming of the Lord")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodyFlush1"
  }, [_vm._v("Paul’s desire that his brothers and sisters not be uninformed (cf. Rom 1:13; 11:25; 1 Cor 10:1; 12:1; 2 Cor 1:8) signals that what follows is best understood as new, or at least clarifying, information concerning “those who are sleeping,” a common euphemism for those who had died, which Paul also uses elsewhere (1 Cor 11:30; 15:6, 18, 20, 51). The language has little, if anything, to say about the nature of an “intermediate state” and at most simply depicts these dead community members as being capable of being “awakened” by resurrection. But will those who have "), _c('a', {
    attrs: {
      "id": "page_125"
    }
  }, [_vm._v("died in suffering faithfulness (i.e., sharing in the "), _c('i', [_vm._v("pistis Christou")]), _vm._v(" [faithfulness of Christ]) be raised in time to share in Christ’s public vindication? In other words, can Paul’s later words in Rom 8:17 be trusted? If we cosuffer with him, will we indeed be cohonored/coglorified ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("συνδοξασθῶμεν")]), _vm._v(", "), _c('i', [_vm._v("syndoxasthōmen")]), _vm._v(") with him? Paul attempts to clarify the matter for them so that they will not grieve “just as the rest who have no hope.”")]), _c('a', {
    attrs: {
      "id": "fn386"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn386",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("386")])]), _vm._v(" The wording here need not be taken as indicating an absolute prohibition against any grieving at all for their dead brothers and sisters, but rather as prohibiting grief over the specific issue in this context,"), _c('a', {
    attrs: {
      "id": "fn387"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn387",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("387")])]), _vm._v(" that is, a fear that those sleeping will not be raised in time to share in the parousia. Whatever concrete form such grief might take, it could make the church publicly indistinguishable from “the rest, the ones who have no hope.” A proper Christian response to death that allows the church to give public witness to its specific form of hope is not to deny grief; it is, rather, to frame such grief with the comforting hope for the particular embodied salvation that comes through our Lord Jesus Christ (5:8). Neither a grief borne out of a sense of hopelessness nor a grief thinly masked by various forms of gnostic speculations of disembodied bliss—often seen at “Christian” funerals where there is no body or ashes present to remind us that Death is the last enemy that will finally be destroyed at the future resurrection—is the kind of grief that enables the church to give public witness to the particular hope that animates it.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The meaning of the first part of 4:14 is clear. Paul begins a conditional statement with a claim to which both he and his audience adhere: “Since we believe that Jesus died and rose.”"), _c('a', {
    attrs: {
      "id": "fn388"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn388",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("388")])]), _vm._v(" This affirmation is in some sense the basis for every eschatological claim Paul makes, in this passage or elsewhere. That God the Father vindicated his Son through the Spirit by raising him from the dead and transforming his body is the past event that functions as the primary lens through which any Christian version of the future is to be imagined and depicted. The “then” part of the clause in 4:14 follows (translated in very wooden fashion): “thus also God the ones who have fallen asleep through/in Jesus ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("διὰ τοῦ Ἰησοῦ")]), _vm._v(", "), _c('i', [_vm._v("dia tou Iēsou")]), _vm._v("] he will bring [to be] with him ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("σὺν αὐτῷ")]), _vm._v(", "), _c('i', [_vm._v("syn autō")]), _vm._v("].” There are a variety of ways to render this text, depending on how one takes the prepositional phrases "), _c('i', [_vm._v("dia tou Iēsou")]), _vm._v(" and "), _c('i', [_vm._v("syn autō.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_126"
    }
  }, [_vm._v("With regard to the former, one might take "), _c('i', [_vm._v("dia tou Iēsou")]), _vm._v(" as meaning “in Jesus” and as modifying “the ones who have fallen asleep,” as the NIV does: “God will bring with Jesus those who have fallen asleep "), _c('i', [_vm._v("in him.")]), _vm._v("” However, what it might mean to fall asleep “through/in Jesus” is unclear, and it is unconvincing to argue that it does similar duty as Paul’s more usual language of being “in Christ” ("), _c('i', [_vm._v("en Christō")]), _vm._v(").")]), _c('a', {
    attrs: {
      "id": "fn389"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn389",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("389")])]), _vm._v(" In addition, everywhere else where Paul uses "), _c('i', [_vm._v("dia tou")]), _vm._v(" followed by Jesus, Christ, Lord, or combinations thereof, the phrase always functions instrumentally."), _c('a', {
    attrs: {
      "id": "fn390"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn390",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("390")])]), _vm._v(" God will raise followers of Jesus through Jesus himself at the parousia, which resonates with what Paul says elsewhere (e.g., 1 Cor 15:21; Phil 3:21). Alternatively, then, one might take "), _c('i', [_vm._v("dia tou Iēsou")]), _vm._v(" instrumentally (“through Jesus”) as modifying “will bring”: “God, through Jesus, will bring those who have fallen asleep” (cf. the NRSV: “through Jesus, God will bring with him those who have died”).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("With regard to the translation of "), _c('i', [_vm._v("syn autō,")]), _vm._v(" simply translating it as “with him” might create an initial impression that the dead come with Jesus "), _c('i', [_vm._v("from heaven.")]), _vm._v(" But Paul never says any such thing elsewhere, and given what follows in this context, it makes little sense. Rather, "), _c('i', [_vm._v("syn autō")]), _vm._v(" is best taken as equivalent to “so that they might be with him” ("), _c('i', [_vm._v("eis to einai autous syn autō")]), _vm._v("),"), _c('a', {
    attrs: {
      "id": "fn391"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn391",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("391")])]), _vm._v(" yielding the following translation of v. 14b: “So also God, through Jesus, will bring those who have fallen asleep so that they might be with him.” That is, God the Father, "), _c('i', [_vm._v("through the activity of the risen Lord Jesus")]), _vm._v(" in his parousia in v. 16,"), _c('a', {
    attrs: {
      "id": "fn392"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn392",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("392")])]), _vm._v(" will bring those who have fallen asleep to be with him by raising them "), _c('i', [_vm._v("first")]), _vm._v(" so that they can participate in his royal coming in the very presence of the holy God, along with those living at the time. Hence, they will share not only in Christ’s story of death but also in his resurrection/vindication (cf. 5:10; Rom 6:8; 8:17; 1 Cor 15; Phil 3:20–21).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul’s warrant for saying what follows in 4:15b–17"), _c('a', {
    attrs: {
      "id": "fn393"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn393",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("393")])]), _vm._v(" is that it is “in accordance with this message about the Lord ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("λόγῳ κυρίου")]), _vm._v(", "), _c('i', [_vm._v("logō kyriou")]), _vm._v("),” that is, the "), _c('a', {
    attrs: {
      "id": "page_127"
    }
  }, [_vm._v("mutually believed message about Jesus’ death and resurrection in 4:14a.")]), _c('a', {
    attrs: {
      "id": "fn394"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn394",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("394")])]), _vm._v(" Most translate what comes next along the lines of “we who are living and remaining "), _c('i', [_vm._v("at")]), _vm._v(" ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εἰς")]), _vm._v(", "), _c('i', [_vm._v("eis")]), _vm._v("] the parousia of the Lord will surely not precede those who have fallen asleep.” This rendering takes the "), _c('i', [_vm._v("eis")]), _vm._v(" as indicating time and modifying “those who remain,” that is, “those who remain "), _c('i', [_vm._v("at the time of")]), _vm._v(" the parousia of the Lord.” But neither Paul nor any other NT writer ever uses "), _c('i', [_vm._v("eis")]), _vm._v(" prior to the word “parousia” elsewhere,"), _c('a', {
    attrs: {
      "id": "fn395"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn395",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("395")])]), _vm._v(" which suggests a different way to render the verse here, namely, “we who are living and remaining will surely not precede "), _c('i', [_vm._v("into")]), _vm._v(" ["), _c('i', [_vm._v("eis")]), _vm._v("] the parousia of the Lord the ones who have fallen asleep.”"), _c('a', {
    attrs: {
      "id": "fn396"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn396",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("396")])]), _vm._v(" In this rendering, "), _c('i', [_vm._v("eis")]), _vm._v(" has its more typical force of indicating “movement toward or into,” thereby depicting the parousia as something "), _c('i', [_vm._v("into")]), _vm._v(" which people can go—that is, an event in which one might participate. Therefore, what Paul is saying that is conceptually “in accordance with this message about the Lord” is that God, through Jesus’ own activity at the parousia, will raise the dead and lead them into the royal parade to be with Jesus. Those who are still living will not precede those in the community who had died in going into this royal welcoming parade, which affirms that the latter will not miss out on the honor of participating in it. John Chrysostom also recognized the connection of honor and participation in the parousia:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("If He is about to descend, on what account shall we be caught up? "), _c('i', [_vm._v("For the sake of honor.")]), _vm._v(" For when a king drives into a city, "), _c('i', [_vm._v("those who are in honor go out to meet him;")]), _vm._v(" but the condemned await the judge within. . . . For He received Him up in the clouds, and “we shall be caught up in the clouds.” Seest thou "), _c('i', [_vm._v("how great is the honor?")]), _vm._v(" And as He descends, we go forth to meet Him, and, what is more blessed than all, so we shall be with Him. ("), _c('i', [_vm._v("Homily")]), _vm._v(" 8 on 1 Thessalonians, my italics; cf. also his comments on v. 15 in "), _c('i', [_vm._v("Homily")]), _vm._v(" 7)")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Because of what the Lord himself will do at the royal coming, the living will “surely not precede” the ones who have fallen asleep. He will descend "), _c('a', {
    attrs: {
      "id": "page_128"
    }
  }, [_vm._v("from heaven (as in Phil 3:20–21), and the dead will rise first, as a result of God raising them through Christ’s actions.")]), _c('a', {
    attrs: {
      "id": "fn397"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn397",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("397")])]), _vm._v(" What actions one should attribute to Jesus other than simply descending from heaven depends on how one understands the following three phrases expressing circumstances that attend to the Lord’s descent. Various construals of these phrases are possible, depending on what sorts of historical and textual parallels one introduces and what one imagines is the main thrust of the passage itself."), _c('a', {
    attrs: {
      "id": "fn398"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn398",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("398")])]), _vm._v(" My interpretation will be coherent with what we have argued is Paul’s main focus in this section, namely, that God will raise the dead "), _c('i', [_vm._v("through Jesus")]), _vm._v(" in time for them to participate in the royal welcoming parade. We will also introduce partial parallels with other NT texts to help warrant this way of construing these phrases. Since, as we have noted earlier, 1 Thessalonians is most probably the earliest Christian document in the NT canon, it should be obvious that I am not arguing that Paul would have been aware of any of these parallels. Rather, I am maintaining that, in a theological commentary that affirms that this letter is located not only in a context of first-century Thessalonica but also in the context of a canon of Scripture, it is appropriate to (at least partially) warrant particular textual construals by appealing to parallels with other passages within that canon.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The phrase “with a commanding shout” is best taken as indicating that the Lord will descend with "), _c('i', [_vm._v("his own")]), _vm._v(" shout of command, whose purpose is to command the dead to awake."), _c('a', {
    attrs: {
      "id": "fn399"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn399",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("399")])]), _vm._v(" The Fourth Gospel makes the clear claim that it is the Son who will raise up those who “believe into him” on the last day (6:39–40, 44, 54); more to the point here, it claims that he will do so "), _c('i', [_vm._v("with his voice:")])]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_c('sup', [_vm._v("25")]), _vm._v("Very truly I say to you all that the hour is coming—and now is here—when the dead will hear the voice of the Son of God, and those who hear will come to life. "), _c('sup', [_vm._v("26")]), _vm._v("For just as the Father has life in himself, so also he has granted to the Son to have life in himself. . . . "), _c('sup', [_vm._v("28")]), _vm._v("Do not marvel at this; for the hour is coming when all those in the tombs will hear his voice, "), _c('sup', [_vm._v("29")]), _vm._v("and they will come out, those who have done good into a resurrection of life, "), _c('a', {
    attrs: {
      "id": "page_129"
    }
  }, [_vm._v("but those who have practiced evil into a resurrection of judgment. (John 5:25–26, 28–29)")]), _c('a', {
    attrs: {
      "id": "fn400"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn400",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("400")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb1"
  }, [_vm._v("Such language is essentially an oral explication of Jesus’ claim to be “the resurrection and the life” (11:25). Shortly after making that claim in 11:25, he demonstrates it with a graphic, albeit proleptic (since Lazarus dies again), portrayal when he stands at the tomb of Lazarus and "), _c('i', [_vm._v("cries out with a loud voice,")]), _vm._v(" “Lazarus, come out!” (11:43). Hence, the Son of God, who raises Lazarus with a loud command and promises to raise the dead with his voice on the last day, will descend at the parousia and keep that promise “with a commanding shout.” On this reading of this phrase, it is Jesus’ own action in his descent that is the agency through which God raises the dead. This reading has the potential for further theological development in a pneumatological direction. We attempt to do so below in the section “You Wonder Where the Spirit Went” in the Theological Horizons portion of the commentary. To anticipate what we will conclude there, through this commanding shout the Son releases the breath/Spirit he receives from the Father to go forth into hopelessly dead bodies to permeate and transform them into bodies appropriate for the new creation, bodies that Paul calls elsewhere “spiritual bodies” (1 Cor 15:44).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Son’s making-alive shout is accompanied by the sound the archangel makes,"), _c('a', {
    attrs: {
      "id": "fn401"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn401",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("401")])]), _vm._v(" the one who is (apparently) in charge of “his powerful angels,” who come with Jesus from heaven (2 Thess 1:7) to gather the elect as in Matt 24:31 (cf. Jude 9, where Michael is identified as “the archangel”). This sound that the archangel makes is probably blowing the trumpet belonging to God,"), _c('a', {
    attrs: {
      "id": "fn402"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn402",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("402")])]), _vm._v(" but certainty about the matter is neither possible nor necessary. Granted, the use of trumpets was not typical of the parousia tradition in the Greco-Roman world,"), _c('a', {
    attrs: {
      "id": "fn403"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn403",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("403")])]), _vm._v(" which is not surprising, for Paul is not attempting to forge a one-to-one correspondence "), _c('a', {
    attrs: {
      "id": "page_130"
    }
  }, [_vm._v("between the Lord’s coming and the parousia tradition (on which, see below). Trumpets do, however, have a number of functions in Israel’s Scriptures that make a trumpet blast clearly appropriate in this context.")]), _c('a', {
    attrs: {
      "id": "fn404"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn404",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("404")])]), _vm._v(" Here, the trumpet’s blast signals the commencement of the Day of the Lord, where the King of the cosmos has arrived to lead the final battle, in which Death as the last enemy is completely destroyed and God becomes “all in all” (cf. 1 Cor 15:23–28, 50–58).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("With the ink still drying on the word “first” at the end of v. 16, Paul begins v. 17 with “then,” rhetorically emphasizing that the main issue here is that of timing. He affirms that the living will not precede the dead into the parousia but that either they will all be “caught up” ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἁρπάζω")]), _vm._v(", "), _c('i', [_vm._v("harpazō")]), _vm._v(") together or, possibly, that the community members who had died would go into the parousia right before the living were caught up into it, perhaps increasing their honor even more. In either case, Paul’s main concern here is to emphasize that those who have died will be raised "), _c('i', [_vm._v("in time to be together in the parousia")]), _vm._v(" with those who are still living.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This is the only time in the Bible where the verb "), _c('i', [_vm._v("harpazō")]), _vm._v(" (“caught up”) is used in an eschatological context. The Latin equivalent, "), _c('i', [_vm._v("rapio")]), _vm._v(" (I snatch, carry away), is the word from which the English word “rapture” is derived. Hence, this text has been understood throughout most of church history to refer to the “rapture” of Christians, albeit not to the “secret rapture” so beloved by premillennial dispensationalists."), _c('a', {
    attrs: {
      "id": "fn405"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn405",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("405")])]), _vm._v(" But here the word Paul uses simply means “snatched up” by sudden, even violent, divine action. Given that its only occurrence in an eschatological context is here, its content should be filled primarily with the images that this passage supplies.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These images follow in v. 17, where both the dead and the living are caught up by/in the clouds. Clouds are an element in numerous OT theophany texts (e.g., Exod 13:21; 19:9; Num 12:5; 14:14; Neh 9:12; Pss 97:1–2; 99:7), and there is no doubt that Paul is depicting this coming of the Lord of the cosmos as a theophany (note that the imagery has numerous parallels to Exod 19:7–25). As was the case with Jesus (Acts 1:9–11), clouds here are the means, or at least the mode, of his followers’ ascension, albeit not into heaven like Jesus, but into the meeting in the "), _c('a', {
    attrs: {
      "id": "page_131"
    }
  }, [_vm._v("air as they are caught up into the Lord’s parousia. The basic pattern of Christ’s story continues to be that of those who are “in Christ”: faithfulness to Israel’s God in life and death, followed by a vindicating resurrection and ascension. The underlying thought here is analogous to that of Dan 7, in which the “son of man” represents the holy ones of Israel, and his destiny prefigures theirs. In Dan 7 the “son of man” appears to descend on clouds from heaven to earth "), _c('i', [_vm._v("coming to")]), _vm._v(" the Ancient of Days, who has convened court for the judgment of the nations in order that the son of man might be enthroned where “peoples, nations, and languages” would “serve him” (7:14). Jesus draws on this very language to describe his eschatological actions as “son of man” (e.g., Mark 14:62 and par.). Daniel’s “holy ones” are depicted as being on earth, with an arrogant empire “prevailing over them” until the Ancient One "), _c('i', [_vm._v("comes to")]), _vm._v(" them, vindicating them by giving judgment on their behalf and granting them the kingdom (Dan 7:21–22). In other words, in Dan 7 divine deliverance and vindication for God’s holy ones are depicted as coming "), _c('i', [_vm._v("from heaven to earth")]), _vm._v(" (cf. Phil 3:20–21), where they are granted a share in the divine kingdom (cf. 1 Thess 2:12). They are not taken into heaven.")])]), _c('a', {
    attrs: {
      "id": "page_131"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_131"
    }
  }, [_vm._v("When the dead and the living are caught up by or in the clouds, it is “into a meeting with the Lord ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εἰς ἀπάντησιν τοῦ κυρίου")]), _vm._v(", "), _c('i', [_vm._v("eis apantēsin tou kyriou")]), _vm._v("] in the air.”")]), _c('a', {
    attrs: {
      "id": "fn406"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn406",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("406")])]), _vm._v(" The word "), _c('i', [_vm._v("apantēsis")]), _vm._v(" can refer simply to a generic meeting, as it is often used in the LXX and in Greco-Roman culture. Hence, it is not a technical term that, by itself, refers to a particular kind of meeting."), _c('a', {
    attrs: {
      "id": "fn407"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn407",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("407")])]), _vm._v(" Along with several synonyms, however, it can be used when referring to the custom of meeting a Hellenistic dignitary (including an emperor) who was coming to visit a Greco-Roman city,"), _c('a', {
    attrs: {
      "id": "fn408"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn408",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("408")])]), _vm._v(" or perhaps when a new ruler or victorious commander was coming into a city in triumph."), _c('a', {
    attrs: {
      "id": "fn409"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn409",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("409")])]), _vm._v(" When used in conjunction with "), _c('a', {
    attrs: {
      "id": "page_132"
    }
  }, [_vm._v("a parousia involving the Lord ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("κύριος")]), _vm._v(", "), _c('i', [_vm._v("kyrios")]), _vm._v(") of the cosmos, who is being welcomed amid “happy noise,”")]), _c('a', {
    attrs: {
      "id": "fn410"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn410",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("410")])]), _vm._v(" "), _c('i', [_vm._v("apantēsis")]), _vm._v(" would evoke loosely the cultural expectations associated with formal receptions of a king coming to claim his kingdom in triumph. In this sort of meeting a delegation often comprising those with the most status or honor—those whose relative status was closer to that of the dignitary—would go outside of the city along the road on which the dignitary would be arriving, greet and welcome him there, and then escort him back into the city (cf. Acts 28:15)."), _c('a', {
    attrs: {
      "id": "fn411"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn411",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("411")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Being a part of that delegation involved giving honor ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("δόξα")]), _vm._v(", "), _c('i', [_vm._v("doxa")]), _vm._v(") to the visiting dignitary and, at least at times, having an opportunity to display one’s own relative status as the delegation escorted him back into the city, thereby accruing public honor for oneself as well (see the quote from Chrysostom above). To be in such a select delegation that goes out to meet and honor a "), _c('i', [_vm._v("cruciform Lord,")]), _vm._v(" one might be expected to share an analogous cruciform character (i.e., “blameless in holiness,” 3:13) marked by suffering faithfulness if one was also going to share in his public "), _c('i', [_vm._v("doxa")]), _vm._v(" in the march back into the city. Hence, the basis for sharing in the honor of this parade is different from that which typically brings status and honor; it is sharing in the cruciform character of the coming Lord. One might say, then, that the images the text evokes here provide a visual display of Paul’s words elsewhere: “We are coheirs with Christ,"), _c('a', {
    attrs: {
      "id": "fn412"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn412",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("412")])]), _vm._v(" if indeed we are suffering with him so that we might be cohonored/coglorified with ["), _c('span', {
    staticClass: "grk"
  }, [_vm._v("συνδοξασθῶμεν")]), _vm._v(", "), _c('i', [_vm._v("syndoxasthōmen")]), _vm._v("] him” (Rom 8:17b). It indeed depicts Christ’s followers sharing in his “kingdom and honor,” to which God is calling this audience (1 Thess 2:12; 2 Thess 1:12).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("About the aftermath of this meeting, Paul explicitly says only that “we will always be with the Lord.” He does not say that we will always be with the Lord in the air or always with the Lord in heaven."), _c('a', {
    attrs: {
      "id": "fn413"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn413",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("413")])]), _vm._v(" All the preceding political connotations "), _c('a', {
    attrs: {
      "id": "page_133"
    }
  }, [_vm._v("of the text, along with the use of "), _c('i', [_vm._v("apantēsis")]), _vm._v(" in this verse, point toward affirming that this community who goes to honor the Lord by meeting him in the air shares that honor as they escort him back to earth, where he publicly consummates his reign as Lord of the cosmos.")]), _c('a', {
    attrs: {
      "id": "fn414"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn414",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("414")])]), _vm._v(" Indeed, this is precisely what God has called all the suffering faithful (living and dead) into, his own kingdom and honor/glory (1 Thess 2:12; 2 Thess 1:12). God, then, will raise the dead (who had suffered) through the actions of Jesus at the parousia, and they, like the suffering living, will experience public vindication when they share in the honor ("), _c('i', [_vm._v("doxa")]), _vm._v(") accruing to those who form the delegation to meet the true Lord of the cosmos as he comes to publicly consummate his reign.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It should be noted that this is not some sort of interim rule with some connection to a millennium,"), _c('a', {
    attrs: {
      "id": "fn415"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn415",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("415")])]), _vm._v(" a concept that is neither warranted from Paul’s letters nor theologically relevant here."), _c('a', {
    attrs: {
      "id": "fn416"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn416",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("416")])]), _vm._v(" Rather, the orientation and direction of Paul’s eschatological images move toward imagining the parousia as the time when the cosmos itself is redeemed and God becomes “all in all.” This cosmic redemption is more than the creation being “restored to its paradisal state”;"), _c('a', {
    attrs: {
      "id": "fn417"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn417",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("417")])]), _vm._v(" it is “the unrealized promise of the first creation finally achieved,”"), _c('a', {
    attrs: {
      "id": "fn418"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn418",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("418")])]), _vm._v(" when God brings humanity and the rest of creation to its intended destiny.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paul concludes in v. 18 with what is essentially the antidote to the current (or possible) grief in the community, namely, the admonition to comfort or exhort one another with the words of this section. Given that those who died will be raised in time to participate together with those in the community who are still living, there is no reason for grieving over the uncertainty of their sharing the royal parade of vindication with the living.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Hearing these words after two thousand years could certainly generate skepticism, either because the idea of participating in such a victory parade seems so foreign to our thinking, or simply because of the amount of time that has passed without any such parade having happened. Yet, given a nonsectarian ecclesiology, as Robert Jenson calls it,"), _c('a', {
    attrs: {
      "id": "fn419"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001a#rfn419",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("419")])]), _vm._v(" and with the Spirit’s enabling, the words might rather become a rich source of grace for us as well. That is, the words still work to assure us that we will indeed become the one, holy, catholic "), _c('a', {
    attrs: {
      "id": "page_134"
    }
  }, [_vm._v("church, but only when we are all together in the parousia. That is, we will not be finally vindicated/justified or made completely holy apart from those whose embodying of the faithfulness of Christ ("), _c('i', [_vm._v("pistis Christou")]), _vm._v(") has shaped our very imaginations, bodies, and communities. There is an ecclesiology at work here that moves along the lines of the view in Hebrews that even the holy ones who have died will not be made perfect without us (11:39–40). In other words, it takes "), _c('i', [_vm._v("all")]), _vm._v(" of the one, catholic "), _c('i', [_vm._v("ekklēsia")]), _vm._v(" stretching through time and into eternity to finally be the one, "), _c('i', [_vm._v("holy,")]), _vm._v(" catholic "), _c('i', [_vm._v("ekklēsia.")]), _vm._v(" With them we will be raised (or, if living, transformed) and then be “blameless in holiness” together. Our lives and bodies are too interconnected with each other and with the crucified and risen Christ for it to be any other way!")])]), _c('a', {
    attrs: {
      "id": "page_134"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-335648f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter001.vue
// module id = 84
// module chunks = 0